<template>
  <div @click="goToTradeWatcherPage" class="home-button">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="home-button__icon">
          <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              height="256px"
              viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve"
          >
            <g>
	<g>
		<g>
			<g>
				<defs>
					<path id="SVGID_1_" d="M-326.5,679.5v-0.4v-0.4c0-0.4,0-0.4,0-0.8v-4.6c0,0.4,0,0.4,0,0.8v0.4l-0.4,0.4l0,0
						c0,0.4-0.4,0.4-0.4,0.8l0,0c-0.4,0.4-0.4,0.4-0.8,0.8v4.6l0,0h0.4h0.4l0.4-0.4l0,0l0,0h0.4L-326.5,679.5L-326.5,679.5
						L-326.5,679.5L-326.5,679.5"/>
				</defs>
        <clipPath id="SVGID_00000103243237094772985630000000078496561450887320_">
					<use xlink:href="#SVGID_1_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000103243237094772985630000000078496561450887320_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000120535445869525337140000015106365372132037784_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000144323568381176673110000002193343926458342326_">
								<use xlink:href="#SVGID_00000120535445869525337140000015106365372132037784_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000026124838547151360150000006302762616394330249_" d="M-326.5,671.6c-0.4-0.4-0.4-0.4-0.8-0.8
						c1.2,1.2,0.4,3.3-1.2,4.6l0.4,1.2C-326.1,675-325.2,673.3-326.5,671.6"/>
				</defs>
        <clipPath id="SVGID_00000141424759004264474240000012797019735026094248_">
					<use xlink:href="#SVGID_00000026124838547151360150000006302762616394330249_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000141424759004264474240000012797019735026094248_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000021108239961587166910000001499057264255251635_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000091695516350928443310000011777034389660548240_">
								<use xlink:href="#SVGID_00000021108239961587166910000001499057264255251635_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000049916334146197161320000003236025658554016400_" d="M-326.5,671.6c-0.4-0.4-0.4-0.4-0.8-0.8
						c1.2,1.2,0.4,3.3-1.2,4.6l0.4,1.2C-326.1,675-325.2,673.3-326.5,671.6"/>
				</defs>
        <clipPath id="SVGID_00000008829848812013485440000016140268235345073599_">
					<use xlink:href="#SVGID_00000049916334146197161320000003236025658554016400_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000008829848812013485440000016140268235345073599_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000034769293630044841210000007027904949929579684_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000132779512693080557150000001055834861474321581_">
								<use xlink:href="#SVGID_00000034769293630044841210000007027904949929579684_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000116914453500424242880000015440775371963711389_" d="M-537.9,722.6c0.4,0.4,0.4,0.4,0.8,0.8
						s0.8,0.8,1.7,1.2l-0.4-0.8C-537.1,723.5-537.5,723-537.9,722.6"/>
				</defs>
        <clipPath id="SVGID_00000033357368901700228330000007693904625290952855_">
					<use xlink:href="#SVGID_00000116914453500424242880000015440775371963711389_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000033357368901700228330000007693904625290952855_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000134240265365549730430000003025350295420570798_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000060742185510079742760000001260823701798299558_">
								<use xlink:href="#SVGID_00000134240265365549730430000003025350295420570798_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000130634828523725418980000016771158477267486612_" d="M-536.3,719.3c-0.4-0.4-0.8-0.4-0.8-0.8l0,0
						c-0.4-0.4-0.4-0.4-0.8-0.8l0,0c0-0.4-0.4-0.4-0.4-0.8l0,0c0-0.4,0-0.4,0-0.8v4.6v0.4v0.4l0,0l0,0v0.4v0.4l0,0l0,0l0,0v0.4
						l0.4,0.4l0,0l0,0l0,0h0.4h0.4h0.4l0,0L-536.3,719.3"/>
				</defs>
        <clipPath id="SVGID_00000091001546191943562860000000019096879627547276_">
					<use xlink:href="#SVGID_00000130634828523725418980000016771158477267486612_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000091001546191943562860000000019096879627547276_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000000205646491314803800000015688411002170528929_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000044160721369057597690000015168308572408869557_">
								<use xlink:href="#SVGID_00000000205646491314803800000015688411002170528929_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000049194636939102785950000010802592903522056111_" d="M-537.5,713.5L-537.5,713.5L-537.5,713.5
						L-537.5,713.5L-537.5,713.5L-537.5,713.5L-537.5,713.5l-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0c-1.2,1.7-0.4,3.7,1.7,5l0.4-1.2
						C-537.9,716.8-538.3,714.8-537.5,713.5"/>
				</defs>
        <clipPath id="SVGID_00000173883591469645076400000010297791370494856592_">
					<use xlink:href="#SVGID_00000049194636939102785950000010802592903522056111_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000173883591469645076400000010297791370494856592_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000105415176368488899560000014081829504344214185_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000041989972002348203990000015216092391488884869_">
								<use xlink:href="#SVGID_00000105415176368488899560000014081829504344214185_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000063595620387657987460000001386603357925286570_" d="M-537.5,713.5L-537.5,713.5L-537.5,713.5
						L-537.5,713.5L-537.5,713.5L-537.5,713.5L-537.5,713.5l-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0c-1.2,1.7-0.4,3.7,1.7,5l0.4-1.2
						C-537.9,716.8-538.3,714.8-537.5,713.5"/>
				</defs>
        <clipPath id="SVGID_00000108277347530831189250000015700225004431451833_">
					<use xlink:href="#SVGID_00000063595620387657987460000001386603357925286570_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000108277347530831189250000015700225004431451833_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000177484148576135317980000003071610967938311871_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000162353223023462957180000015106998323214571436_">
								<use xlink:href="#SVGID_00000177484148576135317980000003071610967938311871_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000156559218202400533350000008667505169029494199_" d="M-327.7,680.8L-327.7,680.8l-133.1,79.2
						c-0.4,0.4-0.8,0.4-1.2,0.4l0,0c-0.4,0-0.8,0.4-1.2,0.4h-0.4c-0.4,0-0.8,0-1.2,0.4l0,0l0,0c-0.8,0-1.2,0-2.1,0h-0.4
						c-0.8,0-1.2,0-2.1-0.4c-0.4,0-0.8,0-1.2-0.4l0,0c-0.4,0-0.8-0.4-1.2-0.4l-64.7-36.5l0.4,0.8l64.7,36.5l0.4,0.4
						c0,0,0.4,0,0.4,0.4l0,0l0,0c0.4,0,0.4,0,0.8,0.4l0,0c0.4,0,1.2,0.4,1.7,0.4h0.4c0.4,0,1.2,0,1.7,0l0,0l0,0l0,0
						c0.4,0,0.4,0,0.8,0l0,0h0.4h0.4c0.4,0,0.4,0,0.8-0.4l0,0l0,0c0.4,0,0.4,0,0.8-0.4l0.4-0.4l132.7-79.2c0.4-0.4,1.2-0.8,1.7-1.2
						l0.8-0.8C-326.9,680.3-327.3,680.8-327.7,680.8"/>
				</defs>
        <clipPath id="SVGID_00000054226698843112363580000000074028485619911827_">
					<use xlink:href="#SVGID_00000156559218202400533350000008667505169029494199_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000054226698843112363580000000074028485619911827_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000176761140746286844130000011301662478863572910_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000071538225421109844620000006832681905462652565_">
								<use xlink:href="#SVGID_00000176761140746286844130000011301662478863572910_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000089568293434791896280000004867832390783443367_" points="-460.8,755.4 -460.8,760.4 -328.1,681.2
						-328.1,676.6 -460.8,755.4 					"/>
				</defs>
        <clipPath id="SVGID_00000111177488909597587760000014617388669819225742_">
					<use xlink:href="#SVGID_00000089568293434791896280000004867832390783443367_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000111177488909597587760000014617388669819225742_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000120535504765720983530000002802545850211707795_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000082340397532017189100000002958462370066806190_">
								<use xlink:href="#SVGID_00000120535504765720983530000002802545850211707795_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000000936113049341072760000011868305104625355424_" points="-536.3,719.3 -536.3,723.9 -471.6,760.4
						-471.6,755.8 -536.3,719.3 					"/>
				</defs>
        <clipPath id="SVGID_00000178895429981365379090000004137906184855768510_">
					<use xlink:href="#SVGID_00000000936113049341072760000011868305104625355424_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000178895429981365379090000004137906184855768510_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000066491860795436262450000003540716217405068467_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000072280416709277287010000000857601762372539033_">
								<use xlink:href="#SVGID_00000066491860795436262450000003540716217405068467_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000096776257692632019150000018258539939226149543_" points="-461.6,754.1 -460.8,755.4 -328.1,676.6
						-328.6,675 -461.6,754.1 					"/>
				</defs>
        <clipPath id="SVGID_00000052080047608316535420000009962858792826804642_">
					<use xlink:href="#SVGID_00000096776257692632019150000018258539939226149543_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000052080047608316535420000009962858792826804642_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000070106428610138213720000002330750658312295822_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000045600042194576417630000004713832741170781071_">
								<use xlink:href="#SVGID_00000070106428610138213720000002330750658312295822_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000135677663733337407100000004221457747267598474_" points="-535.8,717.7 -536.3,719.3 -471.6,755.8
						-471.2,754.1 -535.8,717.7 					"/>
				</defs>
        <clipPath id="SVGID_00000133520872443938107010000001448265289060765330_">
					<use xlink:href="#SVGID_00000135677663733337407100000004221457747267598474_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000133520872443938107010000001448265289060765330_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000035516935944620076530000011735195210529921204_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000103253269910589104440000000785927205371876267_">
								<use xlink:href="#SVGID_00000035516935944620076530000011735195210529921204_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000169536678539406012480000005808174295947374755_" d="M-471.2,754.1c2.9,1.7,7,1.7,9.9,0l132.7-79.2
						c2.5-1.7,2.5-4.1,0-5.8l-64.7-36.5c-2.9-1.7-7-1.7-9.9,0l-132.7,79.2c-2.5,1.7-2.5,4.1,0,5.8L-471.2,754.1"/>
				</defs>
        <clipPath id="SVGID_00000045590961068485991610000017822880559876852656_">
					<use xlink:href="#SVGID_00000169536678539406012480000005808174295947374755_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000045590961068485991610000017822880559876852656_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000048461198738148837360000009418959513423943068_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000172438032631727491720000017757468597355233669_">
								<use xlink:href="#SVGID_00000048461198738148837360000009418959513423943068_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000049186463125865816750000006387553024275557796_" d="M-461.6,754.1c-0.4,0-0.8,0.4-1.2,0.4l0,0
						c-0.4,0-0.8,0.4-1.2,0.4l0,0c-0.4,0-0.8,0-1.2,0.4l0,0c-0.4,0-0.8,0-1.2,0l0,0c-0.4,0-0.8,0-1.2,0l0,0c-0.4,0-0.8,0-1.2,0l0,0
						c-0.4,0-0.8-0.4-1.2-0.4l0,0c-0.4,0-0.8-0.4-1.2-0.4v1.2l0,0h0.4h0.4h0.4h0.4l0,0l0,0l0,0l0,0l0,0h0.4l0,0l0,0l0,0l0,0l0,0l0,0
						l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.4h0.4h0.4h0.4l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0
						l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.4h0.4h0.4h0.4h0.4h0.4h0.4
						l0,0L-461.6,754.1"/>
				</defs>
        <clipPath id="SVGID_00000046323326302905262150000010207373564568814512_">
					<use xlink:href="#SVGID_00000049186463125865816750000006387553024275557796_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000046323326302905262150000010207373564568814512_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000152973580673944764530000000998803046902705321_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000031196141101875928550000006363199848181855633_">
								<use xlink:href="#SVGID_00000152973580673944764530000000998803046902705321_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000127763644234479070770000014197152300099920266_" d="M-358.8,658.8c-0.4-0.4-0.4-0.4,0-0.8
						c0.4-0.4,1.2-0.4,1.7,0c0.4,0.4,0.4,0.4,0,0.8C-357.6,659.2-358.4,659.2-358.8,658.8 M-356.7,658c-0.4-0.4-1.7-0.4-2.1,0
						c-0.4,0.4-0.4,0.8,0,1.2c0.4,0.4,1.7,0.4,2.1,0C-356.3,658.8-356.3,658-356.7,658"/>
				</defs>
        <clipPath id="SVGID_00000060020765508940776240000015836958981069423240_">
					<use xlink:href="#SVGID_00000127763644234479070770000014197152300099920266_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000060020765508940776240000015836958981069423240_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000009559639091402118860000007880200460207409300_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000045587617478269824800000007477565249723902104_">
								<use xlink:href="#SVGID_00000009559639091402118860000007880200460207409300_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000152960304176975117420000007043816306073703605_" d="M-357.2,658c0.4,0.4,0.4,0.4,0,0.8s-1.2,0.4-1.7,0
						c-0.4-0.4-0.4-0.4,0-0.8C-358.4,658-357.6,657.5-357.2,658"/>
				</defs>
        <clipPath id="SVGID_00000162324854034630609910000002361183641451429254_">
					<use xlink:href="#SVGID_00000152960304176975117420000007043816306073703605_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000162324854034630609910000002361183641451429254_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000091703056249161608200000011057542988533647273_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000173870913553327433600000014887393225474861726_">
								<use xlink:href="#SVGID_00000091703056249161608200000011057542988533647273_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000157275485435872056390000007992746812947091850_" d="M-361.7,657.1c-0.4-0.4-0.4-0.4,0-0.8
						c0.4-0.4,1.2-0.4,1.7,0c0.4,0.4,0.4,0.4,0,0.8C-360.5,657.5-361.3,657.5-361.7,657.1 M-360.1,656.3c-0.4-0.4-1.7-0.4-2.1,0
						c-0.4,0.4-0.4,0.8,0,1.2c0.4,0.4,1.7,0.4,2.1,0C-359.2,657.1-359.2,656.3-360.1,656.3"/>
				</defs>
        <clipPath id="SVGID_00000118379827572126040310000007816629514205423279_">
					<use xlink:href="#SVGID_00000157275485435872056390000007992746812947091850_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000118379827572126040310000007816629514205423279_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000169520623120622979430000013481889908272850068_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000173867990129880470600000008788149510999123610_">
								<use xlink:href="#SVGID_00000169520623120622979430000013481889908272850068_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000147915149748190117980000004583357104423408063_" d="M-360.1,656.3c0.4,0.4,0.4,0.4,0,0.8s-1.2,0.4-1.7,0
						c-0.4-0.4-0.4-0.4,0-0.8C-361.3,656.3-360.5,655.9-360.1,656.3"/>
				</defs>
        <clipPath id="SVGID_00000152973092248287903170000014172754914186122159_">
					<use xlink:href="#SVGID_00000147915149748190117980000004583357104423408063_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000152973092248287903170000014172754914186122159_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000168092739829321663100000004083862291143212425_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000017483709381060839640000012233315022328393913_">
								<use xlink:href="#SVGID_00000168092739829321663100000004083862291143212425_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000019677228396185992340000003076776397552057478_" d="M-365.5,655.1l-8.3-4.6c-0.4,0-0.4-0.4,0-0.4l0.4-0.4
						c0.4,0,0.8,0,0.8,0l8.3,4.6c0.4,0,0.4,0.4,0,0.4l-0.4,0.4C-365,655.1-365.5,655.1-365.5,655.1 M-372.5,649.3
						c-0.4,0-0.8,0-0.8,0l-1.2,0.8c-0.4,0-0.4,0.4,0,0.4l9.1,5c0.4,0,0.8,0,0.8,0l1.2-0.8c0.4,0,0.4-0.4,0-0.4L-372.5,649.3"/>
				</defs>
        <clipPath id="SVGID_00000066504796098467237570000008086768059275813782_">
					<use xlink:href="#SVGID_00000019677228396185992340000003076776397552057478_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000066504796098467237570000008086768059275813782_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000025437972277699053470000004939955987285909921_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000059304736623483670890000001037682098645400734_">
								<use xlink:href="#SVGID_00000025437972277699053470000004939955987285909921_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000018202894523353376990000016283615191130544283_" d="M-372.5,649.3l8.3,4.6c0.4,0,0.4,0.4,0,0.4l-0.4,0.4
						c-0.4,0-0.8,0-0.8,0l-8.3-4.6c-0.4,0-0.4-0.4,0-0.4l0.4-0.4C-372.9,649.3-372.5,649.3-372.5,649.3"/>
				</defs>
        <clipPath id="SVGID_00000096050343321571460790000003469519900148917686_">
					<use xlink:href="#SVGID_00000018202894523353376990000016283615191130544283_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000096050343321571460790000003469519900148917686_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000122715253569904091600000010991786392185076654_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000156579545155747202960000005856215650082184090_">
								<use xlink:href="#SVGID_00000122715253569904091600000010991786392185076654_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000075844100506578798270000013029012023523223714_" points="-346.8,688.6 -375,705.6 -375,708.1
						-346.8,691.5 -346.8,688.6 					"/>
				</defs>
        <clipPath id="SVGID_00000138573105786047041170000007670768657523193764_">
					<use xlink:href="#SVGID_00000075844100506578798270000013029012023523223714_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000138573105786047041170000007670768657523193764_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000069365812244738050190000009026858379926747311_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000037670675264504352290000001468494689195617959_">
								<use xlink:href="#SVGID_00000069365812244738050190000009026858379926747311_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000167393104349180048060000012414264917854098081_" points="-489,746.3 -489,750.4 -485.7,752.5
						-485.7,748.3 -489,746.3 					"/>
				</defs>
        <clipPath id="SVGID_00000103960385635584419110000015170541577720525220_">
					<use xlink:href="#SVGID_00000167393104349180048060000012414264917854098081_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000103960385635584419110000015170541577720525220_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000093160526098724973120000002869753622383037093_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000075121681690039982240000004288407457818044805_">
								<use xlink:href="#SVGID_00000093160526098724973120000002869753622383037093_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000124884236914272169220000017574532948771187585_" d="M-612.5,566.3V614c0,10.4,5.8,20.3,14.5,25.7l29,16.6
						l85-49.3l-29-15.8c-9.1-5.4-14.9-14.9-14.9-25.7v-47.7L-612.5,566.3"/>
				</defs>
        <clipPath id="SVGID_00000138573082490170460790000010522290595888732338_">
					<use xlink:href="#SVGID_00000124884236914272169220000017574532948771187585_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000138573082490170460790000010522290595888732338_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000074432515784600146120000010673142521156429237_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000143615760623008180580000003933630206326311098_">
								<use xlink:href="#SVGID_00000074432515784600146120000010673142521156429237_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000060007181990385470590000010150512676401770416_" points="-483.6,596.2 -483.6,606.6 -568.6,655.9
						-568.6,645.5 -483.6,596.2 					"/>
				</defs>
        <clipPath id="SVGID_00000172404241398680400610000013622476194614786950_">
					<use xlink:href="#SVGID_00000060007181990385470590000010150512676401770416_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000172404241398680400610000013622476194614786950_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000151522779143733556890000013234187323207036805_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000103979075558195984190000003431464494464414610_">
								<use xlink:href="#SVGID_00000151522779143733556890000013234187323207036805_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000075844204780837153190000005119583808527865486_" points="-814.8,689.1 -814.8,689.1 -814.8,689.1
						-814.8,689.1 					"/>
				</defs>
        <clipPath id="SVGID_00000011739713761575327550000008671075968322790807_">
					<use xlink:href="#SVGID_00000075844204780837153190000005119583808527865486_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000011739713761575327550000008671075968322790807_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000124142829850585196640000001818150320616938140_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000003798332463416121360000000353548203743641004_">
								<use xlink:href="#SVGID_00000124142829850585196640000001818150320616938140_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000035490614321093805720000004693980612487540393_" points="-814.8,689.1 -815.2,688.6 -814.8,689.1
											"/>
				</defs>
        <clipPath id="SVGID_00000181067296621075316500000008718817714782147973_">
					<use xlink:href="#SVGID_00000035490614321093805720000004693980612487540393_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000181067296621075316500000008718817714782147973_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000156554714488764598990000013901259989829206928_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000113346034585893782720000008754982314417042101_">
								<use xlink:href="#SVGID_00000156554714488764598990000013901259989829206928_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000107570406152035246090000002080439698598351265_" d="M-368.4,67.2l1.7,0.8
						C-367.1,67.6-367.9,67.6-368.4,67.2"/>
				</defs>
        <clipPath id="SVGID_00000073000209026374437430000001734407630649756814_">
					<use xlink:href="#SVGID_00000107570406152035246090000002080439698598351265_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000073000209026374437430000001734407630649756814_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000013872440270848089770000000275902351715004801_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000176731428753726787130000000980428190220774047_">
								<use xlink:href="#SVGID_00000013872440270848089770000000275902351715004801_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000090990440689258544620000016718358336084059808_" d="M-378.7,61c-1.7-1.2-2.9-2.1-5-2.9
						c-2.9-1.2-6.2-1.7-9.5-1.2c-1.7,0-3.3,0.4-4.6,1.2l0,0c-0.8,0.4-1.7,0.8-2.5,1.2l-14.9,8.3l0,0l-395.9,224.3l13.7,7.9
						l410.8-232.2c5.8-3.3,12.9-3.3,18.2-0.4L-378.7,61"/>
				</defs>
        <clipPath id="SVGID_00000137089758586371079230000008078571572634465679_">
					<use xlink:href="#SVGID_00000090990440689258544620000016718358336084059808_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000137089758586371079230000008078571572634465679_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000073712498855266794150000000656875404991467955_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000051365281773384461710000010328589086937823371_">
								<use xlink:href="#SVGID_00000073712498855266794150000000656875404991467955_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000142899098147578671350000013468187092678464938_" d="M-804.9,303.9c-12.9,7.5-20.7,21.1-20.7,35.7
						l0.8,299.7L-358,374.4l0.4-290.2c0-7-3.7-12.9-9.1-16.2l0,0l-1.7-0.8c-5.4-2.9-12-2.9-18.2,0.4l-410.8,232.2L-804.9,303.9"/>
				</defs>
        <clipPath id="SVGID_00000052816315441248741470000002084756623401177273_">
					<use xlink:href="#SVGID_00000142899098147578671350000013468187092678464938_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000052816315441248741470000002084756623401177273_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000052803362525148938680000003991280729922364310_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000181068842675417419110000010124197099894715049_">
								<use xlink:href="#SVGID_00000052803362525148938680000003991280729922364310_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000010283856043211891140000011902885626299746737_" d="M-824.8,639.3v32.8c0,7.5,3.7,13.3,9.5,16.6l0.4,0.4
						l0,0c5.4,2.9,12.4,3.3,19.1,0l428.2-242.9c5.8-3.3,9.5-9.9,9.5-16.6v-54.7L-824.8,639.3"/>
				</defs>
        <clipPath id="SVGID_00000086666002694737947350000015675052354397599109_">
					<use xlink:href="#SVGID_00000010283856043211891140000011902885626299746737_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000086666002694737947350000015675052354397599109_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000178906954921282941430000011343699461169079469_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000069394533010022625840000003423082851507007630_">
								<use xlink:href="#SVGID_00000178906954921282941430000011343699461169079469_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000158738446156597928040000017023906807988339841_" d="M-824.8,672.5v-32.8h-0.4l-13.3-7.9v32.3
						c0,6.6,3.3,12.4,8.3,15.8c0.8,0.4,1.7,1.2,2.5,1.7l12.4,7C-820.6,685.3-824.8,679.5-824.8,672.5"/>
				</defs>
        <clipPath id="SVGID_00000138550118127771838000000004717881593860021693_">
					<use xlink:href="#SVGID_00000158738446156597928040000017023906807988339841_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000138550118127771838000000004717881593860021693_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000157291652475774546660000006238719190717006259_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000157269547714555026980000010424284540473015211_">
								<use xlink:href="#SVGID_00000157291652475774546660000006238719190717006259_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000048494448431773555680000013109735046701663114_" d="M-824.8,639.3l-0.8-299.7c0-14.9,7.9-28.6,20.7-35.7
						l7-4.1l-13.7-7.9l-7.5,4.1c-12.9,7.5-20.7,21.1-20.7,35.7l0.8,300.1L-824.8,639.3L-824.8,639.3"/>
				</defs>
        <clipPath id="SVGID_00000072966473731679515000000000637928130753549219_">
					<use xlink:href="#SVGID_00000048494448431773555680000013109735046701663114_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000072966473731679515000000000637928130753549219_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000040543253040430783060000013078910993617216166_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000143587417641006956380000012453435518213670301_">
								<use xlink:href="#SVGID_00000040543253040430783060000013078910993617216166_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000134940275001522449430000008526740968032277398_" points="-797.4,299.8 -797.4,299.8 -804.9,303.9
						-797.4,299.8 					"/>
				</defs>
        <clipPath id="SVGID_00000019661824639006377130000001573427232291063482_">
					<use xlink:href="#SVGID_00000134940275001522449430000008526740968032277398_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000019661824639006377130000001573427232291063482_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000144332321081722701350000005770121222488479138_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000116925151785991409220000018131639519359849364_">
								<use xlink:href="#SVGID_00000144332321081722701350000005770121222488479138_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000158734120764392718260000016199260998927299976_" d="M-457.1,655.9c6.6-2.9,15.3-4.6,24.9-4.6
						c7.9,0,15.3,1.2,21.6,3.3l-21.6,15.3L-457.1,655.9"/>
				</defs>
        <clipPath id="SVGID_00000054950391080479861490000000969895794195365006_">
					<use xlink:href="#SVGID_00000158734120764392718260000016199260998927299976_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000054950391080479861490000000969895794195365006_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000057109137683346031660000005871681640974443924_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000114045117872745818860000017954665220308249988_">
								<use xlink:href="#SVGID_00000057109137683346031660000005871681640974443924_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000108275887622949960730000017802838423099402169_" points="-410.6,654.6 -410.6,670 -432.2,685.3
						-432.2,670 -410.6,654.6 					"/>
				</defs>
        <clipPath id="SVGID_00000182499572921731156780000008213829909884339840_">
					<use xlink:href="#SVGID_00000108275887622949960730000017802838423099402169_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000182499572921731156780000008213829909884339840_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000051342931205105787390000008454505968316869777_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000155145157664374151470000002539227507251839902_">
								<use xlink:href="#SVGID_00000051342931205105787390000008454505968316869777_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000056420703174888870980000010800559861267747732_" points="-457.1,655.9 -457.1,671.2 -432.2,685.3
						-432.2,670 -457.1,655.9 					"/>
				</defs>
        <clipPath id="SVGID_00000023242609166861076690000009014516866639268240_">
					<use xlink:href="#SVGID_00000056420703174888870980000010800559861267747732_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000023242609166861076690000009014516866639268240_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000058572488457829750840000005639609503707272067_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000131364156938974352060000015500962088685093813_">
								<use xlink:href="#SVGID_00000058572488457829750840000005639609503707272067_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000088093411529727299950000005549549280959151499_" points="-394.9,676.2 -394.9,681.6 -432.2,685.3
						-432.2,680.3 -394.9,676.2 					"/>
				</defs>
        <clipPath id="SVGID_00000168102147767085671590000007736491288135926944_">
					<use xlink:href="#SVGID_00000088093411529727299950000005549549280959151499_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000168102147767085671590000007736491288135926944_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000090289818521926798350000000729332016942501562_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000155863862003458916680000016491166970676490883_">
								<use xlink:href="#SVGID_00000090289818521926798350000000729332016942501562_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000060017308117587810030000004992129055449840536_" points="-512.2,404.7 -528,413 -542.9,407.6
						-542.9,334.2 -527.1,327.6 -512.2,330.9 -512.2,404.7 					"/>
				</defs>
        <clipPath id="SVGID_00000089571222257269374520000011230092217629125007_">
					<use xlink:href="#SVGID_00000060017308117587810030000004992129055449840536_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000089571222257269374520000011230092217629125007_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000024696464455936990670000017493673228265498283_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000098191722404576759420000015483437661768884896_">
								<use xlink:href="#SVGID_00000024696464455936990670000017493673228265498283_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000091004829577534921610000012147498306207848107_" points="-528,413 -528,339.2 -542.9,334.2
						-542.9,407.6 -528,413 					"/>
				</defs>
        <clipPath id="SVGID_00000026143099744175866790000017693326123837554056_">
					<use xlink:href="#SVGID_00000091004829577534921610000012147498306207848107_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000026143099744175866790000017693326123837554056_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000122684695360280270470000003446590962332613260_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000177473516319406145760000000568841370403970234_">
								<use xlink:href="#SVGID_00000122684695360280270470000003446590962332613260_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000119816347850366279750000015913190817260146832_" points="-512.2,330.9 -528,339.2 -542.9,334.2
						-527.1,325.5 -512.2,330.9 					"/>
				</defs>
        <clipPath id="SVGID_00000163751464367445450790000001587781033455072173_">
					<use xlink:href="#SVGID_00000119816347850366279750000015913190817260146832_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000163751464367445450790000001587781033455072173_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000181783806649442856320000005151302110857969283_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000181075901621649839770000015420218242990661272_">
								<use xlink:href="#SVGID_00000181783806649442856320000005151302110857969283_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000124162241654127829410000004580377435025107858_" points="-538.7,419.2 -554.5,427.5 -569.4,422.5
						-569.4,325.5 -553.7,318.4 -538.7,322.2 -538.7,419.2 					"/>
				</defs>
        <clipPath id="SVGID_00000100357721392611840630000009192738223953679489_">
					<use xlink:href="#SVGID_00000124162241654127829410000004580377435025107858_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000100357721392611840630000009192738223953679489_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000163050820443488540080000000314409581806272928_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000080918390019762528900000014887357378462223551_">
								<use xlink:href="#SVGID_00000163050820443488540080000000314409581806272928_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000157994429932258359330000010972533602226576541_" points="-554.5,427.5 -554.5,330.5 -569.4,325.5
						-569.4,422.5 -554.5,427.5 					"/>
				</defs>
        <clipPath id="SVGID_00000099657850208758081890000005125545443506933688_">
					<use xlink:href="#SVGID_00000157994429932258359330000010972533602226576541_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000099657850208758081890000005125545443506933688_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000054260432541154340900000013626084701674183562_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000024717437521724293720000008536456985164267160_">
								<use xlink:href="#SVGID_00000054260432541154340900000013626084701674183562_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000170252926793891548900000008236630548015784598_" points="-538.7,322.2 -554.5,330.5 -569.4,325.5
						-553.7,316.8 -538.7,322.2 					"/>
				</defs>
        <clipPath id="SVGID_00000026845340733426754270000002509726896510786739_">
					<use xlink:href="#SVGID_00000170252926793891548900000008236630548015784598_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000026845340733426754270000002509726896510786739_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000024706051052299989980000009040263367619987079_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000132080771609119297970000004589195217813367218_">
								<use xlink:href="#SVGID_00000024706051052299989980000009040263367619987079_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000070813079302844715390000005479191062840586164_" points="-565.7,433.7 -581,442.4 -595.9,437
						-595.9,312.2 -580.6,305.6 -565.7,308.9 -565.7,433.7 					"/>
				</defs>
        <clipPath id="SVGID_00000000941970953580709720000007588544600731336109_">
					<use xlink:href="#SVGID_00000070813079302844715390000005479191062840586164_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000000941970953580709720000007588544600731336109_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000152946411106782550910000005243845540251931798_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000119800870885845026560000008486951801180239764_">
								<use xlink:href="#SVGID_00000152946411106782550910000005243845540251931798_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000052800039036096671160000017669260671881350834_" points="-581,442.4 -581,317.2 -595.9,312.2
						-595.9,437 -581,442.4 					"/>
				</defs>
        <clipPath id="SVGID_00000057122809898686140970000017096118164304475781_">
					<use xlink:href="#SVGID_00000052800039036096671160000017669260671881350834_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000057122809898686140970000017096118164304475781_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000062885963611136725240000006575538096982284465_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000153672980676207224870000008403726647007533501_">
								<use xlink:href="#SVGID_00000062885963611136725240000006575538096982284465_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000029005112459835381010000000490258870031601584_" points="-565.7,308.9 -581,317.2 -595.9,312.2
						-580.6,303.5 -565.7,308.9 					"/>
				</defs>
        <clipPath id="SVGID_00000151537931642578484780000009178458087967272087_">
					<use xlink:href="#SVGID_00000029005112459835381010000000490258870031601584_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000151537931642578484780000009178458087967272087_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000034049481453506200450000014902635892667580598_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000156554062420970857890000014149357252909467014_">
								<use xlink:href="#SVGID_00000034049481453506200450000014902635892667580598_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000089541431656676073440000015395452716407909509_" points="-592.2,448.6 -607.6,456.9 -622.5,451.9
						-622.5,352.8 -607.1,346.2 -592.2,349.5 -592.2,448.6 					"/>
				</defs>
        <clipPath id="SVGID_00000065048512072944027700000011252874070029332369_">
					<use xlink:href="#SVGID_00000089541431656676073440000015395452716407909509_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000065048512072944027700000011252874070029332369_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000012474029725037726350000008835335765222077857_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000032612752079223634070000016267338453153040516_">
								<use xlink:href="#SVGID_00000012474029725037726350000008835335765222077857_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000170979381694532768370000011963736311793104257_" points="-607.6,456.9 -607.6,358.2 -622.5,352.8
						-622.5,451.9 -607.6,456.9 					"/>
				</defs>
        <clipPath id="SVGID_00000064324179773820313850000002889455010037449887_">
					<use xlink:href="#SVGID_00000170979381694532768370000011963736311793104257_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000064324179773820313850000002889455010037449887_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000071527834102224343010000007479189076134481852_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000182526119342905630790000014501284841599477157_">
								<use xlink:href="#SVGID_00000071527834102224343010000007479189076134481852_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000069386056095010873920000016512220591789939391_" points="-592.2,349.5 -607.6,358.2 -622.5,352.8
						-607.1,344.6 -592.2,349.5 					"/>
				</defs>
        <clipPath id="SVGID_00000150097052156263952030000010228736192378823559_">
					<use xlink:href="#SVGID_00000069386056095010873920000016512220591789939391_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000150097052156263952030000010228736192378823559_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000040567465549152218960000015967713330576382860_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000026843477568717447310000018196992169678582432_">
								<use xlink:href="#SVGID_00000040567465549152218960000015967713330576382860_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000047020948820362077020000009514346094168478606_" points="-618.7,463.1 -634.5,471.8 -649.4,466.4
						-649.4,381 -633.7,374.4 -618.7,377.7 -618.7,463.1 					"/>
				</defs>
        <clipPath id="SVGID_00000141438164584125900480000007572587502414188425_">
					<use xlink:href="#SVGID_00000047020948820362077020000009514346094168478606_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000141438164584125900480000007572587502414188425_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000149342311682146841080000016592555846917398913_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000077298132230015465800000003664494846803574945_">
								<use xlink:href="#SVGID_00000149342311682146841080000016592555846917398913_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000007392617125949735290000018419549980429217712_" points="-634.5,471.8 -634.5,386.4 -649.4,381
						-649.4,466.4 -634.5,471.8 					"/>
				</defs>
        <clipPath id="SVGID_00000036957764741584429330000005979400486277163668_">
					<use xlink:href="#SVGID_00000007392617125949735290000018419549980429217712_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000036957764741584429330000005979400486277163668_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000152949488645159158670000018102581922918526870_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000134224570824154613940000006376035326358403213_">
								<use xlink:href="#SVGID_00000152949488645159158670000018102581922918526870_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000018202952408032694340000013260438090921845942_" points="-618.7,377.7 -634.5,386.4 -649.4,381
						-633.7,372.7 -618.7,377.7 					"/>
				</defs>
        <clipPath id="SVGID_00000145059856336546446840000008085745919581226426_">
					<use xlink:href="#SVGID_00000018202952408032694340000013260438090921845942_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000145059856336546446840000008085745919581226426_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000049918844135834275650000008816155133916266131_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000155860157209589244070000004287856764839946636_">
								<use xlink:href="#SVGID_00000049918844135834275650000008816155133916266131_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000132056928246516359790000014099308064003625366_" d="M-635.3,367.8c-0.4,0-0.8,0-0.8-0.4l-23.2-35.2
						c-0.4-0.4,0-1.2,0.4-1.7s1.2-0.4,1.7,0l22,32.8l11.6-71.7c0-0.4,0.4-0.8,1.2-1.2c0.4,0,0.8,0,1.2,0.8l12.9,40.2l14.5-88.7
						c0-0.4,0.4-1.2,1.2-1.2c0.4,0,1.2,0.4,1.2,0.8l10.8,51l13.7-37.7c0-0.4,0.8-0.8,1.2-0.8c0.4,0,0.8,0.4,1.2,0.8l10.8,51.8
						l10.8-20.3c0.4-0.4,0.8-0.8,1.2-0.8s0.8,0,0.8,0.4l14.1,31.9c0.4,0.4,0,1.2-0.4,1.7s-1.2,0-1.7-0.4l-13.3-29.8l-11.2,21.1
						c-0.4,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-0.8-0.8l-11.6-51l-13.7,37.7c0,0.4-0.8,0.8-1.2,0.8c-0.4,0-0.8-0.4-0.8-0.8l-10.4-48.9
						l-14.1,87.5c0,0.4-0.4,0.8-1.2,1.2c-0.4,0-0.8,0-1.2-0.8l-12.9-40.2l-11.6,69.6C-634.1,366.9-634.5,367.4-635.3,367.8
						L-635.3,367.8"/>
				</defs>
        <clipPath id="SVGID_00000078027747906150555980000014634743780115151501_">
					<use xlink:href="#SVGID_00000132056928246516359790000014099308064003625366_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000078027747906150555980000014634743780115151501_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000052792468252571061060000012620514185098372263_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000041287200365199530470000012483647721912923043_">
								<use xlink:href="#SVGID_00000052792468252571061060000012620514185098372263_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000003069860129612016740000005443177500772799375_" d="M-634.1,367.4c-0.4,0-0.8,0-0.8-0.4l-23.2-35.2
						c-0.4-0.4,0-1.2,0.4-1.7s1.2-0.4,1.7,0l22,32.8l11.2-71.3c0-0.4,0.4-0.8,1.2-1.2c0.4,0,0.8,0,1.2,0.8l12.9,40.2l14.5-88.7
						c0-0.4,0.4-1.2,1.2-1.2c0.4,0,1.2,0.4,1.2,0.8l10.8,51l13.7-37.7c0-0.4,0.8-0.8,1.2-0.8c0.4,0,0.8,0.4,1.2,0.8l10.8,51.8
						l10.8-20.3c0.4-0.4,0.8-0.8,1.2-0.8s0.8,0,0.8,0.4l14.1,31.9c0.4,0.4,0,1.2-0.4,1.7s-1.2,0-1.7-0.4l-14.1-29.8l-11.2,21.1
						c-0.4,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-0.8-0.8l-10.8-51l-13.7,37.7c0,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-1.2-0.8l-10.4-48.9
						l-14.1,87.5c0,0.4-0.4,0.8-1.2,1.2c-0.4,0-0.8,0-1.2-0.8l-12.9-40.2l-11.6,69.6C-632.8,366.9-633.3,367.4-634.1,367.4
						L-634.1,367.4"/>
				</defs>
        <clipPath id="SVGID_00000177462868729474635920000011507312893686284207_">
					<use xlink:href="#SVGID_00000003069860129612016740000005443177500772799375_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000177462868729474635920000011507312893686284207_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000182488862742210972290000015314084101555836290_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000158751787763720191410000003181946632457654441_">
								<use xlink:href="#SVGID_00000182488862742210972290000015314084101555836290_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000085249750959681697500000006032010774891608213_" d="M-590.1,233c0,2.9-1.2,5-2.9,5.4
						c-1.7,0-2.9-1.7-2.9-4.6c0-2.9,1.2-5,2.9-5.4C-591.4,228.1-590.1,230.1-590.1,233"/>
				</defs>
        <clipPath id="SVGID_00000083771380498991787580000009565559793954830739_">
					<use xlink:href="#SVGID_00000085249750959681697500000006032010774891608213_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000083771380498991787580000009565559793954830739_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000034050723416754038170000018214976505214327958_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000075161646553438768480000017750421069892315057_">
								<use xlink:href="#SVGID_00000034050723416754038170000018214976505214327958_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000096754241971138596880000001076734241698704020_" d="M-589.3,233c0,2.9-1.2,5-2.9,5.4
						c-1.7,0-2.9-1.7-2.9-4.6c0-2.9,1.2-5,2.9-5.4C-591,228.1-589.3,230.1-589.3,233"/>
				</defs>
        <clipPath id="SVGID_00000083797526097648513170000016401532652388389277_">
					<use xlink:href="#SVGID_00000096754241971138596880000001076734241698704020_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000083797526097648513170000016401532652388389277_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000106833890364082912670000005028285563747786931_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000109719487969861552670000002290347526632358797_">
								<use xlink:href="#SVGID_00000106833890364082912670000005028285563747786931_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000156557585722897138190000000451191444667911571_" d="M-620.8,284.9c0,1.7-0.8,3.3-1.7,3.3
						s-1.7-1.2-1.7-2.9s0.8-3.3,1.7-3.3C-621.6,282-620.8,283.2-620.8,284.9"/>
				</defs>
        <clipPath id="SVGID_00000069391342153993502930000017086220636155980458_">
					<use xlink:href="#SVGID_00000156557585722897138190000000451191444667911571_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000069391342153993502930000017086220636155980458_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000173147765945650223980000007748030924159247549_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000119802441383925988530000010244829559243763847_">
								<use xlink:href="#SVGID_00000173147765945650223980000007748030924159247549_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000108293601685012727260000013548799045586904238_" d="M-620.4,284.9c0,1.7-0.8,3.3-1.7,3.3
						s-1.7-1.2-1.7-2.9s0.8-3.3,1.7-3.3C-621.2,282-620.4,283.2-620.4,284.9"/>
				</defs>
        <clipPath id="SVGID_00000045611643173874864890000010312687953967292092_">
					<use xlink:href="#SVGID_00000108293601685012727260000013548799045586904238_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000045611643173874864890000010312687953967292092_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000061444904282693033650000018008648949888042425_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000034089573864846770290000002212372970809014690_">
								<use xlink:href="#SVGID_00000061444904282693033650000018008648949888042425_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000001662339352828400520000012364864657754478483_" d="M-564,248c0,1.7-0.8,3.3-1.7,3.3
						c-0.8,0-1.7-1.2-1.7-2.9c0-1.7,0.8-3.3,1.7-3.3C-564.9,244.6-564,245.9-564,248"/>
				</defs>
        <clipPath id="SVGID_00000072961194469105377990000013610750848426182311_">
					<use xlink:href="#SVGID_00000001662339352828400520000012364864657754478483_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000072961194469105377990000013610750848426182311_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000060718025989911134440000008342627486495283351_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000098940393737471440320000002988021526644531380_">
								<use xlink:href="#SVGID_00000060718025989911134440000008342627486495283351_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000111877842634357031130000015379676657722915758_" d="M-563.6,248c0,1.7-0.8,3.3-1.7,3.3s-1.7-1.2-1.7-2.9
						c0-1.7,0.8-3.3,1.7-3.3C-564.4,244.6-563.6,245.9-563.6,248"/>
				</defs>
        <clipPath id="SVGID_00000025440439136497894100000014116850769782492589_">
					<use xlink:href="#SVGID_00000111877842634357031130000015379676657722915758_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000025440439136497894100000014116850769782492589_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000089548604946089503200000010515685210326614204_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000083774329070851044940000012310137065339395222_">
								<use xlink:href="#SVGID_00000089548604946089503200000010515685210326614204_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000147921372018506154270000009939331406512647554_" d="M-625.4,526.5L-625.4,526.5L-358,374.4v-24l33.2-19.1
						c0.4,0,0.4-0.4,0.4-0.8s0-0.4,0-0.8s-0.4-0.4-0.8-0.4c0,0,0,0-0.4,0l0,0c0-2.5-0.4-4.6-0.4-7.5c-0.8-8.7-1.7-16.6-3.3-23.2
						c-3.7-15.3-9.5-23.2-17-23.2c-2.5,0-5.4,0.8-8.3,2.5c-1.2,0.8-2.5,1.7-3.3,2.5v-87.1l68.4-39l0.4-44.8l-0.8,257l-67.6,39v-30.7
						L-625.4,526.5"/>
				</defs>
        <clipPath id="SVGID_00000103238760821128333020000002762262584460784275_">
					<use xlink:href="#SVGID_00000147921372018506154270000009939331406512647554_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000103238760821128333020000002762262584460784275_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000080925670312743912420000006648311585438244767_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000064336100180020831590000014451211422850072725_">
								<use xlink:href="#SVGID_00000080925670312743912420000006648311585438244767_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000006707026321910531180000002747942590040546692_" d="M-622.5,376.5l-2.9-1.2v-52.6l0,0V347l16.6-9.5h0.4
						c0,0,0,0,0.4,0c0,0,0.4,0,0.4-0.4h0.4c0,0,0,0,0.4,0s0.8-0.4,1.2-1.2v-0.4l10.4-5.8v18.2l-11.2-3.7l-15.8,8.7L-622.5,376.5
						 M-496,400.5L-496,400.5L-496,400.5c-0.8-2.5-1.2-5-1.7-7c-0.8-4.1-2.1-7.9-4.1-10.4c-2.9-4.1-6.2-6.6-10.8-7v-44.8l-14.9-5.4
						l-11.6,6.2v-9.9l-14.9-5.4l-11.6,6.2v-10.8l8.3-5l0.8,3.3c0,0.4,0.4,0.8,0.8,0.8l0,0c0.4,0,0.4,0,0.8-0.4h0.4l0,0
						c0.4,0,0.8-0.4,1.2-0.8l4.1-7.9l9.1-5.4l9.9,22.4c0,0.4,0.4,0.4,0.8,0.4h0.4l0,0h0.4h0.4c0.4-0.4,0.8-1.2,0.4-1.7l-9.9-22.8
						l178.7-102.4v87.1c-2.9,2.5-5.8,5.4-8.7,9.9c-3.3,4.6-6.6,10.4-10.8,17.8c-4.1,8.3-7.5,13.7-9.1,17c-2.9,5.4-5.4,8.3-6.6,9.1
						c-0.4,0.4-0.8,0.4-1.2,0.4c-2.1,0-4.1-2.9-6.2-8.3c-2.9-9.5-5.4-17-7.5-22c-3.7-9.1-8.3-14.9-12.9-17.4
						c-2.1-0.8-4.1-1.7-6.2-1.7c-5,0-10.8,2.5-17.4,7.5c-10.4,7.9-18.7,17.8-25.3,30.7c-5,9.5-9.1,21.1-12.9,34
						c-1.2,4.6-2.1,9.5-3.3,15.3c-0.8,3.3-1.7,7.5-2.5,12.9c-0.8,4.1-1.7,7.5-2.1,9.5c-0.8,2.5-1.7,4.1-2.9,4.6
						C-494.8,400.1-495.6,400.5-496,400.5 M-625.4,526.5v-59.7l6.6-3.7v-9.9l11.2,3.7l15.8-8.7v-9.9l11.2,3.7l15.8-8.7v-9.9l5,1.7
						c-0.4,0.8-0.4,2.1-0.8,2.9c-3.7,12.9-5.4,26.1-5.8,39.4l-0.4,0.4c-0.4,0-0.4,0.4-0.4,0.8s0,0.4,0,0.8s0.4,0.4,0.8,0.4
						c0,0,0,0,0.4,0h0.4l33.2-19.1l7.5-4.1l167.9-96.2v24L-625.4,526.5"/>
				</defs>
        <clipPath id="SVGID_00000097487035563629218340000007852047409791003326_">
					<use xlink:href="#SVGID_00000006707026321910531180000002747942590040546692_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000097487035563629218340000007852047409791003326_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000069376839231681750060000007085748723762965379_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000016776024617961342500000015960160896675207309_">
								<use xlink:href="#SVGID_00000069376839231681750060000007085748723762965379_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000000180782403312912450000003508405928125388472_" points="-625.4,558.9 -625.4,526.5 -358,374.4
						-358,405.5 -625.4,558.9 					"/>
				</defs>
        <clipPath id="SVGID_00000026848518426849663700000012830081817054670752_">
					<use xlink:href="#SVGID_00000000180782403312912450000003508405928125388472_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000026848518426849663700000012830081817054670752_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000052089382609661520960000006918186717357961857_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000153691786378517054350000016451450574400886437_">
								<use xlink:href="#SVGID_00000052089382609661520960000006918186717357961857_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000156568686649778935290000004587912742947229117_" d="M-528,380.2v-40.6l15.8-8.7v44.8c-0.4,0-0.8,0-1.2,0
						C-517.6,375.6-522.2,377.3-528,380.2"/>
				</defs>
        <clipPath id="SVGID_00000142885414112707491500000003326886770374897557_">
					<use xlink:href="#SVGID_00000156568686649778935290000004587912742947229117_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000142885414112707491500000003326886770374897557_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000003826729336684291450000000537549903593937584_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000080165891527645213790000006945626936520891813_">
								<use xlink:href="#SVGID_00000003826729336684291450000000537549903593937584_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000055675548442346962730000013459086757777574577_" d="M-538.7,388.1v-52.6l11.2,3.7v40.6
						c-0.4,0-0.4,0.4-0.8,0.4C-532.5,382.7-535.8,385.2-538.7,388.1"/>
				</defs>
        <clipPath id="SVGID_00000181798744497033504180000004541370347009208198_">
					<use xlink:href="#SVGID_00000055675548442346962730000013459086757777574577_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000181798744497033504180000004541370347009208198_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000098200650872654493250000016316897967695603598_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000009590974358625817550000015790359867881235380_">
								<use xlink:href="#SVGID_00000098200650872654493250000016316897967695603598_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000039851131185327231490000004339380245010899885_" points="-528,339.2 -538.7,335.4 -538.7,332.1
						-527.1,325.5 -512.2,330.9 -528,339.2 					"/>
				</defs>
        <clipPath id="SVGID_00000182519967356047540680000013369344049307159688_">
					<use xlink:href="#SVGID_00000039851131185327231490000004339380245010899885_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000182519967356047540680000013369344049307159688_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000124849314772884198150000007889437830737749153_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000021077383842322027430000016664062479899368594_">
								<use xlink:href="#SVGID_00000124849314772884198150000007889437830737749153_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000025441214448557663110000003119446184514660527_" d="M-554.5,409.6v-79.2l15.8-8.7v9.9v3.3v52.6
						C-545,393.9-550.3,400.9-554.5,409.6"/>
				</defs>
        <clipPath id="SVGID_00000112592477004440204570000005016260959098407827_">
					<use xlink:href="#SVGID_00000025441214448557663110000003119446184514660527_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000112592477004440204570000005016260959098407827_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000143615992135451300730000009456341891316059832_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000113316679859290600320000010085965461477632690_">
								<use xlink:href="#SVGID_00000143615992135451300730000009456341891316059832_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000170976873613171939460000014887970801924795025_" d="M-560.7,425.4l-5-1.7v-97l11.2,3.7v79.2
						C-557,414.6-558.6,419.6-560.7,425.4"/>
				</defs>
        <clipPath id="SVGID_00000118365000987259547470000008782163426450784909_">
					<use xlink:href="#SVGID_00000170976873613171939460000014887970801924795025_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000118365000987259547470000008782163426450784909_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000101788413507523919300000003115082173792787883_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000160183437292289401650000004386625101672367251_">
								<use xlink:href="#SVGID_00000101788413507523919300000003115082173792787883_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000101787007473474045930000017091354834727884697_" points="-554.5,330.5 -565.7,326.7 -565.7,323
						-553.7,316.8 -538.7,322.2 -554.5,330.5 					"/>
				</defs>
        <clipPath id="SVGID_00000019660186837875109120000010156349900907578527_">
					<use xlink:href="#SVGID_00000101787007473474045930000017091354834727884697_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000019660186837875109120000010156349900907578527_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000160870127358120799890000003307260771577551015_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000096742291698748306860000018076728908016770744_">
								<use xlink:href="#SVGID_00000160870127358120799890000003307260771577551015_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000040566759156100437030000013445968509794151810_" points="-581,442.4 -581,442.4 -581,321.3
						-565.7,312.6 -565.7,323 -565.7,326.7 -565.7,433.7 -581,442.4 					"/>
				</defs>
        <clipPath id="SVGID_00000137854670372326145260000017029320819167831189_">
					<use xlink:href="#SVGID_00000040566759156100437030000013445968509794151810_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000137854670372326145260000017029320819167831189_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000008133151967835968520000001076303744730059943_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000096752776340654182860000003389304506122081711_">
								<use xlink:href="#SVGID_00000008133151967835968520000001076303744730059943_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000101782881676345695430000016550780565919331719_" points="-581,442.4 -592.2,438.2 -592.2,349.5
						-595.9,348.3 -595.9,330 -581,321.3 -581,442.4 					"/>
				</defs>
        <clipPath id="SVGID_00000055690448979127770240000011489592865743241623_">
					<use xlink:href="#SVGID_00000101782881676345695430000016550780565919331719_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000055690448979127770240000011489592865743241623_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000065060872635137092190000011598819478878191546_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000004540647779493650230000002816290695550804402_">
								<use xlink:href="#SVGID_00000065060872635137092190000011598819478878191546_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000176018398825895611210000006535746612456575624_" points="-607.6,456.9 -607.6,456.9 -607.6,358.2
						-592.2,349.5 -592.2,438.2 -592.2,448.6 -607.6,456.9 					"/>
				</defs>
        <clipPath id="SVGID_00000163786922346487933270000005505624965264170142_">
					<use xlink:href="#SVGID_00000176018398825895611210000006535746612456575624_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000163786922346487933270000005505624965264170142_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000069368961594879252980000005403981607006320301_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000150811856099241069760000003974056975961551774_">
								<use xlink:href="#SVGID_00000069368961594879252980000005403981607006320301_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000152967944316337419270000008933975205707853223_" points="-607.6,456.9 -618.7,453.2 -618.7,377.7
						-622.5,376.5 -622.5,352.8 -607.6,358.2 -607.6,456.9 					"/>
				</defs>
        <clipPath id="SVGID_00000059309989337206741280000004748944425496437395_">
					<use xlink:href="#SVGID_00000152967944316337419270000008933975205707853223_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000059309989337206741280000004748944425496437395_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000062193664643914860800000000377851720175030718_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000115476432950606176780000001586918153829227937_">
								<use xlink:href="#SVGID_00000062193664643914860800000000377851720175030718_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000106121856429010357090000014952386160658829952_" points="-607.6,358.2 -622.5,352.8 -607.1,344.6
						-592.2,349.5 -607.6,358.2 					"/>
				</defs>
        <clipPath id="SVGID_00000120549625006450277910000003176005516067612810_">
					<use xlink:href="#SVGID_00000106121856429010357090000014952386160658829952_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000120549625006450277910000003176005516067612810_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000089567225605998766810000010175779672938487983_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000058585254786318269800000000792512991028441761_">
								<use xlink:href="#SVGID_00000089567225605998766810000010175779672938487983_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000142144210879092456500000009016661478137051817_" points="-625.8,466.9 -625.8,381.5 -618.7,377.7
						-618.7,463.1 -625.8,466.9 					"/>
				</defs>
        <clipPath id="SVGID_00000000942165483652938890000008700002986049388733_">
					<use xlink:href="#SVGID_00000142144210879092456500000009016661478137051817_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000000942165483652938890000008700002986049388733_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000145774818170659315940000016381338346585185705_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000037670783497768224120000001262742021555784619_">
								<use xlink:href="#SVGID_00000145774818170659315940000016381338346585185705_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000083076479712763291140000014128415290211129523_" points="-625.8,381.5 -625.8,375.6 -622.5,376.5
						-618.7,377.7 -625.8,381.5 					"/>
				</defs>
        <clipPath id="SVGID_00000007430699420873034380000009727469066704826757_">
					<use xlink:href="#SVGID_00000083076479712763291140000014128415290211129523_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000007430699420873034380000009727469066704826757_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000154419293235949369020000014055020133189070726_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000072986300016283077990000003800509230065524867_">
								<use xlink:href="#SVGID_00000154419293235949369020000014055020133189070726_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000158732925450159931550000017680945632043985338_" d="M-553.7,307.2l-0.4-1.2l1.2-0.8L-553.7,307.2
						 M-625.8,308.9v-6.2V308.9L-625.8,308.9 M-555.3,311.8L-555.3,311.8c-0.4,0-0.8-0.4-0.8-0.8l-0.8-3.3l1.2-0.4l0.8,3.7
						c0,0.4,0.4,0.4,0.4,0.8C-554.9,311.8-555.3,311.8-555.3,311.8 M-528.8,320.5c-0.4,0-0.8,0-0.8-0.4l-9.9-22.4l0.8-0.4
						L-528.8,320.5C-528.8,320.5-528.4,320.5-528.8,320.5L-528.8,320.5C-528.4,320.5-528.4,320.5-528.8,320.5 M-608.8,337.5
						L-608.8,337.5L-608.8,337.5h0.8C-608,337.5-608.4,337.5-608.8,337.5C-608.4,337.5-608.8,337.5-608.8,337.5"/>
				</defs>
        <clipPath id="SVGID_00000046328172582218973400000010888243213175647900_">
					<use xlink:href="#SVGID_00000158732925450159931550000017680945632043985338_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000046328172582218973400000010888243213175647900_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000152247442294326792150000010742340470643105717_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000017493227908565345100000003495494810484207785_">
								<use xlink:href="#SVGID_00000152247442294326792150000010742340470643105717_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000070105526708553369570000005736272653853911964_" d="M-554.1,311.8C-554.1,311.8-554.5,311.8-554.1,311.8
						L-554.1,311.8c-0.8,0-0.8-0.4-0.8-0.8l-0.8-3.7l2.1-1.2l0.4,1.2l1.2-2.1l3.7-2.1l-4.1,7.9
						C-553.2,311.4-553.7,311.8-554.1,311.8 M-527.5,320.5L-527.5,320.5c-0.8,0-0.8-0.4-0.8-0.4l-9.9-22.8l2.1-1.2l9.9,22.8
						c0.4,0.4,0,1.2-0.4,1.7C-527.1,320.5-527.5,320.5-527.5,320.5 M-625.8,322.6v-13.7l0,0V322.6L-625.8,322.6 M-607.6,337.5
						L-607.6,337.5c-0.4,0-0.8,0-0.8-0.4l2.1-1.2v0.4C-606.3,337.1-606.7,337.5-607.6,337.5L-607.6,337.5"/>
				</defs>
        <clipPath id="SVGID_00000066485186497012146650000010885692992757901737_">
					<use xlink:href="#SVGID_00000070105526708553369570000005736272653853911964_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000066485186497012146650000010885692992757901737_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000164488407831340550720000007899972520127170197_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000093177014005221742230000016641000785497837219_">
								<use xlink:href="#SVGID_00000164488407831340550720000007899972520127170197_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000147916426574789027200000014964611766091263924_" points="-289.2,109.5 -625.8,302.7 -635.3,299
						-301.6,109.5 -289.2,109.5 					"/>
				</defs>
        <clipPath id="SVGID_00000020394205418004197510000003526829015357793721_">
					<use xlink:href="#SVGID_00000147916426574789027200000014964611766091263924_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000020394205418004197510000003526829015357793721_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000033370100176121988200000016839151884044908216_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000015337907190453463670000003185535623378107266_">
								<use xlink:href="#SVGID_00000033370100176121988200000016839151884044908216_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000065043466233233857840000010205672793047011510_" points="-635.3,299 -634.1,553.1 -625.4,558.9
						-625.8,302.7 -635.3,299 					"/>
				</defs>
        <clipPath id="SVGID_00000000936000774849417080000006095783492124882569_">
					<use xlink:href="#SVGID_00000065043466233233857840000010205672793047011510_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000000936000774849417080000006095783492124882569_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000181047864322201455130000010438198766075194530_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000032638999770354100250000004772600499026503103_">
								<use xlink:href="#SVGID_00000181047864322201455130000010438198766075194530_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000023262103257028779720000003483727946750032034_" d="M-308.2,136.5c-0.8,0-1.7,0.4-2.9,0.8
						c-2.9,1.7-5,5-5.8,8.3c0,0.8-0.4,1.2-0.4,2.1c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4
						c0-2.1-0.8-3.3-1.7-3.7C-307.4,136.5-307.8,136.5-308.2,136.5 M-328.6,148.9c-0.8,0-1.7,0.4-2.9,0.8c-2.9,1.7-5,5-5.8,8.3
						c0,0.8,0,1.2,0,2.1c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4c0-2.1-0.8-3.3-1.7-3.7
						C-327.7,148.9-328.1,148.9-328.6,148.9 M-348.9,160.1c-0.8,0-1.7,0.4-2.9,0.8c-2.9,1.7-5,5-5.8,8.3c0,0.8,0,1.2,0,2.1
						c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4c0-2.1-0.8-3.3-1.7-3.7
						C-347.6,160.5-348,160.1-348.9,160.1 M-357.6,193.2v-44.8l68.4-39.4l-0.4,44.8L-357.6,193.2"/>
				</defs>
        <use xlink:href="#SVGID_00000023262103257028779720000003483727946750032034_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000121268743171664049000000005365585331419744447_">
					<use xlink:href="#SVGID_00000023262103257028779720000003483727946750032034_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000121268743171664049000000005365585331419744447_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000135650776806874585140000003798536466894382269_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000135650776806874585140000003798536466894382269_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000134247386006831696610000010524960970452466077_">
								<use xlink:href="#SVGID_00000135650776806874585140000003798536466894382269_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000047039123116942810990000007327684588940833674_" d="M-581,291.1l-2.5-12.4l9.1-5.4L-581,291.1
						 M-549.1,303.1l6.2-12l2.9,6.6L-549.1,303.1 M-554.1,305.6l-8.3-39.4L-358,148.9v44.8l-178.7,102.4l-4.1-9.1
						c0-0.4-0.4-0.4-0.8-0.4l0,0c-0.4,0-0.4,0-0.8,0.4h-0.4l0,0c-0.4,0-0.8,0.4-1.2,0.8L-554.1,305.6 M-608.4,328.8l-9.5-30.7
						l16.2-9.1L-608.4,328.8 M-606.3,335.9l7.9-48.9l11.6-6.6l3.7,17.4c0,0.4,0.4,0.8,0.8,0.8l0,0c0.4,0,0.4,0,0.8-0.4h0.4l0,0
						c0.4,0,0.8-0.4,1.2-0.8l9.9-26.9l4.6-2.5l8.3,39.8l-8.3,5v-3.7l-14.9-5.4l-15.8,8.7V330L-606.3,335.9 M-625.4,347v-24.5l3.7-22
						l0.8-0.4l11.6,36.9c0,0.4,0.4,0.4,0.4,0.4L-625.4,347"/>
				</defs>
        <use xlink:href="#SVGID_00000047039123116942810990000007327684588940833674_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000095324964057156292990000005150163403382226819_">
					<use xlink:href="#SVGID_00000047039123116942810990000007327684588940833674_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000095324964057156292990000005150163403382226819_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000000219185655007472900000003812944073080372888_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000000219185655007472900000003812944073080372888_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000134941609579663389140000007120678718303189905_">
								<use xlink:href="#SVGID_00000000219185655007472900000003812944073080372888_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000119802757501544189310000005082595403999819396_" points="-581,321.3 -581,317.2 -565.7,308.9
						-565.7,312.6 -581,321.3 					"/>
				</defs>
        <clipPath id="SVGID_00000128471857515548477400000017058608108716288140_">
					<use xlink:href="#SVGID_00000119802757501544189310000005082595403999819396_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000128471857515548477400000017058608108716288140_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000139278938426595115640000006302845013653295292_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000047059423169697229310000017163918405966057098_">
								<use xlink:href="#SVGID_00000139278938426595115640000006302845013653295292_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000020377399122183413930000016439407808686272921_" points="-595.9,330 -595.9,312.2 -581,317.2
						-581,321.3 -595.9,330 					"/>
				</defs>
        <clipPath id="SVGID_00000080903071172988131500000009776914675188190092_">
					<use xlink:href="#SVGID_00000020377399122183413930000016439407808686272921_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000080903071172988131500000009776914675188190092_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000076604059965314022090000003516063353095452301_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000085933923399276278130000017692774433657843621_">
								<use xlink:href="#SVGID_00000076604059965314022090000003516063353095452301_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000138573578389123940530000004156709584747225222_" points="-581,317.2 -595.9,312.2 -580.6,303.5
						-565.7,308.9 -581,317.2 					"/>
				</defs>
        <clipPath id="SVGID_00000138569540113120136130000009213380521871525284_">
					<use xlink:href="#SVGID_00000138573578389123940530000004156709584747225222_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000138569540113120136130000009213380521871525284_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000049917360275738308480000002790175469711889293_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000008844005870420293990000014043624588125365149_">
								<use xlink:href="#SVGID_00000049917360275738308480000002790175469711889293_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000170237391380135091980000001023382616986768049_" d="M-580.6,293.2l-0.4-2.1l6.6-17.8l1.2-0.8
						L-580.6,293.2 M-539.6,297.7l-2.9-6.6l0.8-1.2l3.3,7.5L-539.6,297.7 M-582.3,298.5c-0.4,0-0.8-0.4-0.8-0.8l-3.7-17.4l1.2-0.4
						l3.7,17.8c0,0.4,0.4,0.4,0.4,0.8C-581.4,298.5-581.9,298.5-582.3,298.5C-581.9,298.5-582.3,298.5-582.3,298.5 M-553.7,306
						L-553.7,306l9.9-19.1c0.4-0.4,0.8-0.8,1.2-0.8l0,0h0.4l-0.4,0.4l-9.9,18.2L-553.7,306 M-557,307.7l-8.3-39.8l1.2-0.4l8.3,39.8
						L-557,307.7 M-625.8,308.9v-6.2l1.2-0.8L-625.8,308.9 M-607.6,331.3l-0.8-2.5l6.6-39.8l1.2-0.8L-607.6,331.3 M-609.2,337.5
						C-609.6,337.5-609.6,337.1-609.2,337.5l-12-37.3l0.8-0.4L-609.2,337.5L-609.2,337.5L-609.2,337.5"/>
				</defs>
        <clipPath id="SVGID_00000123409745381977555830000006218292123812542869_">
					<use xlink:href="#SVGID_00000170237391380135091980000001023382616986768049_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000123409745381977555830000006218292123812542869_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000052103839017573068940000009832144338779495846_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000034804909218295210440000005999102332416903081_">
								<use xlink:href="#SVGID_00000052103839017573068940000009832144338779495846_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000161593829998179477890000011348509969426426292_" d="M-581,298.5L-581,298.5c-0.8,0-0.8-0.4-0.8-0.8
						l-3.7-17.8l2.1-1.2l2.9,14.5l7.5-20.7l2.9-1.7l-9.9,26.9C-579.8,298.1-580.2,298.5-581,298.5L-581,298.5 M-552.4,305.2
						l9.9-18.2l0.4-0.4c0,0,0.4-0.4,0.8-0.4l0,0c0.4,0,0.8,0.4,0.8,0.4l4.1,9.1l-2.1,1.2l-3.7-7l-7,13.3L-552.4,305.2 M-556.1,307.2
						l-8.3-39.8l2.1-1.2l8.3,39.4v0.4L-556.1,307.2 M-625.8,322.6v-13.7l1.2-6.6l2.5-1.7L-625.8,322.6 M-608.4,337.1L-608.4,337.1
						l-12-37.3l2.1-1.2l10.4,32.8l7-42.7l2.5-1.7l-7.9,48.9L-608.4,337.1"/>
				</defs>
        <clipPath id="SVGID_00000160178715773399596970000013206738038995921537_">
					<use xlink:href="#SVGID_00000161593829998179477890000011348509969426426292_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000160178715773399596970000013206738038995921537_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000070831986053866284810000013799883044433751687_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000181777771055927804730000005578333014347179944_">
								<use xlink:href="#SVGID_00000070831986053866284810000013799883044433751687_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000107585454189858846230000005089447674825290632_" d="M-354.3,175.4c-2.1,0-3.3-1.7-3.3-4.1
						c0-0.4,0-1.2,0-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7
						c0,3.7-2.9,8.3-6.2,10.4C-352.6,175.4-353.4,175.4-354.3,175.4"/>
				</defs>
        <clipPath id="SVGID_00000025401019013136598080000015236378230270805414_">
					<use xlink:href="#SVGID_00000107585454189858846230000005089447674825290632_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000025401019013136598080000015236378230270805414_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000113315242795630705050000009117557339155939000_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000026153763065186252250000008646335167382533792_">
								<use xlink:href="#SVGID_00000113315242795630705050000009117557339155939000_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000091696815940834681950000011025051165052222091_" d="M-333.9,164.2c-2.1,0-3.3-1.7-3.3-4.1
						c0-0.4,0-1.2,0-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7
						c0,3.7-2.9,8.3-6.2,10.4C-332.3,163.8-333.1,164.2-333.9,164.2"/>
				</defs>
        <clipPath id="SVGID_00000113328972703162512880000006202955606494132398_">
					<use xlink:href="#SVGID_00000091696815940834681950000011025051165052222091_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000113328972703162512880000006202955606494132398_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000148647484963164916840000009238276898267909003_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000122679220379076661780000006606585775947240373_">
								<use xlink:href="#SVGID_00000148647484963164916840000009238276898267909003_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000022537541285664887980000006963257418265309612_" d="M-314,151.8c-2.1,0-3.3-1.7-3.3-4.1
						c0-0.4,0-1.2,0.4-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7
						c0,3.7-2.9,8.3-6.2,10.4C-312,151.4-313.2,151.8-314,151.8"/>
				</defs>
        <clipPath id="SVGID_00000035492432557236601390000003463161798542574485_">
					<use xlink:href="#SVGID_00000022537541285664887980000006963257418265309612_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000035492432557236601390000003463161798542574485_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000038375192608246080330000009186965483877638055_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000090263511904794542750000007395943225582588841_">
								<use xlink:href="#SVGID_00000038375192608246080330000009186965483877638055_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000150073921207510764550000017283317712673415318_" d="M-534.2,449l7.5-4.1l15.8-9.1l184.9-106.1
						c0.4,0,0.4,0,0.8,0c0.4,0,0.4,0.4,0.8,0.4c0,0.4,0,0.4,0,0.8s-0.4,0.4-0.4,0.8L-525.9,447l-7.5,4.1l-33.2,19.1
						c-0.4,0-0.4,0-0.8,0s-0.4-0.4-0.8-0.4c0-0.4,0-0.4,0-0.8s0.4-0.4,0.4-0.8l30.3-17.4L-534.2,449"/>
				</defs>
        <clipPath id="SVGID_00000114059180113454012030000005024233986617056672_">
					<use xlink:href="#SVGID_00000150073921207510764550000017283317712673415318_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000114059180113454012030000005024233986617056672_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000114753567360186369960000010129363612799937670_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000044143139924323074480000017236848101083543439_">
								<use xlink:href="#SVGID_00000114753567360186369960000010129363612799937670_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000083058511523243349730000015240409126036263593_" d="M-319,281.5c-0.4-0.4-0.8-0.4-1.2-0.8l0,0
						c-1.2-1.2-1.7-2.9-1.7-4.6s0.8-3.3,2.1-4.6c1.2-1.2,2.9-2.1,4.6-2.1c1.7,0,3.3,0.8,4.6,2.1s2.1,2.9,2.1,4.6
						c0,1.7-0.8,3.3-2.1,4.6c-1.2,1.2-2.9,2.1-4.6,2.1C-316.9,282.4-318.2,282.4-319,281.5"/>
				</defs>
        <clipPath id="SVGID_00000169556497639115156720000006885384717998278043_">
					<use xlink:href="#SVGID_00000083058511523243349730000015240409126036263593_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000169556497639115156720000006885384717998278043_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000005954600803780727470000015809626054316613027_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000169557229548630934270000006698236014523845778_">
								<use xlink:href="#SVGID_00000005954600803780727470000015809626054316613027_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000099627547023671510690000014767104639139416458_" d="M-374.2,263.3c-0.4,0.8-0.8,1.2-1.2,2.1
						c-1.2,1.2-2.9,2.1-4.6,2.1c-1.7,0-3.3-0.8-4.6-2.1c-0.4-0.4-0.4-0.4-0.4-0.8c-0.4-0.4-0.8-0.8-0.8-1.7
						c-0.4-0.8-0.4-1.7-0.4-2.5c0-1.7,0.8-3.3,2.1-4.6c1.2-1.2,2.9-2.1,4.6-2.1c1.7,0,3.3,0.8,4.6,2.1c1.2,1.2,2.1,2.9,2.1,4.6
						c0,0.4,0,0.8,0,0.8C-373.7,262.1-374.2,262.9-374.2,263.3"/>
				</defs>
        <clipPath id="SVGID_00000146499004263095277360000005919533238764700057_">
					<use xlink:href="#SVGID_00000099627547023671510690000014767104639139416458_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000146499004263095277360000005919533238764700057_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000111879648319516838090000015649377221645974703_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000012454456149670877950000002152502062103161497_">
								<use xlink:href="#SVGID_00000111879648319516838090000015649377221645974703_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000018202442914641438410000003927213686690723994_" d="M-593.9,419.2c0.8,1.2,1.2,2.5,1.2,3.7
						c0,1.7-0.8,3.3-2.1,4.6c-1.2,1.2-2.9,2.1-4.6,2.1c-1.7,0-3.3-0.8-4.6-2.1s-2.1-2.9-2.1-4.6s0.8-3.3,2.1-4.6
						c1.2-1.2,2.9-2.1,4.6-2.1c1.7,0,2.9,0.4,4.1,1.2l0.4,0.4C-594.3,418.8-594.3,418.8-593.9,419.2"/>
				</defs>
        <clipPath id="SVGID_00000041999176144376721440000010914263237859928979_">
					<use xlink:href="#SVGID_00000018202442914641438410000003927213686690723994_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000041999176144376721440000010914263237859928979_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000088855563614088280570000017878677409902935700_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000041286264652958226080000017837104082399377587_">
								<use xlink:href="#SVGID_00000088855563614088280570000017878677409902935700_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000095312116397429040190000010446106184783622589_" d="M-358,347.9v-67.6c1.2-0.8,2.5-1.7,3.3-2.5
						c2.9-1.7,5.8-2.5,8.3-2.5c7.5,0,13.3,7.9,17,23.2c1.7,6.6,2.9,14.5,3.3,23.2c0.4,2.5,0.4,5,0.4,7.5h-0.4L-358,347.9"/>
				</defs>
        <clipPath id="SVGID_00000095340140499385949210000001742400889216234912_">
					<use xlink:href="#SVGID_00000095312116397429040190000010446106184783622589_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000095340140499385949210000001742400889216234912_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000098918117536846234110000002999073725043116163_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000083082676558130848720000010079675065555731372_">
								<use xlink:href="#SVGID_00000098918117536846234110000002999073725043116163_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000105413704937234485610000008920350686402628286_" d="M-567.3,468.1c0-13.7,2.1-26.5,5.8-39.4
						c0.4-0.8,0.4-2.1,0.8-2.9l6.2,2.1l15.8-8.7v-9.9l11.2,3.7l15.8-8.7v-28.6c4.6,0.4,8.3,2.9,10.8,7c1.7,2.5,2.9,6.2,4.1,10.4
						c0.4,2.1,0.8,4.6,1.2,6.6v0.4c0,0,0,0,0.4,0s0.8-0.4,1.7-0.8c0.8-0.4,2.1-2.1,2.9-4.6c0.8-2.1,1.2-5,2.1-9.5
						c0.8-5.4,1.7-9.5,2.5-12.9c1.2-5.8,2.1-11.2,3.3-15.3c3.3-12.9,7.5-24.5,12.9-34c6.6-12.4,15.3-22.8,25.3-30.7
						c6.6-5,12.4-7.5,17.4-7.5c2.5,0,4.6,0.4,6.2,1.7c5,2.5,9.1,8.3,12.9,17.4c2.1,5,4.6,12.4,7.5,22c2.1,5.4,4.1,8.3,6.2,8.3
						c0.4,0,0.8,0,1.2-0.4c1.7-0.8,3.7-3.7,6.6-9.1c1.7-3.3,5-8.7,9.1-17c4.1-7.5,7.9-13.7,10.8-17.8c2.9-4.1,5.8-7.5,8.7-9.9v67.6
						l-153,88.3l-15.8,9.1l-7.5,4.1l-3.3,1.7L-567.3,468.1"/>
				</defs>
        <clipPath id="SVGID_00000165926045655457793560000002827148231439352236_">
					<use xlink:href="#SVGID_00000105413704937234485610000008920350686402628286_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000165926045655457793560000002827148231439352236_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000121260204950622832890000015377212793593421451_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000108998696364493656450000000896844367129483404_">
								<use xlink:href="#SVGID_00000121260204950622832890000015377212793593421451_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000174574325782774927840000000290909217465803689_" d="M-528,413L-528,413v-32.8c5.4-2.9,10.4-4.6,14.1-4.6
						c0.4,0,0.8,0,1.2,0v28.6L-528,413"/>
				</defs>
        <clipPath id="SVGID_00000062159414969062808450000000800667650484336545_">
					<use xlink:href="#SVGID_00000174574325782774927840000000290909217465803689_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000062159414969062808450000000800667650484336545_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000140734141299917689550000000638859880151362176_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000083053604626630920860000007897507417175233712_">
								<use xlink:href="#SVGID_00000140734141299917689550000000638859880151362176_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000151532145501845851040000012843283219811080862_" d="M-528,413l-11.2-3.7v-20.7c3.3-2.9,6.6-5.4,10.4-7.5
						c0.4,0,0.4-0.4,0.8-0.4V413"/>
				</defs>
        <clipPath id="SVGID_00000165210359768941351030000004954083197527810950_">
					<use xlink:href="#SVGID_00000151532145501845851040000012843283219811080862_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000165210359768941351030000004954083197527810950_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000078034119252255861330000018016201743079283853_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000183937891630217025670000017049007411625863566_">
								<use xlink:href="#SVGID_00000078034119252255861330000018016201743079283853_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000145753081521882806820000014909950726287615383_" d="M-554.5,427.5L-554.5,427.5v-17.8
						c4.1-8.7,9.5-15.8,15.8-21.6v31.1L-554.5,427.5"/>
				</defs>
        <clipPath id="SVGID_00000103225662041424507770000005794436259338120633_">
					<use xlink:href="#SVGID_00000145753081521882806820000014909950726287615383_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000103225662041424507770000005794436259338120633_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000055665807195085351090000006006316745044290184_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000062878954924102063000000016337046814173823912_">
								<use xlink:href="#SVGID_00000055665807195085351090000006006316745044290184_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000169526534872288525980000010248359129949796748_" d="M-554.5,427.5l-6.2-2.1c1.7-5.8,3.7-11.2,6.2-15.8
						V427.5"/>
				</defs>
        <clipPath id="SVGID_00000050643335770590126980000001597759265635246470_">
					<use xlink:href="#SVGID_00000169526534872288525980000010248359129949796748_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000050643335770590126980000001597759265635246470_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000057870009801932616630000005258774717011549605_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000163757833647183163950000004716446159240578191_">
								<use xlink:href="#SVGID_00000057870009801932616630000005258774717011549605_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000072243862857744189970000003321024366804971697_" d="M-567.3,469.3c0-0.4,0-0.8,0-1.2l29.8-17l3.3-1.7
						l7.5-4.1l15.8-9.1L-326.1,330h0.4c0,0.4,0,0.8,0,1.2L-567.3,469.3"/>
				</defs>
        <clipPath id="SVGID_00000158004583175799699420000013927693736915882382_">
					<use xlink:href="#SVGID_00000072243862857744189970000003321024366804971697_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000158004583175799699420000013927693736915882382_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000010310646016274127530000008164278589785009339_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000145048223841284690350000002003717176108615597_">
								<use xlink:href="#SVGID_00000010310646016274127530000008164278589785009339_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000024722215724714936520000006356681689965974418_" d="M-564.4,374c-0.8,1.2-1.7,2.1-2.5,3.3
						c-6.2,8.7-13.3,19.5-21.1,31.9c-2.1,3.3-4.1,6.6-6.2,9.9c0-0.4-0.4-0.4-0.4-0.8l-0.4-0.4c2.1-3.7,4.6-7,6.6-10.8
						c7.9-12.4,14.9-23.2,21.1-31.5c0.8-1.2,1.7-2.5,2.5-3.3c2.1-2.9,4.1-5.4,6.2-7.5c7.5-9.1,14.1-14.9,19.1-17.4
						c12-5.8,22.4-8.7,31.1-8.7c8.7,0,16.6,2.5,23.2,7.9c6.2,5,10.8,7.5,13.7,7.5c15.3,0,27.4-4.6,36.9-14.1
						c6.2-6.6,12.4-17,18.2-31.1c2.9-7.9,5.4-13.3,6.6-17c2.5-6.2,5.4-11.2,7.9-14.9c4.6-6.6,9.5-10.8,15.8-13.3
						c0.4,0.4,0.4,0.8,0.8,1.7c-5.8,2.1-11.2,6.2-15.3,12.4c-2.5,3.7-5,8.3-7.5,14.5c-1.7,3.7-3.7,9.1-6.6,17
						c-5.8,14.5-12.4,25.3-18.7,31.9c-9.5,9.9-22.4,14.5-38.1,14.5c-3.3,0-7.9-2.5-14.5-7.9c-6.2-5-13.7-7.5-22-7.5
						c-8.7,0-18.7,2.9-30.7,8.7c-5,2.5-11.6,8.3-19.1,17.8C-560.3,368.6-562,371.1-564.4,374"/>
				</defs>
        <clipPath id="SVGID_00000086658257692671971490000013692973741036548230_">
					<use xlink:href="#SVGID_00000024722215724714936520000006356681689965974418_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000086658257692671971490000013692973741036548230_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000156545194129706928360000009530961083119013804_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000033344528852877774260000016474362786466135971_">
								<use xlink:href="#SVGID_00000156545194129706928360000009530961083119013804_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000067952647625052913050000015349806366951887024_" d="M-319,281.5c-1.2,0.8-2.9,2.1-5,3.3
						c-4.6,2.9-7.9,4.1-9.1,4.1c-4.1,0-7.9-1.2-11.6-4.1l0,0c-2.1-1.7-5.4-4.6-9.5-8.7c-4.1-4.1-7.5-7-9.9-8.7
						c-3.3-2.1-6.6-3.3-9.9-3.7c0.4-0.4,0.4-1.2,0.4-1.7c3.3,0.4,7,1.7,10.4,4.1c2.5,1.7,5.8,4.6,9.9,9.1c4.1,4.1,7.5,7,9.5,8.7
						c3.7,2.5,7,3.7,10.8,3.7c1.2,0,3.7-1.2,8.3-3.7c1.7-1.2,3.3-2.1,4.6-2.9l0,0C-319.9,281.1-319.4,281.5-319,281.5"/>
				</defs>
        <clipPath id="SVGID_00000141451468636964215230000016454950611288498353_">
					<use xlink:href="#SVGID_00000067952647625052913050000015349806366951887024_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000141451468636964215230000016454950611288498353_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000106826103082697339000000003018424839029381529_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000173869295818358144510000002217078808590400160_">
								<use xlink:href="#SVGID_00000106826103082697339000000003018424839029381529_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000058547582067857533610000000801781836971940266_" points="-897.3,580 -897.3,430 -838.9,396
						-838.5,546.4 -897.3,580 					"/>
				</defs>
        <clipPath id="SVGID_00000029767158031023413790000013470840572444452488_">
					<use xlink:href="#SVGID_00000058547582067857533610000000801781836971940266_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000029767158031023413790000013470840572444452488_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000029754363056738465880000005460646334289759113_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000127737444233370620950000012814180216275598491_">
								<use xlink:href="#SVGID_00000029754363056738465880000005460646334289759113_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000065763068040104822540000018236606788619933323_" d="M-824.8,538.6v-63.4c3.7,15.3,13.7,24,27.8,24
						c7,0,15.3-2.5,24-7c29-16.6,52.6-56.8,52.6-90c0-16.6-5.8-28.2-15.8-33.6c-3.7-2.1-8.3-3.3-13.3-3.3c-7,0-15.3,2.5-24,7
						c-24.5,14.1-45.2,44.4-51,73.4c0,0.8-0.4,1.7-0.4,2.9v-60.5l164.2-94.9v-29l0,0l-1.2,180.7L-824.8,538.6"/>
				</defs>
        <clipPath id="SVGID_00000050649416342392211240000009604574820272324512_">
					<use xlink:href="#SVGID_00000065763068040104822540000018236606788619933323_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000050649416342392211240000009604574820272324512_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000173849973266887824360000004528587955019092875_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000137132323774371291160000010786943212233953676_">
								<use xlink:href="#SVGID_00000173849973266887824360000004528587955019092875_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000111149631661296168210000009248319652614783385_" d="M-838.5,546.4l-0.4-150.1l13.7-7.9V449
						c-0.8,4.6-1.2,9.1-1.2,13.7c0,4.6,0.4,8.7,1.2,12.9V539L-838.5,546.4"/>
				</defs>
        <clipPath id="SVGID_00000005263276387320863860000016469595538027668145_">
					<use xlink:href="#SVGID_00000111149631661296168210000009248319652614783385_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000005263276387320863860000016469595538027668145_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000168094812268016362800000011817223862182319779_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000142143634503558684700000006129832362976970142_">
								<use xlink:href="#SVGID_00000168094812268016362800000011817223862182319779_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000075126332824178138480000012899189890676040866_" d="M-811.1,442L-811.1,442c-0.8,4.1-1.2,8.3-1.2,12
						c0,17,8.7,26.9,21.1,26.9c5.4,0,11.2-1.7,17.4-5.4c21.1-12,38.6-41.5,38.6-65.5c0-12-4.6-20.7-11.6-24.5l-12.4,21.1
						c3.7,2.1,6.2,6.6,6.2,13.3c0,12.9-9.5,29-20.7,35.7c-3.3,2.1-6.6,2.9-9.5,2.9c-6.6,0-11.6-5.4-11.6-14.5c0-2.1,0.4-4.1,0.8-6.6
						c2.5-11.6,10.4-23.6,20.3-29c3.3-2.1,6.6-2.9,9.5-2.9c2.1,0,3.7,0.4,5.4,1.2l12.4-21.1c-2.9-1.7-6.2-2.5-9.9-2.5
						c-5.4,0-11.2,1.7-17.4,5.4C-791.6,398.9-806.5,420.8-811.1,442 M-796.2,495.5c-16.2,0-27.4-12.9-27.4-34.4
						c0-5,0.4-10.4,1.7-15.8c5.8-27.4,25.3-56,48.1-69.2c8.3-4.6,15.8-6.6,22.4-6.6c4.6,0,9.1,1.2,12.4,2.9
						c9.1,5,14.9,15.8,14.9,31.5c0,31.1-22.4,69.2-49.7,85C-781.7,493-789.5,495.5-796.2,495.5"/>
				</defs>
        <clipPath id="SVGID_00000046319206735059465810000008484548815742868890_">
					<use xlink:href="#SVGID_00000075126332824178138480000012899189890676040866_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000046319206735059465810000008484548815742868890_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000061429537539063934350000002262836745452511129_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000083789834676128883910000014469470826467006379_">
								<use xlink:href="#SVGID_00000061429537539063934350000002262836745452511129_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000105402573333584427670000011093528318469085875_" points="-661,264.1 -897.3,400.1 -904,397.2
						-669.7,264.1 -661,264.1 					"/>
				</defs>
        <clipPath id="SVGID_00000094619544236568994680000014559521730166325395_">
					<use xlink:href="#SVGID_00000105402573333584427670000011093528318469085875_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000094619544236568994680000014559521730166325395_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000031167133906461915730000012797191982629369266_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000024715233735994605370000012203398762890579602_">
								<use xlink:href="#SVGID_00000031167133906461915730000012797191982629369266_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000042007223233386922780000015992059278576121523_" points="-904,397.2 -903.5,575.9 -897.3,580
						-897.3,400.1 -904,397.2 					"/>
				</defs>
        <clipPath id="SVGID_00000164504896675674479260000011679842366867342776_">
					<use xlink:href="#SVGID_00000042007223233386922780000015992059278576121523_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000164504896675674479260000011679842366867342776_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000037673279035336472660000003236356517089540009_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000081627661413694793470000003088083454968691605_">
								<use xlink:href="#SVGID_00000037673279035336472660000003236356517089540009_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000158023946261626053160000001893582269174358459_" d="M-751,369c-6.6,0-14.5,2.1-22.4,6.6
						c-23.2,13.3-42.3,41.9-48.1,69.2c-1.2,5.4-1.7,10.4-1.7,15.8c0,22,11.2,34.4,27.4,34.4c6.6,0,14.5-2.1,22.4-6.6
						c27.4-15.8,49.7-53.9,49.7-85c0-15.8-5.8-26.5-14.9-31.5C-742.3,369.8-746.4,369-751,369 M-797.4,499.2c-13.7,0-24-8.7-27.8-24
						v-26.5c0-0.8,0.4-1.7,0.4-2.9c6.2-29,26.5-59.3,51-73.4c8.7-5,16.6-7,24-7c5,0,9.5,1.2,13.3,3.3c9.5,5.4,15.8,17,15.8,33.6
						c0,32.8-23.6,73.4-52.6,90C-782.1,496.7-790.4,499.2-797.4,499.2"/>
				</defs>
        <clipPath id="SVGID_00000106853728842904483780000005376628285823423156_">
					<use xlink:href="#SVGID_00000158023946261626053160000001893582269174358459_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000106853728842904483780000005376628285823423156_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000153683108642558014540000013623474544622901671_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000085955341845675634820000009005322242028753581_">
								<use xlink:href="#SVGID_00000153683108642558014540000013623474544622901671_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000013893244147556842320000002795340662389281930_" d="M-825.2,475.1c-0.8-3.7-1.2-7.9-1.2-12.9
						c0-4.6,0.4-9.1,1.2-13.7V475.1"/>
				</defs>
        <clipPath id="SVGID_00000139995134147107881080000009988061466383300244_">
					<use xlink:href="#SVGID_00000013893244147556842320000002795340662389281930_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000139995134147107881080000009988061466383300244_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000145738825998770632150000004417572079850012829_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000101094371543674665780000010139705234367978132_">
								<use xlink:href="#SVGID_00000145738825998770632150000004417572079850012829_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000011716119586443303160000015612851637811038095_" d="M-773.8,408.4v-19.9c6.2-3.7,12-5.4,17.4-5.4
						c3.7,0,7,0.8,9.9,2.5l-12.4,21.1c-1.7-0.8-3.3-1.2-5.4-1.2C-767.2,405.5-770.1,406.7-773.8,408.4"/>
				</defs>
        <use xlink:href="#SVGID_00000011716119586443303160000015612851637811038095_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000041986958634481713960000009020635629102203037_">
					<use xlink:href="#SVGID_00000011716119586443303160000015612851637811038095_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000041986958634481713960000009020635629102203037_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000132054115909310493740000002442648322848845212_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000132054115909310493740000002442648322848845212_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000000222110284263972880000006057526030682050704_">
								<use xlink:href="#SVGID_00000132054115909310493740000002442648322848845212_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000054234598749035628770000017766535478418778535_" d="M-791.2,480.9c-12.4,0-21.1-9.9-21.1-26.9
						c0-3.7,0.4-7.9,1.2-12l17-4.6c-0.4,2.1-0.8,4.6-0.8,6.6c0,9.1,4.6,14.5,11.6,14.5c2.9,0,6.2-0.8,9.5-2.9
						c11.6-6.6,20.7-22.4,20.7-35.7c0-6.6-2.5-11.2-6.2-13.3l12.4-21.1c7,3.7,11.6,12.4,11.6,24.5c0,24-17.4,53.5-38.6,65.5
						C-780,479.3-785.8,480.9-791.2,480.9"/>
				</defs>
        <clipPath id="SVGID_00000075150013933083749320000005613973153286344621_">
					<use xlink:href="#SVGID_00000054234598749035628770000017766535478418778535_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000075150013933083749320000005613973153286344621_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000076581882981080606300000008803768705063801011_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000170960763796750414320000009355018022717440913_">
								<use xlink:href="#SVGID_00000076581882981080606300000008803768705063801011_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000136375782020606718010000001287379129599695283_" d="M-811.1,442c4.6-21.1,19.5-43.5,37.3-53.5v19.9
						c-9.5,5.4-17.8,17.4-20.3,29L-811.1,442"/>
				</defs>
        <clipPath id="SVGID_00000119105734954090427010000010097215507052604059_">
					<use xlink:href="#SVGID_00000136375782020606718010000001287379129599695283_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000119105734954090427010000010097215507052604059_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000069371074988118648740000009954314288367669678_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000012472813479584233320000013648451777071940259_">
								<use xlink:href="#SVGID_00000069371074988118648740000009954314288367669678_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000177445683757046827250000000128760754927219622_" points="-661,264.1 -661.4,264.1 -661,264.1
						-661,264.1 					"/>
				</defs>
        <clipPath id="SVGID_00000172439373221261181280000008330533907862411683_">
					<use xlink:href="#SVGID_00000177445683757046827250000000128760754927219622_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000172439373221261181280000008330533907862411683_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000035523220409280540790000011428738070669601688_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000139285034914167812070000007742550839239079811_">
								<use xlink:href="#SVGID_00000035523220409280540790000011428738070669601688_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000033339847220243777220000003043996884573639342_" points="-897.3,430 -897.3,400.1 -839.3,366.5
						-838.9,396 -897.3,430 					"/>
				</defs>
        <use xlink:href="#SVGID_00000033339847220243777220000003043996884573639342_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000129199056606887804430000017522210135052947626_">
					<use xlink:href="#SVGID_00000033339847220243777220000003043996884573639342_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000129199056606887804430000017522210135052947626_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000000920048614948497610000015701597462501975462_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000000920048614948497610000015701597462501975462_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000033356103737519868290000001866814999800765086_">
								<use xlink:href="#SVGID_00000000920048614948497610000015701597462501975462_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000171707781599356819400000011758157982144634507_" d="M-677.6,286.5c-0.4,0-1.2,0-1.7,0.4
						c-1.7,0.8-3.3,2.9-3.7,5c0,0.4,0,0.8,0,1.2c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2
						c0-1.2-0.4-2.1-1.2-2.5C-676.8,286.5-677.2,286.5-677.6,286.5 M-689.6,294c-0.4,0-1.2,0-1.7,0.4c-1.7,0.8-3.3,2.9-3.7,5
						c0,0.4,0,0.8,0,1.2c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2c0-1.2-0.4-2.1-1.2-2.5
						C-689.2,294-689.2,294-689.6,294 M-702.1,300.6c-0.4,0-1.2,0-1.7,0.4c-1.7,0.8-3.3,2.9-3.7,5c0,0.4,0,0.8,0,1.2
						c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2c0-1.2-0.4-2.1-1.2-2.5
						C-701.2,301-701.7,300.6-702.1,300.6 M-825.2,388.1v-29.4l164.2-94.5v29L-825.2,388.1"/>
				</defs>
        <use xlink:href="#SVGID_00000171707781599356819400000011758157982144634507_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000175299515259931472300000015252994368208197549_">
					<use xlink:href="#SVGID_00000171707781599356819400000011758157982144634507_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000175299515259931472300000015252994368208197549_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000091695795299866351280000016172040305364067510_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000091695795299866351280000016172040305364067510_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000098184262810689195470000000954919128040412056_">
								<use xlink:href="#SVGID_00000091695795299866351280000016172040305364067510_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000115474306183175295490000000400954498110931346_" points="-838.9,396 -839.3,366.5 -825.2,358.7
						-825.2,388.1 -838.9,396 					"/>
				</defs>
        <use xlink:href="#SVGID_00000115474306183175295490000000400954498110931346_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000119084912583471931490000017050946599085372841_">
					<use xlink:href="#SVGID_00000115474306183175295490000000400954498110931346_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000119084912583471931490000017050946599085372841_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000116929653856198703240000008000964958129087150_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000116929653856198703240000008000964958129087150_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000117666571745392577810000008867307997962404249_">
								<use xlink:href="#SVGID_00000116929653856198703240000008000964958129087150_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000026159958431366592350000005020327141077414335_" points="-897.3,400.1 -661.4,264.1 -661,264.1
						-661,264.1 -825.2,358.7 -897.3,400.1 					"/>
				</defs>
        <use xlink:href="#SVGID_00000026159958431366592350000005020327141077414335_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000034072684805428046220000017366898811948628395_">
					<use xlink:href="#SVGID_00000026159958431366592350000005020327141077414335_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000034072684805428046220000017366898811948628395_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000046315116343412287290000011609511449421304458_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000046315116343412287290000011609511449421304458_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000141429964060569094980000010136219493287561389_">
								<use xlink:href="#SVGID_00000046315116343412287290000011609511449421304458_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000094601872618512930120000016776565137840656794_" points="-897.3,430 -897.3,400.1 -897.3,430
						"/>
				</defs>
        <clipPath id="SVGID_00000052091593083376935520000017321275740049058986_">
					<use xlink:href="#SVGID_00000094601872618512930120000016776565137840656794_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000052091593083376935520000017321275740049058986_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000119085341463906238850000001107866079196272055_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000018956319587441841930000016449677034823571110_">
								<use xlink:href="#SVGID_00000119085341463906238850000001107866079196272055_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000015312994727602884990000001810154325512115131_" d="M-705.4,310.1c-1.2,0-2.1-0.8-2.1-2.5
						c0-0.4,0-0.8,0-1.2c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4c0.4,0,0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5
						c0,2.5-1.7,5-3.7,6.2C-704.1,310.1-705,310.1-705.4,310.1"/>
				</defs>
        <clipPath id="SVGID_00000037686047352265666730000017701759381707817126_">
					<use xlink:href="#SVGID_00000015312994727602884990000001810154325512115131_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000037686047352265666730000017701759381707817126_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000051367103754744748810000012251184412604587654_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000160172432932585393580000013238091922468176025_">
								<use xlink:href="#SVGID_00000051367103754744748810000012251184412604587654_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000122718193510080035710000001433058362368874894_" d="M-693,303.1c-1.2,0-2.1-0.8-2.1-2.5
						c0-0.4,0-0.8,0-1.2c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4s0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2
						C-692.1,303.1-692.5,303.1-693,303.1"/>
				</defs>
        <clipPath id="SVGID_00000084489171503715918760000015930083884416395697_">
					<use xlink:href="#SVGID_00000122718193510080035710000001433058362368874894_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000084489171503715918760000015930083884416395697_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000093891689806508379160000016554242036385061048_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000074400233844560567890000007008994785660957838_">
								<use xlink:href="#SVGID_00000093891689806508379160000016554242036385061048_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000006688466329303989210000012724610045397050782_" d="M-680.9,295.6c-1.2,0-2.1-0.8-2.1-2.5
						c0-0.4,0-0.8,0-1.2c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4s0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2
						C-679.7,295.6-680.1,295.6-680.9,295.6"/>
				</defs>
        <clipPath id="SVGID_00000093174940233186007080000010238677871331255936_">
					<use xlink:href="#SVGID_00000006688466329303989210000012724610045397050782_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000093174940233186007080000010238677871331255936_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000041984223061172475640000013440801445027385534_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000012434787617915942650000009748928197153747876_">
								<use xlink:href="#SVGID_00000041984223061172475640000013440801445027385534_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000000927688390849245790000002154661138173273778_" points="-176,456.1 -355.5,484.7 -321.5,511.6
						-176,456.1 					"/>
				</defs>
        <clipPath id="SVGID_00000015337252842804679880000011991679395967290008_">
					<use xlink:href="#SVGID_00000000927688390849245790000002154661138173273778_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000015337252842804679880000011991679395967290008_);">
					<g>
						<g>

								<rect id="SVGID_00000008125393495697715560000012279838439139711626_" x="-1292" y="-84.9" class="st384"
                      width="1504" height="1002.4"/>
						</g>
            <g>
							<defs>
								<rect id="SVGID_00000116223369340291672020000014306671513171433607_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000114787742377676241280000011272138286998380446_">
								<use xlink:href="#SVGID_00000116223369340291672020000014306671513171433607_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000106126178830944855980000008929153710657128374_" points="-321.5,511.6 -329.4,546.4 -281.7,519.9
						-176,456.1 -321.5,511.6 					"/>
				</defs>
        <use xlink:href="#SVGID_00000106126178830944855980000008929153710657128374_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000158749034455511969940000008315911493437573276_">
					<use xlink:href="#SVGID_00000106126178830944855980000008929153710657128374_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000158749034455511969940000008315911493437573276_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000052066055636462850280000017444663965023815302_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000052066055636462850280000017444663965023815302_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000167398283329959895480000013876572890249484444_">
								<use xlink:href="#SVGID_00000052066055636462850280000017444663965023815302_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000019650786377432818360000010625706143586391195_" points="-176,456.1 -266.8,559.7 -303.3,529
						-176,456.1 					"/>
				</defs>
        <clipPath id="SVGID_00000060021615542162299190000010873908536331522182_">
					<use xlink:href="#SVGID_00000019650786377432818360000010625706143586391195_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000060021615542162299190000010873908536331522182_);">
					<g>
						<g>

								<rect id="SVGID_00000057857180248773200100000018408175993939612544_" x="-1292" y="-84.9" class="st384"
                      width="1504" height="1002.4"/>
						</g>
            <g>
							<defs>
								<rect id="SVGID_00000132066714265275621470000002343526655132789405_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000026128825284249247130000015334853376294277821_">
								<use xlink:href="#SVGID_00000132066714265275621470000002343526655132789405_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000151543105162553174050000001816661063267753605_" points="-297.5,534 -329.4,546.4 -303.3,529
						-297.5,534 					"/>
				</defs>
        <use xlink:href="#SVGID_00000151543105162553174050000001816661063267753605_"
             style="overflow:visible;fill:#3E3F6F;"/>
        <clipPath id="SVGID_00000009558217681513458380000013543453659987464336_">
					<use xlink:href="#SVGID_00000151543105162553174050000001816661063267753605_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000009558217681513458380000013543453659987464336_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000039107466173714340500000008077107633323420564_" x="-1292" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000039107466173714340500000008077107633323420564_"
                   style="overflow:visible;fill:#3E3F6F;"/>
              <clipPath id="SVGID_00000149382455229819047360000016649454531245691025_">
								<use xlink:href="#SVGID_00000039107466173714340500000008077107633323420564_" style="overflow:visible;"/>
							</clipPath>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
            <g>
	<g>
		<g>
			<path class="st401" d="M299,616.9L299,616.9c1.2-0.9,2.5-1.7,3.9-2.5l427.7-246.9c17.4-10.1,45.7-10.1,63.1,0l192.7,111.2
				c8.2,4.8,12.6,10.9,13,17.1c4.6,15.7-0.5,38-13,45.2L558.5,787.9c-17.4,10.1-45.7,10.1-63.1,0L302.8,676.7
				C285.4,666.6,281.5,626.9,299,616.9z"/>
      <g>
				<path class="st402" d="M287.1,623.6l192.7,111.2c17.4,10.1,45.7,10.1,63.1,0l427.7-246.9c17.4-10.1,20.4-49.3,3-59.4
					L763.5,320.1c-17.4-10.1-43.6-0.8-61,9.3L283.9,563.9C266.5,574,269.6,613.6,287.1,623.6z"/>
        <path class="st403" d="M287.1,597.7l192.7,111.2c17.4,10.1,45.7,10.1,63.1,0L970.4,462c17.4-10.1,17.4-26.4,0-36.4L777.8,314.4
					c-17.4-10.1-45.7-10.1-63.1,0L287.1,561.3C269.6,571.3,269.6,587.6,287.1,597.7z"/>
        <path class="st403" d="M287.1,597.7l192.7,111.2c17.4,10.1,45.7,10.1,63.1,0L970.4,462c17.4-10.1,17.4-26.4,0-36.4L777.8,314.4
					c-17.4-10.1-45.7-10.1-63.1,0L287.1,561.3C269.6,571.3,269.6,587.6,287.1,597.7z"/>
        <path class="st404" d="M287.1,597.7l192.7,111.2c17.4,10.1,45.7,10.1,63.1,0L970.4,462c17.4-10.1,17.4-26.4,0-36.4L777.8,314.4
					c-17.4-10.1-45.7-10.1-63.1,0L287.1,561.3C269.6,571.3,269.6,587.6,287.1,597.7z"/>
        <path class="st405" d="M287.1,592.5l192.7,111.2c17.4,10.1,45.7,10.1,63.1,0l427.7-246.9c7.9-4.6,11.5-10.5,12.2-16.5
					c0.8,7.2-2.7,14.5-12.2,20L542.8,707.2c-17.4,10.1-45.7,10.1-63.1,0L287.1,596c-9.5-5.5-13.1-12.8-12.2-20
					C275.5,582,279.1,587.9,287.1,592.5z"/>
        <polygon class="st406" points="317.5,553.5 556.3,691.3 960.5,458 721.7,320.1 				"/>
        <polygon class="st407"
                 points="721.7,320.8 318.1,553.8 317.5,553.4 721.7,320.1 960.5,457.9 959.9,458.3 				"/>
        <g>
					<path class="st405" d="M816.7,362.8l50.7,29.3c2.2,1.3,5.8,1.3,8.1,0l0,0c2.2-1.3,2.2-3.4,0-4.7l-50.7-29.3
						c-2.2-1.3-5.8-1.3-8.1,0l0,0C814.5,359.4,814.5,361.5,816.7,362.8z"/>
          <path class="st408" d="M875.5,388.1l-50.7-29.3c-2.2-1.3-5.8-1.3-8.1,0c-1,0.6-1.5,1.2-1.6,2c-0.2-1,0.3-2,1.6-2.7
						c2.2-1.3,5.8-1.3,8.1,0l50.7,29.3c1.3,0.7,1.8,1.7,1.6,2.7C876.9,389.3,876.4,388.6,875.5,388.1z"/>
          <g>
						<path class="st405" d="M884.1,396.3c-2.9,1.7-2.9,4.3,0,6c2.9,1.7,7.5,1.7,10.4,0c2.9-1.7,2.9-4.3,0-6
							C891.6,394.6,887,394.6,884.1,396.3z"/>
            <path class="st408" d="M894.5,396.7c-2.9-1.7-7.5-1.7-10.4,0c-1.3,0.8-2,1.8-2.1,2.8c-0.1-1.2,0.6-2.3,2.1-3.2
							c2.9-1.7,7.5-1.7,10.4,0c1.5,0.9,2.2,2.1,2.1,3.2C896.5,398.5,895.8,397.5,894.5,396.7z"/>
					</g>
				</g>
        <polygon class="st408" points="372.8,664.1 388.8,673.4 388.8,665.9 372.8,656.6 				"/>
        <path class="st409" d="M519.9,716.9V741c-4.2,0.5-8.2,0.6-12.1,0.5v-24.1C511.8,717.5,515.9,717.4,519.9,716.9z"/>
        <polygon class="st409" points="522.9,716.9 522.9,740.3 527.1,739.4 527.1,716.2 				"/>
        <polygon class="st409" points="499.6,717.1 499.6,740.7 503.8,741.3 503.8,717.4 				"/>
			</g>
		</g>
    <g>
			<g>
				<path class="st410" d="M956.6,331.6L800,241.2c-2.8-1.6-7.4-1.6-10.3,0L314.8,515.4c-1.4,0.8-2.1,1.9-2.1,3v20.3h0
					c0,1.1,0.7,2.2,2.1,3l156.6,90.4c2.8,1.6,7.4,1.6,10.3,0l474.8-274.2c1.4-0.8,2.1-1.8,2.1-2.9h0v-20.3h0
					C958.7,333.6,958,332.5,956.6,331.6z"/>
        <g>
					<g>
						<g>
							<path class="st411" d="M788.9,241.2L314.8,514.9c-2.8,1.6-2.8,4.3,0,5.9l156.3,90.3c2.8,1.6,7.4,1.6,10.3,0l474.1-273.7
								c2.8-1.6,2.8-4.3,0-5.9l-156.3-90.3C796.3,239.5,791.7,239.5,788.9,241.2z"/>
						</g>
					</g>
          <g>

							<linearGradient id="SVGID_00000124136252041593491270000016227446452494112913_"
                              gradientUnits="userSpaceOnUse" x1="456.7545" y1="443.2141" x2="958.6824" y2="443.2141">
							<stop offset="0" style="stop-color:#6B59A6"/>
                <stop offset="0.1686" style="stop-color:#685FA5"/>
                <stop offset="0.4055" style="stop-color:#6172A2"/>
                <stop offset="0.683" style="stop-color:#55909E"/>
                <stop offset="0.9891" style="stop-color:#45B998"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000124136252041593491270000016227446452494112913_);" d="M856.4,273.9l100.2,57.8
							c2.8,1.6,2.8,4.3,0,5.9L482.5,611.3c-2.8,1.6-7.4,1.6-10.3,0l-8.7-5c-15.2-41.4-3-63.7,17.5-76c34.5-20.8,80.6-8,118.4-29.9
							c44.3-25.7,8.2-59.2,53.9-85.7c36.5-21.1,71.6-6,104.3-26.2c43.9-27.1,3.8-68.3,53.2-98.4
							C826.4,280.8,844.5,276.2,856.4,273.9z"/>
					</g>
          <g>
						<g>
							<polygon class="st406" points="515.2,592.5 514.2,593.1 453.9,558.3 454.9,557.7 							"/>
						</g>
            <g>
							<polygon class="st406" points="482.6,568.8 473.1,574.3 441.2,555.8 450.7,550.3 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="552.4,571 551.4,571.6 476.6,528.3 477.6,527.8 							"/>
						</g>
            <g>
							<polygon class="st406" points="502.2,537.1 492.7,542.5 460.7,524.1 470.2,518.6 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="589.7,549.5 588.7,550 529.3,515.8 530.3,515.2 							"/>
						</g>
            <g>
							<polygon class="st406" points="556.1,525.2 546.6,530.7 514.6,512.2 524.2,506.7 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="627,527.9 625.9,528.5 586.2,505.6 587.2,505 							"/>
						</g>
            <g>
							<polygon class="st406" points="615.7,516.5 606.2,522 574.2,503.6 583.7,498.1 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="664.2,506.4 663.2,507 617.3,480.6 618.4,480 							"/>
						</g>
            <g>
							<polygon class="st406" points="646.1,491.1 636.6,496.6 604.6,478.1 614.2,472.6 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="701.5,484.9 700.4,485.5 626.2,442.7 627.2,442.1 							"/>
						</g>
            <g>
							<polygon class="st406" points="652.9,452 643.4,457.5 611.4,439 621,433.5 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="738.7,463.4 737.7,464 650,413.4 651,412.8 							"/>
						</g>
            <g>
							<polygon class="st406" points="674.2,421.3 664.7,426.8 632.7,408.3 642.2,402.8 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="776,441.9 774.9,442.5 702.4,400.6 703.4,400 							"/>
						</g>
            <g>
							<polygon class="st406" points="727.4,409 717.9,414.5 686,396 695.5,390.5 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="813.2,420.4 812.2,421 755,387.9 756,387.3 							"/>
						</g>
            <g>
							<polygon class="st406" points="782.5,397.8 773,403.3 741.1,384.8 750.6,379.3 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="850.5,398.9 849.5,399.5 776.9,357.6 777.9,357 							"/>
						</g>
            <g>
							<polygon class="st406" points="804.5,367.4 795,372.9 763,354.5 772.5,349 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="887.7,377.4 886.7,378 775.5,313.8 776.5,313.2 							"/>
						</g>
            <g>
							<polygon class="st406" points="805.3,324.9 795.8,330.4 763.8,311.9 773.3,306.4 							"/>
						</g>
					</g>
          <g>
						<g>
							<polygon class="st406" points="925,355.9 924,356.4 809.2,290.2 810.3,289.6 							"/>
						</g>
            <g>
							<polygon class="st406" points="831.3,296.9 821.8,302.3 789.8,283.9 799.3,278.4 							"/>
						</g>
					</g>
          <g>
						<path class="st406" d="M605.8,388.3l5,10.9c0.1,0.3,0.5,0.4,0.8,0.3l13.8-7.9c0.5-0.3,0.4-1-0.2-1.1l-18.8-2.9
							C606,387.4,605.6,387.8,605.8,388.3z"/>
					</g>
          <g>
						<g>
							<path class="st406" d="M681.7,356.5l-41.8,24.1c-2.6,1.5-6.7,1.5-9.3,0l0,0c-2.6-1.5-2.6-3.9,0-5.4l41.8-24.1
								c2.6-1.5,6.7-1.5,9.3,0l0,0C684.2,352.6,684.2,355,681.7,356.5z"/>
						</g>
					</g>
          <g>
						<path class="st413" d="M382,501.5l-33.2,19.2c-3.2,1.9-8.5,1.9-11.8,0l0,0c-3.2-1.9-3.2-4.9,0-6.8l33.2-19.2
							c3.2-1.9,8.5-1.9,11.8,0l0,0C385.3,496.6,385.3,499.6,382,501.5z"/>
					</g>
          <g>
						<path class="st406" d="M484.3,442.4l-33.2,19.2c-3.2,1.9-8.5,1.9-11.8,0l0,0c-3.2-1.9-3.2-4.9,0-6.8l33.2-19.2
							c3.2-1.9,8.5-1.9,11.8,0l0,0C487.5,437.5,487.5,440.6,484.3,442.4z"/>
					</g>
          <g>
						<g>

								<linearGradient id="SVGID_00000043420021806641709160000005187923567701825954_"
                                gradientUnits="userSpaceOnUse" x1="385.774" y1="478.1437" x2="435.6056" y2="478.1437">
								<stop offset="0" style="stop-color:#166250"/>
                  <stop offset="0.1797" style="stop-color:#196955"/>
                  <stop offset="0.4323" style="stop-color:#237B64"/>
                  <stop offset="0.7265" style="stop-color:#32997C"/>
                  <stop offset="1" style="stop-color:#44BB98"/>
							</linearGradient>
              <path style="fill:url(#SVGID_00000043420021806641709160000005187923567701825954_);" d="M433.2,472L400,491.1
								c-3.2,1.9-8.5,1.9-11.8,0l0,0c-3.2-1.9-3.2-4.9,0-6.8l33.2-19.2c3.2-1.9,8.5-1.9,11.8,0l0,0C436.4,467,436.4,470.1,433.2,472
								z"/>
						</g>
            <g>
							<path class="st415" d="M393.2,485.4l1.7-1l5.6,1.4l-2.4-3.2l1.7-1l5.8,3.3l-1.4,0.8l-3.5-2l2.2,2.7l-1.1,0.7l-4.8-1.3l3.5,2
								l-1.4,0.8L393.2,485.4z"/>
              <path class="st415" d="M409.3,482.8c-1.6,0.9-4.2,1-5.9,0c-1.7-1-1.6-2.5,0-3.4c1.6-0.9,4.2-1,5.9,0
								C411,480.4,410.9,481.8,409.3,482.8z M408,482.1c0.9-0.5,0.9-1.3-0.2-1.8c-1-0.6-2.3-0.6-3.2-0.1c-0.9,0.5-0.9,1.3,0.1,1.8
								C405.8,482.6,407,482.6,408,482.1z"/>
              <path class="st415" d="M412.3,474.3l5.8,3.3l-1.4,0.8l-5.9-0.7l3.6,2.1l-1.4,0.8l-5.8-3.3l1.4-0.8l5.9,0.7l-3.6-2.1
								L412.3,474.3z"/>
              <path class="st415"
                    d="M413,473.9l4.5-2.6l1.1,0.6l-1.5,0.9l4.6,2.7l-1.4,0.8l-4.6-2.7l-1.5,0.9L413,473.9z"/>
              <path class="st415" d="M425.2,470.8l-2.2,1.3l2.4,1.4l-1.4,0.8l-5.8-3.3l1.4-0.8l2.3,1.3l2.2-1.3l-2.3-1.3l1.4-0.8l5.8,3.3
								l-1.4,0.8L425.2,470.8z"/>
						</g>
					</g>
				</g>
        <g>
					<path class="st415"
                d="M346.4,512.3l1.6-0.9l3.5,0.7l-1.3-2l1.6-0.9l1.9,3.4l1.9,1.1l-1.4,0.8l-1.9-1.1L346.4,512.3z"/>
          <path class="st415" d="M357,507.5l-2.1,1.2l1.2,0.7l1.9-1.1l1.1,0.6l-1.9,1.1l1.3,0.7l2.1-1.2l1.1,0.6l-3.5,2l-5.8-3.3l3.5-2
						L357,507.5z"/>
          <path class="st415" d="M365.1,507l-2.2,1.2l0.7,0.8l-1.5,0.8l-3.7-4.5l1.6-0.9l7.8,2.1l-1.5,0.9L365.1,507z M360.8,505.8
						l1.4,1.6l1.4-0.8L360.8,505.8z"/>
          <path class="st415" d="M365.2,501.4c1.4-0.8,2.9-0.8,3.9-0.2c0.7,0.4,1,1,0.4,1.7l3.6,0.5l-1.6,0.9l-3.4-0.6l-0.3,0.2l2.2,1.3
						l-1.4,0.8l-5.8-3.3L365.2,501.4z M366.3,502.2l-0.9,0.5l1.4,0.8l0.9-0.5c0.5-0.3,0.5-0.6,0-0.9
						C367.3,501.9,366.8,501.9,366.3,502.2z"/>
				</g>
        <g>
					<path class="st415" d="M459,450.6c1.7,1,1.7,2.3-0.1,3.4l-2.2,1.2l-5.8-3.3l2.2-1.2C455,449.6,457.3,449.6,459,450.6z
						 M457.6,453.3c1.1-0.6,1.1-1.3,0-1.9c-1.1-0.6-2.3-0.6-3.4,0l-0.7,0.4l3.3,1.9L457.6,453.3z"/>
          <path class="st415" d="M465.3,449.1l-2.2,1.2l0.7,0.8l-1.5,0.8l-3.7-4.5l1.6-0.9l7.8,2.1l-1.5,0.9L465.3,449.1z M461,447.9
						l1.4,1.6l1.4-0.8L461,447.9z"/>
          <path class="st415"
                d="M462.6,445.2l1.6-0.9l3.5,0.7l-1.3-2l1.6-0.9l1.9,3.4l1.9,1.1l-1.4,0.8l-1.9-1.1L462.6,445.2z"/>
				</g>
        <g>
					<g>
						<g>
							<path class="st415" d="M681.7,356.5l-41.8,24.1c-2.6,1.5-6.7,1.5-9.3,0l0,0c-2.6-1.5-2.6-3.9,0-5.4l41.8-24.1
								c2.6-1.5,6.7-1.5,9.3,0l0,0C684.2,352.6,684.2,355,681.7,356.5z"/>
						</g>
					</g>
          <g>
						<g>
							<path class="st416" d="M636.8,378.9c-0.9,0.5-2.3,0.5-3.1,0c-0.9-0.5-0.9-1.3,0-1.8l41.8-24.1c0.9-0.5,2.3-0.5,3.1,0
								c0.9,0.5,0.9,1.3,0,1.8L636.8,378.9z"/>
						</g>
					</g>
				</g>
			</g>
      <g>
				<g>
					<g id="XMLID_00000158013763437765028430000017949829256753804734_">
						<g>
							<g class="st417">
								<g class="st417">
									<defs>
										<path id="SVGID_00000015322331415918913930000003792911833280657332_" class="st417" d="M692.8,105.2l-3.6-1.9
											c11.9-1.7,21.9-0.5,22.4-0.5l3.6,1.9C714.7,104.7,704.7,103.5,692.8,105.2z"/>
									</defs>
                  <clipPath id="SVGID_00000142150700194832011340000000736219748667212172_">
										<use xlink:href="#SVGID_00000015322331415918913930000003792911833280657332_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000142150700194832011340000000736219748667212172_);enable-background:new    ;">
										<path class="st419"
                          d="M692.8,105.2l-3.6-1.9c11.9-1.7,21.9-0.5,22.4-0.5l3.6,1.9C714.7,104.7,704.7,103.5,692.8,105.2"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000178198392590652591850000014916882030386186139_" class="st417" d="M534.1,368.9l-3.6-1.9
											c-0.1-0.1-0.2-0.1-0.3-0.2l3.6,1.9C533.8,368.8,533.9,368.9,534.1,368.9z"/>
									</defs>
                  <clipPath id="SVGID_00000154395795318228438450000013006768905366913944_">
										<use xlink:href="#SVGID_00000178198392590652591850000014916882030386186139_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000154395795318228438450000013006768905366913944_);enable-background:new    ;">
										<path class="st421"
                          d="M534.1,368.9l-3.6-1.9c-0.1-0.1-0.2-0.1-0.3-0.2l3.6,1.9C533.8,368.8,533.9,368.9,534.1,368.9"/>
									</g>
								</g>
                <g>
									<path class="st422" d="M692.8,105.2c11.9-1.7,21.9-0.5,22.4-0.5l124.6,87.8c1.4,1,1.2,2.6-0.5,3.6l-300,172.7
										c-0.6,0.3-1.3,0.5-1.9,0.6c-1.3,0.2-2.7-0.1-3.7-0.7l-52.6-37.1c22.4-23.3,42.6-34.9,58-41.3c7.2-3,24.8-10.6,37.1-24.1
										c4.3-4.6,7.3-10.4,8.7-18.1c4.2-24.3-0.8-31.7,32.4-49.9s40.4-29.8,42.2-64.7C660.5,114,677.7,107.3,692.8,105.2z"/>
								</g>
                <g>
									<polygon class="st423" points="533.7,368.7 530.1,366.8 477.5,329.7 481.1,331.6 									"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000051360939526384092190000002395464900485037978_" class="st417" d="M481.1,331.6l-3.6-1.9
											c22.4-23.3,42.6-34.9,58-41.3c7.2-3,24.8-10.6,37.1-24.1c4.3-4.6,7.3-10.4,8.7-18.1c4.2-24.3-0.8-31.7,32.4-49.9
											s40.4-29.8,42.2-64.7c1-19.5,18.2-26.2,33.3-28.3l3.6,1.9c-15.1,2.1-32.3,8.8-33.3,28.3c-1.7,34.9-8.9,46.5-42.2,64.7
											s-28.2,25.7-32.4,49.9c-1.3,7.8-4.4,13.5-8.7,18.1c-12.3,13.4-29.9,21.1-37.1,24.1C523.7,296.7,503.5,308.4,481.1,331.6z"
                    />
									</defs>
                  <clipPath id="SVGID_00000079449473033845243680000009233442041108989315_">
										<use xlink:href="#SVGID_00000051360939526384092190000002395464900485037978_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000079449473033845243680000009233442041108989315_);enable-background:new    ;">
										<path class="st425"
                          d="M481.1,331.6l-3.6-1.9c3.9-4.1,7.8-7.8,11.6-11.2l3.6,1.9C488.9,323.8,485,327.6,481.1,331.6"/>
                    <path class="st426"
                          d="M492.7,320.4l-3.6-1.9c6.5-5.9,12.8-10.8,18.7-14.9l3.6,1.9C505.5,309.7,499.2,314.6,492.7,320.4"
                    />
                    <path class="st427"
                          d="M511.4,305.5l-3.6-1.9c7.8-5.4,15.1-9.5,21.7-12.6l3.6,1.9C526.5,296.1,519.2,300.1,511.4,305.5"/>
                    <path class="st419" d="M533.1,293l-3.6-1.9c2.1-1,4.1-1.9,6-2.7c1.8-0.7,4.2-1.8,7.1-3.1l3.6,1.9
											c-2.9,1.3-5.3,2.4-7.1,3.1C537.2,291.1,535.2,292,533.1,293"/>
                    <path class="st427"
                          d="M546.2,287.2l-3.6-1.9c4.8-2.3,10.8-5.4,16.7-9.5l3.6,1.9C557,281.8,551,284.9,546.2,287.2"/>
                    <path class="st426"
                          d="M562.9,277.7l-3.6-1.9c2.9-2,5.8-4.3,8.6-6.7l3.6,1.9C568.7,273.4,565.8,275.7,562.9,277.7"/>
                    <path class="st425" d="M571.5,270.9l-3.6-1.9c1.6-1.5,3.2-3,4.7-4.7c0.2-0.2,0.3-0.3,0.5-0.5l3.6,1.9
											c-0.2,0.2-0.3,0.3-0.5,0.5C574.7,267.9,573.1,269.5,571.5,270.9"/>
                    <path class="st428"
                          d="M576.7,265.7l-3.6-1.9c0.9-1,1.7-2,2.4-3l3.6,1.9C578.4,263.8,577.6,264.8,576.7,265.7"/>
                    <path class="st429"
                          d="M579.1,262.7l-3.6-1.9c0.7-1,1.4-2.1,2-3.3l3.6,1.9C580.5,260.5,579.8,261.6,579.1,262.7"/>
                    <path class="st430"
                          d="M581.1,259.4l-3.6-1.9c0.7-1.4,1.4-2.8,2-4.4l3.6,1.9C582.5,256.6,581.9,258,581.1,259.4"/>
                    <path class="st421" d="M583.1,255l-3.6-1.9c0.8-2.1,1.4-4.4,1.8-6.9c1.9-10.8,1.9-18.3,4.3-24.9l3.6,1.9
											c-2.4,6.6-2.4,14-4.3,24.9C584.5,250.6,583.9,252.9,583.1,255"/>
                    <path class="st430"
                          d="M589.2,223.3l-3.6-1.9c0.4-1.2,0.9-2.3,1.5-3.5l3.6,1.9C590.2,221,589.7,222.1,589.2,223.3"/>
                    <path class="st429"
                          d="M590.8,219.8l-3.6-1.9c0.5-0.9,1-1.8,1.7-2.7l3.6,1.9C591.8,218,591.3,218.9,590.8,219.8"/>
                    <path class="st428"
                          d="M592.5,217.1l-3.6-1.9c0.6-0.9,1.3-1.8,2.1-2.7l3.6,1.9C593.8,215.3,593.1,216.2,592.5,217.1"/>
                    <path class="st425"
                          d="M594.6,214.4l-3.6-1.9c1-1.1,2-2.2,3.3-3.3l3.6,1.9C596.6,212.3,595.5,213.3,594.6,214.4"/>
                    <path class="st426"
                          d="M597.9,211.1l-3.6-1.9c1.8-1.6,4-3.3,6.5-5.1l3.6,1.9C601.8,207.8,599.7,209.5,597.9,211.1"/>
                    <path class="st427" d="M604.4,206.1l-3.6-1.9c3.5-2.4,7.8-5,13-7.8c6.1-3.4,11.4-6.5,15.9-9.6l3.6,1.9
											c-4.5,3.1-9.7,6.2-15.9,9.6C612.1,201.1,607.9,203.6,604.4,206.1"/>
                    <path class="st426"
                          d="M633.2,188.6l-3.6-1.9c3.1-2.2,5.9-4.3,8.3-6.5l3.6,1.9C639.1,184.3,636.4,186.5,633.2,188.6"/>
                    <path class="st425"
                          d="M641.6,182.1l-3.6-1.9c1.7-1.5,3.2-3,4.5-4.6l3.6,1.9C644.7,179.1,643.2,180.6,641.6,182.1"/>
                    <path class="st428"
                          d="M646.1,177.6l-3.6-1.9c1.2-1.3,2.2-2.7,3.2-4.1l3.6,1.9C648.3,174.9,647.3,176.3,646.1,177.6"/>
                    <path class="st429"
                          d="M649.3,173.5l-3.6-1.9c1-1.4,1.9-2.9,2.7-4.4l3.6,1.9C651.2,170.6,650.3,172.1,649.3,173.5"/>
                    <path class="st430"
                          d="M652,169.1l-3.6-1.9c1-1.9,1.9-3.9,2.7-6l3.6,1.9C653.9,165.2,653,167.2,652,169.1"/>
                    <path class="st421" d="M654.7,163.1l-3.6-1.9c2.9-7.8,4.2-17.3,4.8-29.6c0.2-3.1,0.7-5.9,1.6-8.4l3.6,1.9
											c-0.9,2.5-1.5,5.3-1.6,8.4C658.9,145.8,657.6,155.2,654.7,163.1"/>
                    <path class="st430"
                          d="M661.1,125.1l-3.6-1.9c0.4-1.1,0.9-2.2,1.4-3.2l3.6,1.9C662,122.9,661.5,124,661.1,125.1"/>
                    <path class="st429"
                          d="M662.6,121.9L659,120c0.5-0.9,1-1.7,1.5-2.4l3.6,1.9C663.5,120.3,663,121.1,662.6,121.9"/>
                    <path class="st428"
                          d="M664.1,119.5l-3.6-1.9c0.5-0.8,1.1-1.5,1.7-2.2l3.6,1.9C665.2,118,664.6,118.7,664.1,119.5"/>
                    <path class="st425"
                          d="M665.8,117.3l-3.6-1.9c0.7-0.8,1.4-1.5,2.2-2.2l3.6,1.9C667.2,115.8,666.5,116.5,665.8,117.3"/>
                    <path class="st426"
                          d="M667.9,115.1l-3.6-1.9c0.9-0.8,1.9-1.6,2.9-2.3l3.6,1.9C669.8,113.5,668.9,114.3,667.9,115.1"/>
                    <path class="st427"
                          d="M670.9,112.8l-3.6-1.9c1.6-1.1,3.4-2.1,5.2-3l3.6,1.9C674.2,110.7,672.5,111.7,670.9,112.8"/>
                    <path class="st419"
                          d="M676.1,109.9l-3.6-1.9c5.2-2.5,11.1-3.9,16.7-4.7l3.6,1.9C687.2,106,681.3,107.4,676.1,109.9"/>
									</g>
								</g>
							</g>
						</g>
					</g>
          <g class="st431">
						<g>
							<g class="st417">
								<g class="st417">
									<defs>
										<path id="SVGID_00000093156213639472783220000005960413841586126742_" class="st417" d="M768.5,153.5l-1.8-1
											c4.2-0.6,8.1-0.8,11.2-0.8l1.8,1C776.7,152.7,772.8,152.9,768.5,153.5z"/>
									</defs>
                  <clipPath id="SVGID_00000165945175742373460980000013286697572506763432_">
										<use xlink:href="#SVGID_00000093156213639472783220000005960413841586126742_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000165945175742373460980000013286697572506763432_);enable-background:new    ;">
										<path class="st433"
                          d="M768.5,153.5l-1.8-1c4.2-0.6,8.1-0.8,11.2-0.8l1.8,1C776.7,152.7,772.8,152.9,768.5,153.5"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000031203704020644561880000012500237828639107495_" class="st417" d="M742.8,165.1l-1.8-1
											c2.4-2.7,5.6-5.1,9.9-7.1c5.1-2.4,10.7-3.8,15.8-4.5l1.8,1c-5.1,0.7-10.7,2.1-15.8,4.5C748.4,160,745.2,162.4,742.8,165.1
											z"/>
									</defs>
                  <clipPath id="SVGID_00000022528612104398843250000017767621365484719769_">
										<use xlink:href="#SVGID_00000031203704020644561880000012500237828639107495_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000022528612104398843250000017767621365484719769_);enable-background:new    ;">
										<path class="st435"
                          d="M742.8,165.1l-1.8-1c0.6-0.6,1.2-1.3,1.9-1.9l1.8,1C744,163.8,743.4,164.5,742.8,165.1"/>
                    <path class="st436"
                          d="M744.7,163.2l-1.8-1c0.9-0.8,1.8-1.5,2.9-2.3l1.8,1C746.5,161.7,745.6,162.4,744.7,163.2"/>
                    <path class="st437" d="M747.6,160.9l-1.8-1c1.5-1,3.2-2,5.1-2.9c0,0,0.1,0,0.1-0.1l1.8,1c0,0-0.1,0-0.1,0.1
											C750.8,158.9,749.1,159.9,747.6,160.9"/>
                    <path class="st433"
                          d="M752.8,157.9l-1.8-1c5.1-2.4,10.6-3.7,15.7-4.4l1.8,1C763.5,154.2,757.9,155.5,752.8,157.9"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000073685581620604126930000010490639887970601135_" class="st417" d="M718.9,226.6l-1.8-1
											c22.8-17.9,10.2-42.9,22.1-59.4c0.5-0.7,1.1-1.5,1.8-2.2l1.8,1c-0.7,0.7-1.3,1.4-1.8,2.2
											C729.1,183.7,741.7,208.7,718.9,226.6z"/>
									</defs>
                  <clipPath id="SVGID_00000091705875564068311930000011002629229026792875_">
										<use xlink:href="#SVGID_00000073685581620604126930000010490639887970601135_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000091705875564068311930000011002629229026792875_);enable-background:new    ;">
										<path class="st436"
                          d="M718.9,226.6l-1.8-1c0.8-0.6,1.5-1.2,2.2-1.8l1.8,1C720.4,225.4,719.7,226,718.9,226.6"/>
                    <path class="st435"
                          d="M721.1,224.8l-1.8-1c1.2-1.1,2.2-2.1,3.2-3.2l1.8,1C723.3,222.7,722.3,223.8,721.1,224.8"/>
                    <path class="st439"
                          d="M724.3,221.6l-1.8-1c0.9-1,1.7-2.1,2.5-3.2l1.8,1C726,219.5,725.2,220.5,724.3,221.6"/>
                    <path class="st440"
                          d="M726.8,218.4l-1.8-1c0.8-1.2,1.5-2.3,2.2-3.5l1.8,1C728.3,216.1,727.6,217.3,726.8,218.4"/>
                    <path class="st441"
                          d="M729,214.9l-1.8-1c0.9-1.6,1.6-3.2,2.2-4.9l1.8,1C730.5,211.7,729.8,213.3,729,214.9"/>
                    <path class="st442"
                          d="M731.1,210l-1.8-1c4.4-12.2,2.5-25.3,6.4-36.1l1.8,1C733.6,184.7,735.6,197.8,731.1,210"/>
                    <path class="st441"
                          d="M737.5,173.9l-1.8-1c0.5-1.3,1-2.5,1.7-3.7l1.8,1C738.5,171.4,738,172.6,737.5,173.9"/>
                    <path class="st440"
                          d="M739.2,170.2l-1.8-1c0.5-1,1.1-1.9,1.8-2.9l1.8,1C740.3,168.3,739.7,169.2,739.2,170.2"/>
                    <path class="st439" d="M741,167.3l-1.8-1c0,0,0,0,0-0.1c0.4-0.6,0.8-1.1,1.3-1.7l1.8,1C741.9,166.1,741.4,166.7,741,167.3
											C741,167.3,741,167.3,741,167.3"/>
                    <path class="st435"
                          d="M742.3,165.6l-1.8-1c0.1-0.2,0.3-0.3,0.4-0.5l1.8,1C742.6,165.3,742.5,165.4,742.3,165.6"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000097463022726652159140000013681731316660170163_" class="st417" d="M649.1,255l-1.8-1
											c3.9-2.5,8.4-5.2,17.9-8.7c18.6-7,32.3-6,49.5-17.9c0.8-0.6,1.6-1.2,2.4-1.7l1.8,1c-0.7,0.6-1.5,1.2-2.4,1.7
											c-17.2,11.9-30.9,10.9-49.5,17.9C657.5,249.8,653,252.5,649.1,255z"/>
									</defs>
                  <clipPath id="SVGID_00000174592388984366680980000009619167974318019200_">
										<use xlink:href="#SVGID_00000097463022726652159140000013681731316660170163_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000174592388984366680980000009619167974318019200_);enable-background:new    ;">
										<path class="st437"
                          d="M649.1,255l-1.8-1c2.4-1.5,5-3.1,8.9-5l1.8,1C654.1,251.9,651.5,253.5,649.1,255"/>
                    <path class="st433" d="M658,250l-1.8-1c2.4-1.1,5.4-2.4,9-3.8c14.9-5.6,26.7-6.1,39.6-12.2l1.8,1
											c-12.9,6.1-24.7,6.5-39.6,12.2C663.4,247.6,660.4,248.9,658,250"/>
                    <path class="st437"
                          d="M706.7,234.1l-1.8-1c3.2-1.5,6.4-3.3,9.8-5.6l1.8,1C713,230.8,709.8,232.6,706.7,234.1"/>
                    <path class="st436" d="M716.4,228.5l-1.8-1c0,0,0.1-0.1,0.1-0.1c0.8-0.6,1.6-1.2,2.4-1.7l1.8,1c-0.7,0.6-1.5,1.2-2.4,1.7
											C716.5,228.4,716.4,228.4,716.4,228.5"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000125577739773973424830000002126015023524672135_" class="st417" d="M616.8,312.3l-1.8-1
											c0.4-0.3,0.7-0.7,1.1-1l1.8,1C617.5,311.6,617.2,311.9,616.8,312.3z"/>
									</defs>
                  <clipPath id="SVGID_00000007388055144092505510000000290999775293575333_">
										<use xlink:href="#SVGID_00000125577739773973424830000002126015023524672135_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000007388055144092505510000000290999775293575333_);enable-background:new    ;">
										<path class="st435"
                          d="M616.8,312.3l-1.8-1c0.3-0.3,0.5-0.5,0.8-0.8l1.8,1C617.3,311.8,617.1,312,616.8,312.3"/>
                    <path class="st436"
                          d="M617.6,311.5l-1.8-1c0.1-0.1,0.2-0.1,0.2-0.2l1.8,1C617.8,311.4,617.7,311.4,617.6,311.5"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000075140439195676227340000007760074410100095397_" class="st417" d="M646.6,256.7l-1.8-1
											c0.4-0.3,0.8-0.6,1.3-0.9c0.4-0.3,0.8-0.5,1.2-0.8l1.8,1c-0.4,0.3-0.8,0.6-1.2,0.8C647.4,256.1,647,256.4,646.6,256.7z"/>
									</defs>
                  <clipPath id="SVGID_00000133502049743398309220000006291460994172041111_">
										<use xlink:href="#SVGID_00000075140439195676227340000007760074410100095397_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000133502049743398309220000006291460994172041111_);enable-background:new    ;">
										<path class="st436"
                          d="M646.6,256.7l-1.8-1c0.1-0.1,0.2-0.2,0.4-0.3l1.8,1C646.8,256.5,646.7,256.6,646.6,256.7"/>
                    <path class="st437" d="M647,256.4l-1.8-1c0.3-0.2,0.6-0.4,0.9-0.6c0.4-0.3,0.8-0.5,1.2-0.8l1.8,1
											c-0.4,0.3-0.8,0.6-1.2,0.8C647.5,256,647.2,256.2,647,256.4"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000141421737506173597930000014814361516547780533_" class="st417" d="M615.7,313.2l-1.8-1
											c0.4-0.3,0.7-0.6,1.1-0.9l1.8,1C616.4,312.6,616.1,312.9,615.7,313.2z"/>
									</defs>
                  <clipPath id="SVGID_00000173862956128813944920000003211752508187422654_">
										<use xlink:href="#SVGID_00000141421737506173597930000014814361516547780533_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000173862956128813944920000003211752508187422654_);enable-background:new    ;">
										<path class="st436"
                          d="M615.7,313.2l-1.8-1c0.4-0.3,0.7-0.6,1.1-0.9l1.8,1C616.4,312.6,616.1,312.9,615.7,313.2"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000095316690671045290340000002005725984285857722_" class="st417" d="M617.9,311.3l-1.8-1
											c9.4-8.9,11-17.5,12.4-25.9c1.7-9.8,3-19.4,16.3-28.7l1.8,1c-13.3,9.3-14.7,18.8-16.3,28.7
											C628.9,293.8,627.3,302.4,617.9,311.3z"/>
									</defs>
                  <clipPath id="SVGID_00000017491130778460513250000009792743384688799642_">
										<use xlink:href="#SVGID_00000095316690671045290340000002005725984285857722_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000017491130778460513250000009792743384688799642_);enable-background:new    ;">
										<path class="st435"
                          d="M617.9,311.3l-1.8-1c1-1,1.9-1.9,2.8-2.9l1.8,1C619.8,309.4,618.9,310.3,617.9,311.3"/>
                    <path class="st439"
                          d="M620.7,308.4l-1.8-1c1-1.1,1.9-2.2,2.6-3.3l1.8,1C622.5,306.2,621.6,307.3,620.7,308.4"/>
                    <path class="st440"
                          d="M623.3,305.1l-1.8-1c0.8-1.2,1.5-2.3,2.2-3.5l1.8,1C624.8,302.7,624.1,303.9,623.3,305.1"/>
                    <path class="st441"
                          d="M625.5,301.6l-1.8-1c0.8-1.5,1.5-3,2-4.5l1.8,1C626.9,298.5,626.3,300.1,625.5,301.6"/>
                    <path class="st442" d="M627.5,297l-1.8-1c1.4-3.9,2.1-7.8,2.8-11.7c0.7-4.1,1.3-8.1,2.8-12.1l1.8,1c-1.5,4-2.1,8-2.8,12.1
											C629.6,289.2,628.9,293.1,627.5,297"/>
                    <path class="st441"
                          d="M633.1,273.3l-1.8-1c0.5-1.4,1.1-2.7,1.8-4.1l1.8,1C634.2,270.6,633.6,271.9,633.1,273.3"/>
                    <path class="st440"
                          d="M634.9,269.2l-1.8-1c0.5-1,1.2-2,1.9-3l1.8,1C636,267.2,635.4,268.2,634.9,269.2"/>
                    <path class="st439"
                          d="M636.8,266.2l-1.8-1c0.7-0.9,1.4-1.9,2.2-2.8l1.8,1C638.2,264.3,637.4,265.2,636.8,266.2"/>
                    <path class="st435" d="M639,263.4l-1.8-1c0.9-1,1.9-2,3-3l1.8,1C640.9,261.3,639.9,262.3,639,263.4"/>
                    <path class="st436"
                          d="M642,260.3l-1.8-1c1.3-1.2,2.9-2.4,4.6-3.6l1.8,1C644.9,257.9,643.4,259.1,642,260.3"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000152947417551007563290000009518097266161190532_" class="st417" d="M551.7,346.4l-1.8-1
											c0.8-0.6,1.6-1.2,2.4-1.8c4.5-3.2,8.9-5.8,12.9-7.8c14.7-7.7,23.9-10.9,31.3-13.7c6.5-2.5,11.5-4.8,17.5-9.9l1.8,1
											c-6,5.1-11,7.4-17.5,9.9c-7.3,2.8-16.6,6-31.3,13.7c-4,2.1-8.3,4.6-12.9,7.8C553.3,345.2,552.5,345.8,551.7,346.4z"/>
									</defs>
                  <clipPath id="SVGID_00000005955406932580920600000003382592980130820004_">
										<use xlink:href="#SVGID_00000152947417551007563290000009518097266161190532_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000005955406932580920600000003382592980130820004_);enable-background:new    ;">
										<path class="st436"
                          d="M551.7,346.4l-1.8-1c0.7-0.6,1.5-1.1,2.2-1.6l1.8,1C553.2,345.3,552.4,345.8,551.7,346.4"/>
                    <path class="st437"
                          d="M553.9,344.8l-1.8-1c0,0,0,0,0,0L553.9,344.8C554,344.8,553.9,344.8,553.9,344.8"/>
                    <path class="st436" d="M554,344.7l-1.8-1c0,0,0.1,0,0.1-0.1c0.3-0.2,0.6-0.4,0.9-0.6l1.8,1c-0.3,0.2-0.6,0.4-0.9,0.6
											C554,344.7,554,344.7,554,344.7"/>
                    <path class="st437" d="M555,344l-1.8-1c4.2-2.9,8.2-5.3,11.9-7.2c3.4-1.8,6.5-3.3,9.3-4.6l1.8,1c-2.8,1.3-5.9,2.9-9.3,4.6
											C563.2,338.8,559.2,341.1,555,344"/>
                    <path class="st433" d="M576.3,332.2l-1.8-1c9.5-4.5,16.3-6.9,22-9c2.2-0.9,4.2-1.7,6.2-2.6l1.8,1c-1.9,0.9-4,1.7-6.2,2.6
											C592.6,325.3,585.8,327.7,576.3,332.2"/>
                    <path class="st437"
                          d="M604.4,320.5l-1.8-1c2.4-1.1,4.7-2.4,7-4l1.8,1C609.1,318.1,606.8,319.4,604.4,320.5"/>
                    <path class="st436"
                          d="M611.4,316.5l-1.8-1c1.4-1,2.8-2,4.3-3.3l1.8,1C614.2,314.5,612.8,315.5,611.4,316.5"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000132072338850979459600000013865335262768749190_" class="st417" d="M536.1,372.8l-1.8-1
											c-0.1-0.1-0.2-0.1-0.3-0.2l1.8,1C535.9,372.7,536,372.8,536.1,372.8z"/>
									</defs>
                  <clipPath id="SVGID_00000128480560899330867030000009394071318418070190_">
										<use xlink:href="#SVGID_00000132072338850979459600000013865335262768749190_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000128480560899330867030000009394071318418070190_);enable-background:new    ;">
										<path class="st442"
                          d="M536.1,372.8l-1.8-1c-0.1-0.1-0.2-0.1-0.3-0.2l1.8,1C535.9,372.7,536,372.8,536.1,372.8"/>
									</g>
								</g>
                <g>
									<path class="st450" d="M768.5,153.5c4.2-0.6,8.1-0.8,11.2-0.8l62.1,43.8c1.4,1,1.2,2.6-0.5,3.5l-27.2,15.7l-2.5,1.4
										L753,250.9l-2.5,1.4l-58.1,33.4l-2.5,1.5L631.3,321l-2.5,1.4l-58.7,33.8l-2.5,1.4l-26.2,15.1c-0.6,0.3-1.2,0.5-1.9,0.6
										c-1.3,0.2-2.7,0-3.7-0.7l-5.9-4.2c6.8-9.4,14.4-16.6,21.8-22.1c0.8-0.6,1.6-1.2,2.4-1.8c4.5-3.2,8.9-5.8,12.9-7.8
										c14.7-7.7,23.9-10.9,31.3-13.7c6.5-2.5,11.5-4.8,17.5-9.9c0.4-0.3,0.7-0.6,1.1-0.9c0.4-0.3,0.7-0.7,1.1-1
										c9.4-8.9,11-17.5,12.4-25.9c1.7-9.8,3-19.4,16.3-28.7c0.4-0.3,0.8-0.6,1.3-0.9c0.4-0.3,0.8-0.5,1.2-0.8
										c3.9-2.5,8.4-5.2,17.9-8.7c18.6-7,32.3-6,49.5-17.9c0.8-0.6,1.6-1.2,2.4-1.7c22.8-17.9,10.2-42.9,22.1-59.4
										c0.5-0.7,1.1-1.5,1.8-2.2c2.4-2.7,5.6-5.1,9.9-7.1C757.9,155.6,763.4,154.2,768.5,153.5z"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000039092607724663785920000010763271344860878730_" class="st417" d="M529.9,368.5l-1.8-1
											c6.8-9.4,14.4-16.6,21.8-22.1l1.8,1C544.3,351.9,536.6,359.1,529.9,368.5z"/>
									</defs>
                  <clipPath id="SVGID_00000034782083486191148010000014442258834946583175_">
										<use xlink:href="#SVGID_00000039092607724663785920000010763271344860878730_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000034782083486191148010000014442258834946583175_);enable-background:new    ;">
										<path class="st439"
                          d="M529.9,368.5l-1.8-1c2-2.8,4.1-5.4,6.2-7.8l1.8,1C534,363.1,531.9,365.7,529.9,368.5"/>
                    <path class="st435"
                          d="M536.1,360.7l-1.8-1c2.6-3,5.3-5.7,8-8.1l1.8,1C541.4,355,538.7,357.7,536.1,360.7"/>
                    <path class="st436"
                          d="M544.1,352.6l-1.8-1c2.5-2.3,5.1-4.3,7.6-6.2l1.8,1C549.2,348.3,546.6,350.3,544.1,352.6"/>
									</g>
								</g>
                <g>
									<polygon class="st452" points="535.8,372.6 534,371.7 528.1,367.5 529.9,368.5 									"/>
								</g>
							</g>
						</g>
					</g>
          <g>
						<g>
							<g class="st417">
								<g>
									<polygon class="st453" points="745.9,245.6 744.1,244.6 710.2,220.6 712,221.6 									"/>
								</g>
                <g>
									<polygon class="st453" points="807.1,210.3 805.3,209.4 734.6,159.5 736.4,160.5 									"/>
								</g>
                <g>
									<polygon class="st453" points="685.3,280.5 683.5,279.5 640.2,249 642,249.9 									"/>
								</g>
                <g>
									<polygon class="st453" points="624.2,315.7 622.4,314.7 609.3,305.5 611.1,306.4 									"/>
								</g>
                <g>
									<polygon class="st453" points="712,221.6 710.2,220.6 646.2,175.5 648,176.5 									"/>
								</g>
                <g>
									<polygon class="st453" points="736.4,160.5 734.6,159.5 671.9,115.3 673.7,116.3 									"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000158710264201375487390000009499711247972530580_" class="st417" d="M647.9,168.5l1.8,1
											c-1.6-0.8-3.6-1.1-5.6-0.8l-1.8-1C644.2,167.4,646.3,167.7,647.9,168.5z"/>
									</defs>
                  <clipPath id="SVGID_00000160176721390208088260000018305992566990982545_">
										<use xlink:href="#SVGID_00000158710264201375487390000009499711247972530580_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000160176721390208088260000018305992566990982545_);enable-background:new    ;">
										<path class="st455"
                          d="M644,168.7l-1.8-1c1.3-0.2,2.7-0.1,4,0.2l1.8,1C646.7,168.5,645.4,168.5,644,168.7"/>
                    <path class="st456"
                          d="M648,168.9l-1.8-1c0.5,0.1,1,0.3,1.4,0.5l1.8,1C649,169.2,648.5,169,648,168.9"/>
                    <path class="st457"
                          d="M649.4,169.4l-1.8-1c0.1,0,0.2,0.1,0.2,0.1l1.8,1C649.6,169.5,649.5,169.4,649.4,169.4"/>
									</g>
								</g>
                <g>
									<polygon class="st453" points="563,350.9 561.2,349.9 545.3,338.7 547.1,339.7 									"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000034061896315338570610000004641720943515115439_" class="st417" d="M640.5,176.1l-1.8-1
											c-0.2-0.1-0.4-0.2-0.6-0.3c-2.4-1.7-2.1-4.4,0.8-6c1-0.6,2.1-0.9,3.3-1.1l1.8,1c-1.2,0.2-2.3,0.5-3.3,1.1
											c-2.8,1.6-3.2,4.3-0.8,6C640.1,175.9,640.3,176,640.5,176.1z"/>
									</defs>
                  <clipPath id="SVGID_00000155853659323112985500000003068197613158761119_">
										<use xlink:href="#SVGID_00000034061896315338570610000004641720943515115439_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000155853659323112985500000003068197613158761119_);enable-background:new    ;">
										<path class="st459" d="M640.5,176.1l-1.8-1c-0.2-0.1-0.4-0.2-0.6-0.3c-1.4-1-1.9-2.4-1.4-3.7l1.8,1
											c-0.5,1.3,0,2.7,1.4,3.7C640.1,175.9,640.3,176,640.5,176.1"/>
                    <path class="st460"
                          d="M638.5,172.1l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C638.6,171.8,638.6,172,638.5,172.1"/>
                    <path class="st461"
                          d="M638.7,171.7l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C638.9,171.4,638.8,171.6,638.7,171.7"/>
                    <path class="st462"
                          d="M639,171.3l-1.8-1c0.1-0.1,0.2-0.3,0.3-0.4l1.8,1C639.1,171.1,639,171.2,639,171.3"/>
                    <path class="st463"
                          d="M639.3,170.9l-1.8-1c0.1-0.1,0.3-0.3,0.4-0.4l1.8,1C639.5,170.7,639.4,170.8,639.3,170.9"/>
                    <path class="st457"
                          d="M639.7,170.5l-1.8-1c0.2-0.2,0.4-0.3,0.6-0.5l1.8,1C640,170.2,639.8,170.4,639.7,170.5"/>
                    <path class="st456" d="M640.2,170.1l-1.8-1c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.2,0.6-0.3l1.8,1
											c-0.2,0.1-0.4,0.2-0.6,0.3C640.6,169.9,640.4,170,640.2,170.1"/>
                    <path class="st455"
                          d="M641.3,169.5l-1.8-1c0.8-0.4,1.8-0.7,2.7-0.8l1.8,1C643.1,168.8,642.1,169.1,641.3,169.5"/>
									</g>
								</g>
                <g>
									<path class="st464" d="M644,168.7c2.3-0.3,4.6,0.1,6.2,1.2c2,1.4,2.1,3.5,0.4,5.1l63.6,44.9l33.7,23.8
										c0.2,0.1,0.3,0.3,0.4,0.5l-2.5,1.4l-34-23.9l-64-45.1c-0.6,0.2-1.3,0.4-2,0.5c-2.2,0.3-4.5-0.1-6.1-1.2
										c-2.4-1.7-2.1-4.4,0.8-6C641.7,169.2,642.8,168.8,644,168.7z"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000159460795056270872040000003937988097559018910_" class="st417" d="M666.7,115.9l-1.8-1
											c-0.2-0.1-0.4-0.2-0.5-0.3l1.8,1C666.3,115.7,666.5,115.8,666.7,115.9z"/>
									</defs>
                  <clipPath id="SVGID_00000080916238854902109180000017431213849447072919_">
										<use xlink:href="#SVGID_00000159460795056270872040000003937988097559018910_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000080916238854902109180000017431213849447072919_);enable-background:new    ;">
										<path class="st459"
                          d="M666.7,115.9l-1.8-1c-0.2-0.1-0.4-0.2-0.5-0.3l1.8,1C666.3,115.7,666.5,115.8,666.7,115.9"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000103246586847016498880000013033993996451737246_" class="st417" d="M667.2,104.1l1.8,1
											c-1.5-0.8-3.5-1.1-5.4-0.8l-1.8-1C663.7,103,665.7,103.2,667.2,104.1z"/>
									</defs>
                  <clipPath id="SVGID_00000110472847906497086970000015744803712796486070_">
										<use xlink:href="#SVGID_00000103246586847016498880000013033993996451737246_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000110472847906497086970000015744803712796486070_);enable-background:new    ;">
										<path class="st455"
                          d="M663.6,104.2l-1.8-1c1.3-0.2,2.6-0.1,3.8,0.2l1.8,1C666.2,104.1,664.8,104,663.6,104.2"/>
                    <path class="st456"
                          d="M667.3,104.4l-1.8-1c0.5,0.1,1,0.3,1.4,0.5l1.8,1C668.3,104.7,667.8,104.5,667.3,104.4"/>
                    <path class="st457"
                          d="M668.7,104.9l-1.8-1c0.1,0,0.2,0.1,0.2,0.1l1.8,1C668.9,105,668.8,104.9,668.7,104.9"/>
									</g>
								</g>
                <g>
									<polygon class="st453" points="666.2,115.6 664.4,114.6 657.9,110 659.7,111 									"/>
								</g>
                <g>
									<polygon class="st453" points="611.1,306.4 609.3,305.5 565.5,274.6 567.3,275.6 									"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000018207309959415545900000011092737115754377137_" class="st417" d="M659.7,111l-1.8-1
											c-2.3-1.6-2-4.2,0.7-5.8c0.9-0.5,2-0.9,3.1-1l1.8,1c-1.1,0.2-2.2,0.5-3.1,1C657.7,106.8,657.4,109.4,659.7,111z"/>
									</defs>
                  <clipPath id="SVGID_00000066484437149540046760000008439544043025197458_">
										<use xlink:href="#SVGID_00000018207309959415545900000011092737115754377137_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000066484437149540046760000008439544043025197458_);enable-background:new    ;">
										<path class="st459"
                          d="M659.7,111l-1.8-1c-1.4-1-1.8-2.3-1.4-3.5l1.8,1C657.9,108.7,658.3,110.1,659.7,111"/>
                    <path class="st460"
                          d="M658.3,107.5l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C658.4,107.2,658.4,107.4,658.3,107.5"/>
                    <path class="st461"
                          d="M658.5,107.1l-1.8-1c0.1-0.1,0.1-0.2,0.2-0.4l1.8,1C658.6,106.9,658.6,107,658.5,107.1"/>
                    <path class="st462"
                          d="M658.7,106.7l-1.8-1c0.1-0.1,0.2-0.2,0.3-0.4l1.8,1C658.9,106.5,658.8,106.6,658.7,106.7"/>
                    <path class="st463"
                          d="M659,106.4l-1.8-1c0.1-0.1,0.2-0.3,0.4-0.4l1.8,1C659.3,106.1,659.1,106.2,659,106.4"/>
                    <path class="st457"
                          d="M659.4,106l-1.8-1c0.2-0.2,0.4-0.3,0.6-0.4l1.8,1C659.8,105.7,659.6,105.8,659.4,106"/>
                    <path class="st456" d="M660,105.5l-1.8-1c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.2,0.5-0.3l1.8,1
											c-0.2,0.1-0.4,0.2-0.5,0.3C660.3,105.4,660.1,105.4,660,105.5"/>
                    <path class="st455"
                          d="M661,105l-1.8-1c0.8-0.4,1.7-0.6,2.6-0.8l1.8,1C662.7,104.3,661.8,104.6,661,105"/>
									</g>
								</g>
                <g>
									<path class="st464" d="M663.6,104.2c2.1-0.3,4.4,0.1,5.9,1.2l6.5,4.6c1.9,1.3,2,3.3,0.4,4.9l61.8,43.5l71,50.1
										c0.2,0.1,0.3,0.3,0.4,0.5l-2.5,1.4l-70.7-49.8l-62.7-44.2c-0.6,0.2-1.1,0.3-1.7,0.4c-2.1,0.3-4.3-0.1-5.8-1.1l-6.5-4.6
										c-2.3-1.6-2-4.2,0.7-5.8C661.4,104.7,662.4,104.4,663.6,104.2z"/>
								</g>
                <g>
									<polygon class="st453" points="642,249.9 640.2,249 592.7,215.5 594.5,216.4 									"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000092416841126425911660000013289615700102165923_" class="st417" d="M567.3,267.6l1.8,1
											c-1.5-0.8-3.6-1.1-5.6-0.8l-1.8-1C563.7,266.5,565.8,266.8,567.3,267.6z"/>
									</defs>
                  <clipPath id="SVGID_00000016057211349969395200000013011025308811884719_">
										<use xlink:href="#SVGID_00000092416841126425911660000013289615700102165923_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000016057211349969395200000013011025308811884719_);enable-background:new    ;">
										<path class="st455"
                          d="M563.5,267.7l-1.8-1c1.3-0.2,2.7-0.1,4,0.2l1.8,1C566.2,267.6,564.8,267.5,563.5,267.7"/>
                    <path class="st456"
                          d="M567.4,267.9l-1.8-1c0.5,0.1,1,0.3,1.4,0.5l1.8,1C568.4,268.2,567.9,268.1,567.4,267.9"/>
                    <path class="st457"
                          d="M568.9,268.5l-1.8-1c0.1,0,0.2,0.1,0.2,0.1l1.8,1C569,268.5,568.9,268.5,568.9,268.5"/>
									</g>
								</g>
                <g>
									<path class="st464" d="M563.5,267.7c2.3-0.3,4.6,0.1,6.2,1.2c2,1.4,2.1,3.5,0.4,5.1l43.2,30.4l13,9.2
										c0.2,0.1,0.3,0.3,0.4,0.5l-2.5,1.4l-13-9.2l-43.8-30.9c-0.6,0.2-1.2,0.3-1.9,0.4c-2.2,0.3-4.5-0.1-6.1-1.2
										c-2.4-1.7-2.1-4.4,0.8-6C561.1,268.3,562.3,267.9,563.5,267.7z"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000013887020663607308950000004491732734366439054_" class="st417" d="M559.9,275.2l-1.8-1
											c-0.2-0.1-0.4-0.2-0.6-0.4c-2.4-1.7-2.1-4.4,0.8-6c1-0.6,2.1-0.9,3.3-1.1l1.8,1c-1.2,0.2-2.3,0.5-3.3,1.1
											c-2.8,1.6-3.2,4.3-0.8,6C559.6,275,559.7,275.1,559.9,275.2z"/>
									</defs>
                  <clipPath id="SVGID_00000009566906893377015880000016171765392615071656_">
										<use xlink:href="#SVGID_00000013887020663607308950000004491732734366439054_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000009566906893377015880000016171765392615071656_);enable-background:new    ;">
										<path class="st459" d="M559.9,275.2l-1.8-1c-0.2-0.1-0.4-0.2-0.6-0.4c-1.4-1-1.9-2.4-1.4-3.7l1.8,1
											c-0.5,1.3,0,2.7,1.4,3.7C559.6,275,559.7,275.1,559.9,275.2"/>
                    <path class="st460"
                          d="M558,271.2l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C558.1,270.9,558,271,558,271.2"/>
                    <path class="st461"
                          d="M558.1,270.8l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C558.3,270.5,558.2,270.6,558.1,270.8"/>
                    <path class="st462"
                          d="M558.4,270.4l-1.8-1c0.1-0.1,0.2-0.3,0.3-0.4l1.8,1C558.6,270.1,558.5,270.3,558.4,270.4"/>
                    <path class="st463"
                          d="M558.7,270l-1.8-1c0.1-0.1,0.3-0.3,0.4-0.4l1.8,1C558.9,269.7,558.8,269.9,558.7,270"/>
                    <path class="st457"
                          d="M559.1,269.6l-1.8-1c0.2-0.2,0.4-0.3,0.6-0.5l1.8,1C559.5,269.3,559.3,269.4,559.1,269.6"/>
                    <path class="st456" d="M559.7,269.1l-1.8-1c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.2,0.6-0.3l1.8,1
											c-0.2,0.1-0.4,0.2-0.6,0.3C560,268.9,559.8,269,559.7,269.1"/>
                    <path class="st455"
                          d="M560.7,268.5l-1.8-1c0.8-0.4,1.8-0.7,2.7-0.8l1.8,1C562.5,267.9,561.6,268.1,560.7,268.5"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000037673454565922439340000004967225279465499326_" class="st417" d="M594.5,208.4l1.8,1
											c-1.6-0.8-3.6-1.1-5.6-0.8l-1.8-1C590.8,207.3,592.9,207.6,594.5,208.4z"/>
									</defs>
                  <clipPath id="SVGID_00000092452431360410625640000014899165671788397729_">
										<use xlink:href="#SVGID_00000037673454565922439340000004967225279465499326_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000092452431360410625640000014899165671788397729_);enable-background:new    ;">
										<path class="st455"
                          d="M590.6,208.6l-1.8-1c1.3-0.2,2.7-0.1,4,0.2l1.8,1C593.3,208.5,592,208.4,590.6,208.6"/>
                    <path class="st456"
                          d="M594.6,208.8l-1.8-1c0.5,0.1,1,0.3,1.4,0.5l1.8,1C595.6,209.1,595.1,208.9,594.6,208.8"/>
                    <path class="st457"
                          d="M596,209.3l-1.8-1c0.1,0,0.2,0.1,0.2,0.1l1.8,1C596.2,209.4,596.1,209.3,596,209.3"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000008127214467262891240000007091321203983936641_" class="st417" d="M587.1,216l-1.8-1
											c-0.2-0.1-0.4-0.2-0.6-0.3c-2.4-1.7-2.1-4.4,0.8-6c1-0.6,2.1-0.9,3.3-1.1l1.8,1c-1.2,0.2-2.3,0.5-3.3,1.1
											c-2.8,1.6-3.2,4.3-0.8,6C586.7,215.8,586.9,215.9,587.1,216z"/>
									</defs>
                  <clipPath id="SVGID_00000163754095954124253510000008123499884595434401_">
										<use xlink:href="#SVGID_00000008127214467262891240000007091321203983936641_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000163754095954124253510000008123499884595434401_);enable-background:new    ;">
										<path class="st459" d="M587.1,216l-1.8-1c-0.2-0.1-0.4-0.2-0.6-0.3c-1.4-1-1.9-2.4-1.4-3.7l1.8,1c-0.5,1.3,0,2.7,1.4,3.7
											C586.7,215.8,586.9,215.9,587.1,216"/>
                    <path class="st460"
                          d="M585.1,212l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C585.2,211.7,585.2,211.9,585.1,212"/>
                    <path class="st461"
                          d="M585.3,211.6l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C585.5,211.3,585.4,211.5,585.3,211.6"/>
                    <path class="st462"
                          d="M585.6,211.2l-1.8-1c0.1-0.1,0.2-0.3,0.3-0.4l1.8,1C585.7,211,585.6,211.1,585.6,211.2"/>
                    <path class="st463"
                          d="M585.9,210.8l-1.8-1c0.1-0.1,0.3-0.3,0.4-0.4l1.8,1C586.1,210.6,586,210.7,585.9,210.8"/>
                    <path class="st457"
                          d="M586.3,210.4l-1.8-1c0.2-0.2,0.4-0.3,0.6-0.5l1.8,1C586.6,210.1,586.4,210.3,586.3,210.4"/>
                    <path class="st456" d="M586.9,210l-1.8-1c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.2,0.6-0.3l1.8,1
											c-0.2,0.1-0.4,0.2-0.6,0.3C587.2,209.8,587,209.9,586.9,210"/>
                    <path class="st455"
                          d="M587.9,209.4l-1.8-1c0.8-0.4,1.8-0.7,2.7-0.8l1.8,1C589.7,208.7,588.7,209,587.9,209.4"/>
									</g>
								</g>
                <g>
									<path class="st464" d="M590.6,208.6c2.3-0.3,4.6,0.1,6.2,1.2c2,1.4,2.1,3.5,0.4,5.1l47.3,33.3l42.9,30.3
										c0.2,0.1,0.3,0.3,0.4,0.5l-2.5,1.5L642,249.9l-47.5-33.5c-0.6,0.2-1.2,0.3-1.8,0.4c-2.2,0.3-4.5-0.1-6.1-1.2
										c-2.4-1.7-2.1-4.4,0.8-6C588.3,209.1,589.4,208.7,590.6,208.6z"/>
								</g>
                <g>
									<polygon class="st453" points="547.1,339.7 545.3,338.7 507,311.7 508.8,312.7 									"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000035521442563218795990000017827415599341523357_" class="st417" d="M501.8,312.3l-1.8-1
											c-0.2-0.1-0.4-0.2-0.5-0.3l1.8,1C501.5,312.1,501.7,312.2,501.8,312.3z"/>
									</defs>
                  <clipPath id="SVGID_00000025417714237774573490000001348895446856990620_">
										<use xlink:href="#SVGID_00000035521442563218795990000017827415599341523357_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000025417714237774573490000001348895446856990620_);enable-background:new    ;">
										<path class="st459"
                          d="M501.8,312.3l-1.8-1c-0.2-0.1-0.4-0.2-0.5-0.3l1.8,1C501.5,312.1,501.7,312.2,501.8,312.3"/>
									</g>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000163774068174468111880000014667349238922786478_" class="st417" d="M502.3,300.4l1.8,1
											c-1.5-0.8-3.5-1.1-5.4-0.8l-1.8-1C498.8,299.4,500.8,299.6,502.3,300.4z"/>
									</defs>
                  <clipPath id="SVGID_00000011012661511933769650000014359084887117552046_">
										<use xlink:href="#SVGID_00000163774068174468111880000014667349238922786478_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000011012661511933769650000014359084887117552046_);enable-background:new    ;">
										<path class="st455"
                          d="M498.7,300.6l-1.8-1c1.3-0.2,2.6-0.1,3.8,0.2l1.8,1C501.3,300.5,500,300.4,498.7,300.6"/>
                    <path class="st456"
                          d="M502.5,300.8l-1.8-1c0.5,0.1,1,0.3,1.4,0.5l1.8,1C503.5,301.1,503,300.9,502.5,300.8"/>
                    <path class="st457"
                          d="M503.9,301.3l-1.8-1c0.1,0,0.1,0.1,0.2,0.1l1.8,1C504,301.4,504,301.3,503.9,301.3"/>
									</g>
								</g>
                <g>
									<polygon class="st453" points="501.3,312 499.5,311 493,306.4 494.8,307.4 									"/>
								</g>
                <g>
									<path class="st464" d="M498.7,300.6c2.1-0.3,4.4,0.1,5.9,1.1l6.5,4.6c1.9,1.3,2,3.3,0.4,4.9l37.9,26.7l15.6,11
										c0.2,0.1,0.3,0.3,0.4,0.5l-2.5,1.4l-15.9-11.2l-38.3-27c-0.5,0.2-1.1,0.3-1.7,0.4c-2.1,0.3-4.3-0.1-5.8-1.1l-6.5-4.6
										c-2.3-1.6-2-4.2,0.7-5.8C496.5,301.1,497.6,300.8,498.7,300.6z"/>
								</g>
                <g class="st417">
									<defs>
										<path id="SVGID_00000181788683124079713270000010406123762607309453_" class="st417" d="M494.8,307.4l-1.8-1
											c-2.3-1.6-2-4.2,0.7-5.8c0.9-0.5,2-0.9,3.2-1l1.8,1c-1.1,0.2-2.2,0.5-3.2,1C492.9,303.2,492.5,305.8,494.8,307.4z"/>
									</defs>
                  <clipPath id="SVGID_00000030477115081689566710000010329120307786551738_">
										<use xlink:href="#SVGID_00000181788683124079713270000010406123762607309453_"
                         style="overflow:visible;"/>
									</clipPath>
                  <g style="clip-path:url(#SVGID_00000030477115081689566710000010329120307786551738_);enable-background:new    ;">
										<path class="st459"
                          d="M494.8,307.4l-1.8-1c-1.4-1-1.8-2.3-1.4-3.5l1.8,1C493,305.1,493.5,306.4,494.8,307.4"/>
                    <path class="st460"
                          d="M493.5,303.9l-1.8-1c0.1-0.1,0.1-0.3,0.2-0.4l1.8,1C493.6,303.6,493.5,303.8,493.5,303.9"/>
                    <path class="st461"
                          d="M493.7,303.5l-1.8-1c0.1-0.1,0.1-0.2,0.2-0.4l1.8,1C493.8,303.2,493.7,303.4,493.7,303.5"/>
                    <path class="st462"
                          d="M493.9,303.1l-1.8-1c0.1-0.1,0.2-0.2,0.3-0.4l1.8,1C494.1,302.9,494,303,493.9,303.1"/>
                    <path class="st463"
                          d="M494.2,302.8l-1.8-1c0.1-0.1,0.2-0.3,0.4-0.4l1.8,1C494.4,302.5,494.3,302.6,494.2,302.8"/>
                    <path class="st457"
                          d="M494.5,302.4l-1.8-1c0.2-0.2,0.4-0.3,0.6-0.4l1.8,1C494.9,302.1,494.7,302.2,494.5,302.4"/>
                    <path class="st456" d="M495.1,301.9l-1.8-1c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.2,0.5-0.3l1.8,1
											c-0.2,0.1-0.4,0.2-0.5,0.3C495.4,301.7,495.3,301.8,495.1,301.9"/>
                    <path class="st455"
                          d="M496.1,301.4l-1.8-1c0.8-0.4,1.7-0.6,2.6-0.8l1.8,1C497.8,300.7,496.9,301,496.1,301.4"/>
									</g>
								</g>
							</g>
              <g class="st417">
								<g>
									<polygon class="st464" points="510.4,281.5 514.1,284.1 490.2,297.9 486.6,295.3 									"/>
								</g>
                <g>
									<polygon class="st453" points="490.2,297.9 488.4,296.9 484.8,294.3 486.6,295.3 									"/>
								</g>
                <g>
									<polygon class="st475" points="486.6,295.3 484.8,294.3 508.6,280.6 510.4,281.5 									"/>
								</g>
                <g>
									<polygon class="st464" points="497,282.5 500.6,285.1 484.9,294.1 481.2,291.5 									"/>
								</g>
                <g>
									<polygon class="st453" points="484.9,294.1 483.1,293.1 479.4,290.5 481.2,291.5 									"/>
								</g>
                <g>
									<polygon class="st475" points="481.2,291.5 479.4,290.5 495.2,281.5 497,282.5 									"/>
								</g>
							</g>
              <g class="st417">
								<g>
									<polygon class="st464" points="588.4,195.2 592.1,197.8 568.2,211.5 564.6,208.9 									"/>
								</g>
                <g>
									<polygon class="st453" points="568.2,211.5 566.4,210.5 562.8,207.9 564.6,208.9 									"/>
								</g>
                <g>
									<polygon class="st475" points="564.6,208.9 562.8,207.9 586.6,194.2 588.4,195.2 									"/>
								</g>
                <g>
									<polygon class="st464" points="579,193.7 582.7,196.3 567,205.4 563.3,202.8 									"/>
								</g>
                <g>
									<polygon class="st453" points="567,205.4 565.2,204.4 561.5,201.8 563.3,202.8 									"/>
								</g>
                <g>
									<polygon class="st475" points="563.3,202.8 561.5,201.8 577.3,192.8 579,193.7 									"/>
								</g>
							</g>
              <g class="st417">
								<g>
									<polygon class="st464" points="652.6,99.7 656.2,102.3 632.4,116 628.7,113.4 									"/>
								</g>
                <g>
									<polygon class="st453" points="632.4,116 630.6,115.1 626.9,112.5 628.7,113.4 									"/>
								</g>
                <g>
									<polygon class="st475" points="628.7,113.4 626.9,112.5 650.8,98.7 652.6,99.7 									"/>
								</g>
                <g>
									<polygon class="st464" points="647.2,96 650.9,98.5 635.2,107.6 631.5,105 									"/>
								</g>
                <g>
									<polygon class="st453" points="635.2,107.6 633.4,106.6 629.7,104 631.5,105 									"/>
								</g>
                <g>
									<polygon class="st475" points="631.5,105 629.7,104 645.4,95 647.2,96 									"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
      <g>
				<g>

						<linearGradient id="SVGID_00000154394864090832057840000001108360667661547669_"
                            gradientUnits="userSpaceOnUse" x1="203.7558" y1="726.8474" x2="372.2985" y2="726.8474"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000154394864090832057840000001108360667661547669_);" d="M588.6,689.5h171.3v24.2h0
						c0,0.2,0,0.5,0,0.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9c0-0.2,0-0.5,0-0.7h0V689.5z"/>
          <g>

							<linearGradient id="SVGID_00000172440329865521913440000007212760833220339616_"
                              gradientUnits="userSpaceOnUse" x1="202.9394" y1="710.795" x2="202.9693" y2="710.795"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000172440329865521913440000007212760833220339616_);" d="M759.8,710.5v0.7
							C759.8,710.9,759.8,710.7,759.8,710.5L759.8,710.5z"/>

            <linearGradient id="SVGID_00000027596139874338246970000013717781972127371940_"
                            gradientUnits="userSpaceOnUse" x1="203.7558" y1="736.6036" x2="372.2977" y2="736.6036"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000027596139874338246970000013717781972127371940_);" d="M674.2,758.9
							c47.3,0,85.6-22.3,85.6-49.9v4.6h0c0,0.2,0,0.5,0,0.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9
							c0-0.2,0-0.5,0-0.7h0V709C588.6,736.5,626.9,758.9,674.2,758.9z"/>

            <linearGradient id="SVGID_00000024710430492453884040000006382542263865232038_"
                            gradientUnits="userSpaceOnUse" x1="374.1637" y1="710.795" x2="374.1923" y2="710.795"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000024710430492453884040000006382542263865232038_);" d="M588.6,711.1v-0.7h0
							C588.6,710.7,588.6,710.9,588.6,711.1z"/>
					</g>
          <g>

							<linearGradient id="SVGID_00000163784902162902224840000004975139607831640995_"
                              gradientUnits="userSpaceOnUse" x1="314.7943" y1="729.8843" x2="317.1946" y2="729.8843"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000163784902162902224840000004975139607831640995_);" d="M648,761.8c-0.8-0.2-1.6-0.3-2.4-0.5
							V698h2.4V761.8z"/>

            <linearGradient id="SVGID_00000157307279294673119440000017621599252695291528_"
                            gradientUnits="userSpaceOnUse" x1="325.5518" y1="728.6149" x2="327.9522" y2="728.6149"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000157307279294673119440000017621599252695291528_);" d="M637.2,759.3
							c-0.8-0.2-1.6-0.4-2.4-0.7V698h2.4V759.3z"/>

            <linearGradient id="SVGID_00000167374824473499533380000007208525614773475257_"
                            gradientUnits="userSpaceOnUse" x1="336.3087" y1="726.8522" x2="338.7091" y2="726.8522"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000167374824473499533380000007208525614773475257_);" d="M626.5,755.7c-0.8-0.3-1.6-0.7-2.4-1
							V698h2.4V755.7z"/>

            <linearGradient id="SVGID_00000035504286733482024790000006565526702327306886_"
                            gradientUnits="userSpaceOnUse" x1="304.0374" y1="730.6595" x2="306.4377" y2="730.6595"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000035504286733482024790000006565526702327306886_);" d="M658.7,763.3
							c-0.8-0.1-1.6-0.2-2.4-0.3V698h2.4V763.3z"/>

            <linearGradient id="SVGID_00000175294432399108086760000006621692053313653895_"
                            gradientUnits="userSpaceOnUse" x1="357.8232" y1="720.7747" x2="360.2235" y2="720.7747"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000175294432399108086760000006621692053313653895_);" d="M604.9,743.6c-0.8-0.7-1.6-1.3-2.4-2
							V698h2.4V743.6z"/>

            <linearGradient id="SVGID_00000145034672345579338690000015512466522446648714_"
                            gradientUnits="userSpaceOnUse" x1="368.5794" y1="714.9726" x2="370.9797" y2="714.9726"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000145034672345579338690000015512466522446648714_);" d="M594.2,732c-0.9-1.4-1.7-2.8-2.4-4.2
							V698h2.4V732z"/>

            <linearGradient id="SVGID_00000107552902066125245800000013272249324312603549_"
                            gradientUnits="userSpaceOnUse" x1="347.0649" y1="724.3264" x2="349.4653" y2="724.3264"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000107552902066125245800000013272249324312603549_);" d="M615.7,750.7
							c-0.8-0.4-1.6-0.9-2.4-1.3V698h2.4V750.7z"/>

            <linearGradient id="SVGID_00000114067909263172012130000016250580293327977861_"
                            gradientUnits="userSpaceOnUse" x1="293.2805" y1="731.0173" x2="295.6808" y2="731.0173"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000114067909263172012130000016250580293327977861_);" d="M669.5,764.1c-0.8,0-1.6,0-2.4-0.1
							v-66h2.4V764.1z"/>

            <linearGradient id="SVGID_00000065060330728241827400000004709085452049506720_"
                            gradientUnits="userSpaceOnUse" x1="282.523" y1="731.0329" x2="284.9232" y2="731.0329"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000065060330728241827400000004709085452049506720_);" d="M680.2,764c-0.8,0-1.6,0.1-2.4,0.1
							V698h2.4V764z"/>

            <linearGradient id="SVGID_00000160871637712032223220000009192010357386768013_"
                            gradientUnits="userSpaceOnUse" x1="261.0099" y1="729.9891" x2="263.4102" y2="729.9891"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000160871637712032223220000009192010357386768013_);" d="M701.8,761.5
							c-0.8,0.2-1.6,0.3-2.4,0.5v-64h2.4V761.5z"/>

            <linearGradient id="SVGID_00000103971053521743230230000003648753494797097656_"
                            gradientUnits="userSpaceOnUse" x1="271.7667" y1="730.7068" x2="274.1671" y2="730.7068"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000103971053521743230230000003648753494797097656_);" d="M691,763.2c-0.8,0.1-1.6,0.1-2.4,0.2
							V698h2.4V763.2z"/>

            <linearGradient id="SVGID_00000183944019915320280880000004099394107726800315_"
                            gradientUnits="userSpaceOnUse" x1="250.2523" y1="728.765" x2="252.6526" y2="728.765"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000183944019915320280880000004099394107726800315_);" d="M712.5,758.9
							c-0.8,0.2-1.6,0.5-2.4,0.7V698h2.4V758.9z"/>

            <linearGradient id="SVGID_00000098195805042997082400000018010307353359389863_"
                            gradientUnits="userSpaceOnUse" x1="207.2247" y1="715.8253" x2="209.625" y2="715.8253"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000098195805042997082400000018010307353359389863_);" d="M755.5,729.9
							c-0.7,1.3-1.5,2.6-2.4,3.8V698h2.4V729.9z"/>

            <linearGradient id="SVGID_00000006703616411786337890000004341382208260207004_"
                            gradientUnits="userSpaceOnUse" x1="217.9809" y1="721.192" x2="220.3813" y2="721.192"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000006703616411786337890000004341382208260207004_);" d="M744.8,742.5
							c-0.8,0.6-1.6,1.2-2.4,1.9V698h2.4V742.5z"/>

            <linearGradient id="SVGID_00000159440370879747885920000014547699471347553951_"
                            gradientUnits="userSpaceOnUse" x1="239.4955" y1="727.0417" x2="241.8957" y2="727.0417"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000159440370879747885920000014547699471347553951_);" d="M723.3,755.2
							c-0.8,0.3-1.6,0.6-2.4,0.9V698h2.4V755.2z"/>

            <linearGradient id="SVGID_00000109000194154462604380000006152467482383522750_"
                            gradientUnits="userSpaceOnUse" x1="228.7385" y1="724.6102" x2="231.1388" y2="724.6102"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000109000194154462604380000006152467482383522750_);" d="M734,750c-0.8,0.4-1.6,0.8-2.4,1.3
							V698h2.4V750z"/>
					</g>

          <linearGradient id="SVGID_00000126306575343848931060000011772289491370448785_" gradientUnits="userSpaceOnUse"
                          x1="446.78" y1="530.6144" x2="279.2908" y2="699.1705"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000126306575343848931060000011772289491370448785_);" d="M588.6,689.8
						c0,27.5,38.3,49.9,85.6,49.9c47.3,0,85.6-22.3,85.6-49.9S721.5,640,674.2,640C626.9,640,588.6,662.3,588.6,689.8z"/>

          <linearGradient id="SVGID_00000041287840556266260620000005680770931462135709_" gradientUnits="userSpaceOnUse"
                          x1="202.9399" y1="716.0338" x2="374.1934" y2="716.0338"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000041287840556266260620000005680770931462135709_);" d="M674.2,738.4
						c46.3,0,83.9-21.4,85.5-48.1c0,0.6,0.2,1.1,0.2,1.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9
						c0-0.6,0.1-1.2,0.2-1.7C590.3,717,627.9,738.4,674.2,738.4z"/>

          <linearGradient id="SVGID_00000042726502926339537120000002663733142238425247_" gradientUnits="userSpaceOnUse"
                          x1="357.3742" y1="620.5897" x2="232.1713" y2="746.5901"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>

          <ellipse style="fill:url(#SVGID_00000042726502926339537120000002663733142238425247_);" cx="674.2" cy="689.8"
                   rx="64" ry="37.3"/>

          <linearGradient id="SVGID_00000134951420436743664470000002764401240379713169_" gradientUnits="userSpaceOnUse"
                          x1="226.6908" y1="670.0651" x2="354.7085" y2="670.0651"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000134951420436743664470000002764401240379713169_);" d="M672.1,654.4
						c-34.2,0-62,15.6-63.8,35.3c-0.1-0.7-0.2-1.3-0.2-2c0-20.6,28.7-37.3,64-37.3s64,16.7,64,37.3c0,0.7-0.1,1.3-0.2,2
						C734.1,670.1,706.3,654.4,672.1,654.4z"/>

          <linearGradient id="SVGID_00000171690762246396678080000009843377970360350883_" gradientUnits="userSpaceOnUse"
                          x1="380.4187" y1="593.3012" x2="262.2643" y2="712.2083"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000171690762246396678080000009843377970360350883_);" d="M674.2,656.6
						c-34.2,0-62,15.6-63.8,35.3c-0.1-0.7-0.2-1.3-0.2-2c0-20.6,28.7-37.3,64-37.3c35.4,0,64,16.7,64,37.3c0,0.7-0.1,1.3-0.2,2
						C736.2,672.2,708.4,656.6,674.2,656.6z"/>

          <linearGradient id="SVGID_00000026869126751343572380000001591176585039173549_" gradientUnits="userSpaceOnUse"
                          x1="15584.0439" y1="-6283.1885" x2="15827.0566" y2="-6283.1885"
                          gradientTransform="matrix(-4.830000e-02 -0.142 -0.2866 9.760000e-02 -407.0796 3502.489)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000026869126751343572380000001591176585039173549_);" d="M629.2,641.8
						c-19.2,6.5-32.2,19.6-29,29.1c3.2,9.5,21.5,11.9,40.7,5.4c19.2-6.5,32.2-19.6,29-29.1C666.7,637.7,648.5,635.3,629.2,641.8z"/>
          <g>

							<linearGradient id="SVGID_00000132792880706252703390000001583235935091436180_"
                              gradientUnits="userSpaceOnUse" x1="256.5931" y1="690.3158" x2="320.4057" y2="690.3158"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000132792880706252703390000001583235935091436180_);" d="M672.4,669.3
							c1.4,0.4,2.9,0.8,4.5,1.2c1.6,0.4,3.3,0.9,5.1,1.5c1.8,0.6,3.5,1.2,5.3,1.9c1.8,0.7,3.6,1.4,5.3,2.3l5.8-3.4l5.8,3.3l-5.8,3.3
							c2.1,1.4,3.7,2.9,5,4.4c1.3,1.5,2.1,3.1,2.5,4.6c0.3,1.5,0.2,3-0.6,4.4c-0.7,1.4-2.1,2.7-4.2,3.9c-1.5,0.9-3.1,1.5-4.7,1.8
							c-1.6,0.4-3.4,0.5-5.4,0.4c-1.9-0.1-4.1-0.4-6.4-0.9c-2.3-0.5-4.9-1.3-7.8-2.2c-1.9-0.6-3.8-1.3-5.5-1.9l-5,2.9
							c1.9,0.9,3.9,1.7,6.1,2.3c2.1,0.7,4.1,1.2,5.8,1.7c2.1,0.5,4.1,1,6,1.4l-3.7,9.1c-3.8-0.8-7.7-1.9-11.8-3.3
							c-4.1-1.4-7.9-3-11.4-4.8l-7,4.1l-5.8-3.3l6.9-4c-2.1-1.3-3.9-2.8-5.5-4.2c-1.5-1.5-2.6-3-3.2-4.5c-0.6-1.5-0.6-3,0-4.5
							c0.6-1.5,2-2.9,4.3-4.2c1.9-1.1,3.9-1.8,5.9-2.2c2.1-0.4,4.2-0.4,6.5-0.2c2.3,0.2,4.7,0.7,7.3,1.4c2.6,0.7,5.3,1.6,8.2,2.6
							c0.6,0.2,1.3,0.5,1.9,0.7c0.6,0.2,1.2,0.4,1.7,0.6l5.1-3c-1.5-0.7-3.1-1.3-4.8-1.8c-1.7-0.6-3.3-1-4.7-1.4
							c-1.7-0.5-3.3-0.8-4.9-1.1L672.4,669.3z M687.7,684.5l-4.3,2.5c1.3,0.4,2.3,0.6,3.2,0.7c0.8,0.1,1.5-0.1,2.1-0.4
							C689.7,686.7,689.4,685.7,687.7,684.5z M660.6,693c0.2,0.5,0.8,1,1.9,1.7l4.2-2.4c-1.3-0.4-2.4-0.6-3.4-0.7
							c-1-0.1-1.7,0-2.3,0.3C660.6,692.2,660.4,692.5,660.6,693z"/>
					</g>
          <g>

							<linearGradient id="SVGID_00000062171136409081445690000016239647606522088348_"
                              gradientUnits="userSpaceOnUse" x1="351.0405" y1="653.6695" x2="296.6328" y2="683.3626"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000062171136409081445690000016239647606522088348_);" d="M672.4,667.2
							c1.4,0.4,2.9,0.8,4.5,1.2c1.6,0.4,3.3,0.9,5.1,1.5c1.8,0.6,3.5,1.2,5.3,1.9c1.8,0.7,3.6,1.4,5.3,2.3l5.8-3.4l5.8,3.3l-5.8,3.3
							c2.1,1.4,3.7,2.9,5,4.4c1.3,1.5,2.1,3.1,2.5,4.6c0.3,1.5,0.2,3-0.6,4.4c-0.7,1.4-2.1,2.7-4.2,3.9c-1.5,0.9-3.1,1.5-4.7,1.8
							c-1.6,0.4-3.4,0.5-5.4,0.4c-1.9-0.1-4.1-0.4-6.4-0.9c-2.3-0.5-4.9-1.3-7.8-2.2c-1.9-0.6-3.8-1.3-5.5-1.9l-5,2.9
							c1.9,0.9,3.9,1.7,6.1,2.3c2.1,0.7,4.1,1.2,5.8,1.7c2.1,0.5,4.1,1,6,1.4l-3.7,9.1c-3.8-0.8-7.7-1.9-11.8-3.3
							c-4.1-1.4-7.9-3-11.4-4.8l-7,4.1l-5.8-3.3l6.9-4c-2.1-1.3-3.9-2.8-5.5-4.2c-1.5-1.5-2.6-3-3.2-4.5c-0.6-1.5-0.6-3,0-4.5
							c0.6-1.5,2-2.9,4.3-4.2c1.9-1.1,3.9-1.8,5.9-2.2c2.1-0.4,4.2-0.4,6.5-0.2c2.3,0.2,4.7,0.7,7.3,1.4c2.6,0.7,5.3,1.6,8.2,2.6
							c0.6,0.2,1.3,0.5,1.9,0.7c0.6,0.2,1.2,0.4,1.7,0.6l5.1-3c-1.5-0.7-3.1-1.3-4.8-1.8c-1.7-0.6-3.3-1-4.7-1.4
							c-1.7-0.5-3.3-0.8-4.9-1.1L672.4,667.2z M687.7,682.4l-4.3,2.5c1.3,0.4,2.3,0.6,3.2,0.7c0.8,0.1,1.5-0.1,2.1-0.4
							C689.7,684.5,689.4,683.6,687.7,682.4z M660.6,690.9c0.2,0.5,0.8,1,1.9,1.7l4.2-2.4c-1.3-0.4-2.4-0.6-3.4-0.7
							c-1-0.1-1.7,0-2.3,0.3C660.6,690,660.4,690.4,660.6,690.9z"/>
					</g>

          <linearGradient id="SVGID_00000089532648797731916510000003891886143546705554_" gradientUnits="userSpaceOnUse"
                          x1="256.5931" y1="688.1821" x2="320.4057" y2="688.1821"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000089532648797731916510000003891886143546705554_);" d="M672.4,667.2c1.4,0.4,2.9,0.8,4.5,1.2
						c1.6,0.4,3.3,0.9,5.1,1.5c1.8,0.6,3.5,1.2,5.3,1.9c1.8,0.7,3.6,1.4,5.3,2.3l5.8-3.4l5.8,3.3l-5.8,3.3c2.1,1.4,3.7,2.9,5,4.4
						c1.3,1.5,2.1,3.1,2.5,4.6c0.3,1.5,0.2,3-0.6,4.4c-0.7,1.4-2.1,2.7-4.2,3.9c-1.5,0.9-3.1,1.5-4.7,1.8c-1.6,0.4-3.4,0.5-5.4,0.4
						c-1.9-0.1-4.1-0.4-6.4-0.9c-2.3-0.5-4.9-1.3-7.8-2.2c-1.9-0.6-3.8-1.3-5.5-1.9l-5,2.9c1.9,0.9,3.9,1.7,6.1,2.3
						c2.1,0.7,4.1,1.2,5.8,1.7c2.1,0.5,4.1,1,6,1.4l-3.7,9.1c-3.8-0.8-7.7-1.9-11.8-3.3c-4.1-1.4-7.9-3-11.4-4.8l-7,4.1l-5.8-3.3
						l6.9-4c-2.1-1.3-3.9-2.8-5.5-4.2c-1.5-1.5-2.6-3-3.2-4.5c-0.6-1.5-0.6-3,0-4.5c0.6-1.5,2-2.9,4.3-4.2c1.9-1.1,3.9-1.8,5.9-2.2
						c2.1-0.4,4.2-0.4,6.5-0.2c2.3,0.2,4.7,0.7,7.3,1.4c2.6,0.7,5.3,1.6,8.2,2.6c0.6,0.2,1.3,0.5,1.9,0.7c0.6,0.2,1.2,0.4,1.7,0.6
						l5.1-3c-1.5-0.7-3.1-1.3-4.8-1.8c-1.7-0.6-3.3-1-4.7-1.4c-1.7-0.5-3.3-0.8-4.9-1.1L672.4,667.2z M687.7,682.4l-4.3,2.5
						c1.3,0.4,2.3,0.6,3.2,0.7c0.8,0.1,1.5-0.1,2.1-0.4C689.7,684.5,689.4,683.6,687.7,682.4z M660.6,690.9c0.2,0.5,0.8,1,1.9,1.7
						l4.2-2.4c-1.3-0.4-2.4-0.6-3.4-0.7c-1-0.1-1.7,0-2.3,0.3C660.6,690,660.4,690.4,660.6,690.9z"/>
				</g>
        <g>

						<linearGradient id="SVGID_00000147941160299801962400000006760601460532246162_"
                            gradientUnits="userSpaceOnUse" x1="203.7558" y1="698.3989" x2="372.2985" y2="698.3989"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000147941160299801962400000006760601460532246162_);" d="M588.6,661h171.3v24.2h0
						c0,0.2,0,0.5,0,0.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9c0-0.2,0-0.5,0-0.7h0V661z"/>
          <g>

							<linearGradient id="SVGID_00000178189535691917574370000012476151028691283086_"
                              gradientUnits="userSpaceOnUse" x1="202.9394" y1="682.3465" x2="202.9693" y2="682.3465"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000178189535691917574370000012476151028691283086_);" d="M759.8,682v0.7
							C759.8,682.5,759.8,682.2,759.8,682L759.8,682z"/>

            <linearGradient id="SVGID_00000116220506081147289280000007847980299487810981_"
                            gradientUnits="userSpaceOnUse" x1="203.7558" y1="708.1555" x2="372.2977" y2="708.1555"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000116220506081147289280000007847980299487810981_);" d="M674.2,730.4
							c47.3,0,85.6-22.3,85.6-49.9v4.6h0c0,0.2,0,0.5,0,0.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9
							c0-0.2,0-0.5,0-0.7h0v-4.6C588.6,708.1,626.9,730.4,674.2,730.4z"/>

            <linearGradient id="SVGID_00000040541995813607965380000007440140978884251019_"
                            gradientUnits="userSpaceOnUse" x1="374.1637" y1="682.3465" x2="374.1923" y2="682.3465"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000040541995813607965380000007440140978884251019_);" d="M588.6,682.7V682h0
							C588.6,682.2,588.6,682.5,588.6,682.7z"/>
					</g>
          <g>

							<linearGradient id="SVGID_00000139268073129468326250000009097246736016434561_"
                              gradientUnits="userSpaceOnUse" x1="314.7943" y1="701.4365" x2="317.1946" y2="701.4365"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000139268073129468326250000009097246736016434561_);" d="M648,733.3c-0.8-0.2-1.6-0.3-2.4-0.5
							v-63.3h2.4V733.3z"/>

            <linearGradient id="SVGID_00000006709846339660118560000011737014710612949691_"
                            gradientUnits="userSpaceOnUse" x1="325.5518" y1="700.1667" x2="327.9522" y2="700.1667"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000006709846339660118560000011737014710612949691_);" d="M637.2,730.8
							c-0.8-0.2-1.6-0.4-2.4-0.7v-60.6h2.4V730.8z"/>

            <linearGradient id="SVGID_00000065033397854193701920000009923378804887131837_"
                            gradientUnits="userSpaceOnUse" x1="336.3087" y1="698.4041" x2="338.7091" y2="698.4041"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000065033397854193701920000009923378804887131837_);" d="M626.5,727.3c-0.8-0.3-1.6-0.7-2.4-1
							v-56.7h2.4V727.3z"/>

            <linearGradient id="SVGID_00000129889964883894053030000016811546104666969757_"
                            gradientUnits="userSpaceOnUse" x1="304.0374" y1="702.2113" x2="306.4377" y2="702.2113"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000129889964883894053030000016811546104666969757_);" d="M658.7,734.9
							c-0.8-0.1-1.6-0.2-2.4-0.3v-65.1h2.4V734.9z"/>

            <linearGradient id="SVGID_00000026852085828466478220000004398365122203000720_"
                            gradientUnits="userSpaceOnUse" x1="357.8232" y1="692.3268" x2="360.2235" y2="692.3268"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000026852085828466478220000004398365122203000720_);" d="M604.9,715.1c-0.8-0.7-1.6-1.3-2.4-2
							v-43.6h2.4V715.1z"/>

            <linearGradient id="SVGID_00000082354918794560095530000015004899750507956921_"
                            gradientUnits="userSpaceOnUse" x1="368.5794" y1="686.5244" x2="370.9797" y2="686.5244"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000082354918794560095530000015004899750507956921_);" d="M594.2,703.5
							c-0.9-1.4-1.7-2.8-2.4-4.2v-29.8h2.4V703.5z"/>

            <linearGradient id="SVGID_00000009570888240577864910000002920865369453973165_"
                            gradientUnits="userSpaceOnUse" x1="347.0649" y1="695.8782" x2="349.4653" y2="695.8782"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000009570888240577864910000002920865369453973165_);" d="M615.7,722.2
							c-0.8-0.4-1.6-0.9-2.4-1.3v-51.4h2.4V722.2z"/>

            <linearGradient id="SVGID_00000080196251299604775990000016921274062611026620_"
                            gradientUnits="userSpaceOnUse" x1="293.2805" y1="702.5692" x2="295.6808" y2="702.5692"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000080196251299604775990000016921274062611026620_);" d="M669.5,735.6c-0.8,0-1.6,0-2.4-0.1
							v-66h2.4V735.6z"/>

            <linearGradient id="SVGID_00000062891729067558627430000007187206786867621303_"
                            gradientUnits="userSpaceOnUse" x1="282.523" y1="702.5847" x2="284.9232" y2="702.5847"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000062891729067558627430000007187206786867621303_);" d="M680.2,735.6c-0.8,0-1.6,0.1-2.4,0.1
							v-66.1h2.4V735.6z"/>

            <linearGradient id="SVGID_00000119109004623562831900000010740678883742253458_"
                            gradientUnits="userSpaceOnUse" x1="261.0099" y1="701.5409" x2="263.4102" y2="701.5409"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000119109004623562831900000010740678883742253458_);" d="M701.8,733.1
							c-0.8,0.2-1.6,0.3-2.4,0.5v-64h2.4V733.1z"/>

            <linearGradient id="SVGID_00000129187958322274373930000004509655334159490479_"
                            gradientUnits="userSpaceOnUse" x1="271.7667" y1="702.2587" x2="274.1671" y2="702.2587"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000129187958322274373930000004509655334159490479_);" d="M691,734.8c-0.8,0.1-1.6,0.1-2.4,0.2
							v-65.5h2.4V734.8z"/>

            <linearGradient id="SVGID_00000134962493765579547320000002002004955378379172_"
                            gradientUnits="userSpaceOnUse" x1="250.2523" y1="700.3168" x2="252.6526" y2="700.3168"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000134962493765579547320000002002004955378379172_);" d="M712.5,730.4
							c-0.8,0.2-1.6,0.5-2.4,0.7v-61.6h2.4V730.4z"/>

            <linearGradient id="SVGID_00000068678784656876418690000014917599491433762999_"
                            gradientUnits="userSpaceOnUse" x1="207.2247" y1="687.3771" x2="209.625" y2="687.3771"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000068678784656876418690000014917599491433762999_);" d="M755.5,701.4
							c-0.7,1.3-1.5,2.6-2.4,3.8v-35.7h2.4V701.4z"/>

            <linearGradient id="SVGID_00000157309106578107496210000003998747853239574422_"
                            gradientUnits="userSpaceOnUse" x1="217.9809" y1="692.7441" x2="220.3813" y2="692.7441"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000157309106578107496210000003998747853239574422_);" d="M744.8,714.1
							c-0.8,0.6-1.6,1.2-2.4,1.9v-46.4h2.4V714.1z"/>

            <linearGradient id="SVGID_00000183968924623547599140000012565517559023250824_"
                            gradientUnits="userSpaceOnUse" x1="239.4955" y1="698.5939" x2="241.8957" y2="698.5939"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000183968924623547599140000012565517559023250824_);" d="M723.3,726.7
							c-0.8,0.3-1.6,0.6-2.4,0.9v-58.1h2.4V726.7z"/>

            <linearGradient id="SVGID_00000123411729009793924540000008390928754975933619_"
                            gradientUnits="userSpaceOnUse" x1="228.7385" y1="696.162" x2="231.1388" y2="696.162"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000123411729009793924540000008390928754975933619_);" d="M734,721.5c-0.8,0.4-1.6,0.8-2.4,1.3
							v-53.3h2.4V721.5z"/>
					</g>

          <linearGradient id="SVGID_00000070801172810191389700000016051606212213899677_" gradientUnits="userSpaceOnUse"
                          x1="446.7802" y1="502.1658" x2="279.2908" y2="670.7222"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000070801172810191389700000016051606212213899677_);" d="M588.6,661.4
						c0,27.5,38.3,49.9,85.6,49.9c47.3,0,85.6-22.3,85.6-49.9c0-27.5-38.3-49.9-85.6-49.9C626.9,611.5,588.6,633.8,588.6,661.4z"/>

          <linearGradient id="SVGID_00000177472093030021583560000018356094950494576291_" gradientUnits="userSpaceOnUse"
                          x1="202.9399" y1="687.5853" x2="374.1934" y2="687.5853"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000177472093030021583560000018356094950494576291_);" d="M674.2,709.9
						c46.3,0,83.9-21.4,85.5-48.1c0,0.6,0.2,1.1,0.2,1.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9
						c0-0.6,0.1-1.2,0.2-1.7C590.3,688.5,627.9,709.9,674.2,709.9z"/>

          <linearGradient id="SVGID_00000035527818949747747780000000610557446746585534_" gradientUnits="userSpaceOnUse"
                          x1="357.3745" y1="592.1411" x2="232.1711" y2="718.142"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000035527818949747747780000000610557446746585534_);" d="M610.2,661.4
						c0,20.6,28.7,37.3,64,37.3c35.4,0,64-16.7,64-37.3c0-20.6-28.7-37.3-64-37.3C638.9,624.1,610.2,640.8,610.2,661.4z"/>

          <linearGradient id="SVGID_00000013156661001559270240000012627997561983565237_" gradientUnits="userSpaceOnUse"
                          x1="226.6908" y1="641.6169" x2="354.7085" y2="641.6169"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000013156661001559270240000012627997561983565237_);" d="M672.1,626c-34.2,0-62,15.6-63.8,35.3
						c-0.1-0.7-0.2-1.3-0.2-2c0-20.6,28.7-37.3,64-37.3s64,16.7,64,37.3c0,0.7-0.1,1.3-0.2,2C734.1,641.6,706.3,626,672.1,626z"/>

          <linearGradient id="SVGID_00000061441550918852344260000007507531382171900328_" gradientUnits="userSpaceOnUse"
                          x1="380.4186" y1="564.8529" x2="262.2643" y2="683.7598"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000061441550918852344260000007507531382171900328_);" d="M674.2,628.1
						c-34.2,0-62,15.6-63.8,35.3c-0.1-0.7-0.2-1.3-0.2-2c0-20.6,28.7-37.3,64-37.3c35.4,0,64,16.7,64,37.3c0,0.7-0.1,1.3-0.2,2
						C736.2,643.7,708.4,628.1,674.2,628.1z"/>

          <linearGradient id="SVGID_00000075159633564984633710000017618403971101692547_" gradientUnits="userSpaceOnUse"
                          x1="15763.5879" y1="-6313.4463" x2="16006.6016" y2="-6313.4463"
                          gradientTransform="matrix(-4.830000e-02 -0.142 -0.2866 9.760000e-02 -407.0796 3502.489)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000075159633564984633710000017618403971101692547_);" d="M629.2,613.4
						c-19.2,6.5-32.2,19.6-29,29.1c3.2,9.5,21.5,11.9,40.7,5.4c19.2-6.5,32.2-19.6,29-29.1C666.7,609.2,648.5,606.8,629.2,613.4z"/>
          <g>

							<linearGradient id="SVGID_00000168798661416535490900000005364187863414536624_"
                              gradientUnits="userSpaceOnUse" x1="256.5931" y1="661.8672" x2="320.4057" y2="661.8672"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000168798661416535490900000005364187863414536624_);" d="M672.4,640.9
							c1.4,0.4,2.9,0.8,4.5,1.2c1.6,0.4,3.3,0.9,5.1,1.5c1.8,0.6,3.5,1.2,5.3,1.9c1.8,0.7,3.6,1.4,5.3,2.3l5.8-3.4l5.8,3.3l-5.8,3.3
							c2.1,1.4,3.7,2.9,5,4.4c1.3,1.5,2.1,3.1,2.5,4.6c0.3,1.5,0.2,3-0.6,4.4c-0.7,1.4-2.1,2.7-4.2,3.9c-1.5,0.9-3.1,1.5-4.7,1.8
							c-1.6,0.4-3.4,0.5-5.4,0.4c-1.9-0.1-4.1-0.4-6.4-0.9c-2.3-0.5-4.9-1.3-7.8-2.2c-1.9-0.6-3.8-1.3-5.5-1.9l-5,2.9
							c1.9,0.9,3.9,1.7,6.1,2.3c2.1,0.7,4.1,1.2,5.8,1.7c2.1,0.5,4.1,1,6,1.4l-3.7,9.1c-3.8-0.8-7.7-1.9-11.8-3.3
							c-4.1-1.4-7.9-3-11.4-4.8l-7,4.1l-5.8-3.3l6.9-4c-2.1-1.3-3.9-2.8-5.5-4.2c-1.5-1.5-2.6-3-3.2-4.5c-0.6-1.5-0.6-3,0-4.5
							c0.6-1.5,2-2.9,4.3-4.2c1.9-1.1,3.9-1.8,5.9-2.2c2.1-0.4,4.2-0.4,6.5-0.2c2.3,0.2,4.7,0.7,7.3,1.4c2.6,0.7,5.3,1.6,8.2,2.6
							c0.6,0.2,1.3,0.5,1.9,0.7c0.6,0.2,1.2,0.4,1.7,0.6l5.1-3c-1.5-0.7-3.1-1.3-4.8-1.8c-1.7-0.6-3.3-1-4.7-1.4
							c-1.7-0.5-3.3-0.8-4.9-1.1L672.4,640.9z M687.7,656.1l-4.3,2.5c1.3,0.4,2.3,0.6,3.2,0.7c0.8,0.1,1.5-0.1,2.1-0.4
							C689.7,658.2,689.4,657.3,687.7,656.1z M660.6,664.6c0.2,0.5,0.8,1,1.9,1.7l4.2-2.4c-1.3-0.4-2.4-0.6-3.4-0.7
							c-1-0.1-1.7,0-2.3,0.3C660.6,663.7,660.4,664.1,660.6,664.6z"/>
					</g>
          <g>

							<linearGradient id="SVGID_00000110452808137046156240000005898513695982751663_"
                              gradientUnits="userSpaceOnUse" x1="351.0405" y1="625.2213" x2="296.6329" y2="654.9144"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000110452808137046156240000005898513695982751663_);" d="M672.4,638.7
							c1.4,0.4,2.9,0.8,4.5,1.2c1.6,0.4,3.3,0.9,5.1,1.5c1.8,0.6,3.5,1.2,5.3,1.9c1.8,0.7,3.6,1.4,5.3,2.3l5.8-3.4l5.8,3.3l-5.8,3.3
							c2.1,1.4,3.7,2.9,5,4.4c1.3,1.5,2.1,3.1,2.5,4.6c0.3,1.5,0.2,3-0.6,4.4c-0.7,1.4-2.1,2.7-4.2,3.9c-1.5,0.9-3.1,1.5-4.7,1.8
							c-1.6,0.4-3.4,0.5-5.4,0.4c-1.9-0.1-4.1-0.4-6.4-0.9c-2.3-0.5-4.9-1.3-7.8-2.2c-1.9-0.6-3.8-1.3-5.5-1.9l-5,2.9
							c1.9,0.9,3.9,1.7,6.1,2.3c2.1,0.7,4.1,1.2,5.8,1.7c2.1,0.5,4.1,1,6,1.4l-3.7,9.1c-3.8-0.8-7.7-1.9-11.8-3.3
							c-4.1-1.4-7.9-3-11.4-4.8l-7,4.1l-5.8-3.3l6.9-4c-2.1-1.3-3.9-2.8-5.5-4.2c-1.5-1.5-2.6-3-3.2-4.5c-0.6-1.5-0.6-3,0-4.5
							c0.6-1.5,2-2.9,4.3-4.2c1.9-1.1,3.9-1.8,5.9-2.2c2.1-0.4,4.2-0.4,6.5-0.2c2.3,0.2,4.7,0.7,7.3,1.4c2.6,0.7,5.3,1.6,8.2,2.6
							c0.6,0.2,1.3,0.5,1.9,0.7c0.6,0.2,1.2,0.4,1.7,0.6l5.1-3c-1.5-0.7-3.1-1.3-4.8-1.8c-1.7-0.6-3.3-1-4.7-1.4
							c-1.7-0.5-3.3-0.8-4.9-1.1L672.4,638.7z M687.7,653.9l-4.3,2.5c1.3,0.4,2.3,0.6,3.2,0.7c0.8,0.1,1.5-0.1,2.1-0.4
							C689.7,656.1,689.4,655.2,687.7,653.9z M660.6,662.4c0.2,0.5,0.8,1,1.9,1.7l4.2-2.4c-1.3-0.4-2.4-0.6-3.4-0.7
							c-1-0.1-1.7,0-2.3,0.3C660.6,661.6,660.4,662,660.6,662.4z"/>
					</g>

          <linearGradient id="SVGID_00000047062255598228529000000002461969533387784095_" gradientUnits="userSpaceOnUse"
                          x1="256.5931" y1="659.7339" x2="320.4057" y2="659.7339"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000047062255598228529000000002461969533387784095_);" d="M672.4,638.7c1.4,0.4,2.9,0.8,4.5,1.2
						c1.6,0.4,3.3,0.9,5.1,1.5c1.8,0.6,3.5,1.2,5.3,1.9c1.8,0.7,3.6,1.4,5.3,2.3l5.8-3.4l5.8,3.3l-5.8,3.3c2.1,1.4,3.7,2.9,5,4.4
						c1.3,1.5,2.1,3.1,2.5,4.6c0.3,1.5,0.2,3-0.6,4.4c-0.7,1.4-2.1,2.7-4.2,3.9c-1.5,0.9-3.1,1.5-4.7,1.8c-1.6,0.4-3.4,0.5-5.4,0.4
						c-1.9-0.1-4.1-0.4-6.4-0.9c-2.3-0.5-4.9-1.3-7.8-2.2c-1.9-0.6-3.8-1.3-5.5-1.9l-5,2.9c1.9,0.9,3.9,1.7,6.1,2.3
						c2.1,0.7,4.1,1.2,5.8,1.7c2.1,0.5,4.1,1,6,1.4l-3.7,9.1c-3.8-0.8-7.7-1.9-11.8-3.3c-4.1-1.4-7.9-3-11.4-4.8l-7,4.1l-5.8-3.3
						l6.9-4c-2.1-1.3-3.9-2.8-5.5-4.2c-1.5-1.5-2.6-3-3.2-4.5c-0.6-1.5-0.6-3,0-4.5c0.6-1.5,2-2.9,4.3-4.2c1.9-1.1,3.9-1.8,5.9-2.2
						c2.1-0.4,4.2-0.4,6.5-0.2c2.3,0.2,4.7,0.7,7.3,1.4c2.6,0.7,5.3,1.6,8.2,2.6c0.6,0.2,1.3,0.5,1.9,0.7c0.6,0.2,1.2,0.4,1.7,0.6
						l5.1-3c-1.5-0.7-3.1-1.3-4.8-1.8c-1.7-0.6-3.3-1-4.7-1.4c-1.7-0.5-3.3-0.8-4.9-1.1L672.4,638.7z M687.7,653.9l-4.3,2.5
						c1.3,0.4,2.3,0.6,3.2,0.7c0.8,0.1,1.5-0.1,2.1-0.4C689.7,656.1,689.4,655.2,687.7,653.9z M660.6,662.4c0.2,0.5,0.8,1,1.9,1.7
						l4.2-2.4c-1.3-0.4-2.4-0.6-3.4-0.7c-1-0.1-1.7,0-2.3,0.3C660.6,661.6,660.4,662,660.6,662.4z"/>
				</g>
        <g>

						<linearGradient id="SVGID_00000022547816132119481850000007663659988601377455_"
                            gradientUnits="userSpaceOnUse" x1="203.7558" y1="669.5071" x2="372.2985" y2="669.5071"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000022547816132119481850000007663659988601377455_);" d="M588.6,632.2h171.3v24.2h0
						c0,0.2,0,0.5,0,0.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9c0-0.2,0-0.5,0-0.7h0V632.2z"/>
          <g>

							<linearGradient id="SVGID_00000142166659069575097240000014091783046454377392_"
                              gradientUnits="userSpaceOnUse" x1="202.9394" y1="653.4547" x2="202.9693" y2="653.4547"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000142166659069575097240000014091783046454377392_);" d="M759.8,653.1v0.7
							C759.8,653.6,759.8,653.3,759.8,653.1L759.8,653.1z"/>

            <linearGradient id="SVGID_00000123403397279244692620000000831586004685398203_"
                            gradientUnits="userSpaceOnUse" x1="203.7558" y1="679.2636" x2="372.2977" y2="679.2636"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000123403397279244692620000000831586004685398203_);" d="M674.2,701.5
							c47.3,0,85.6-22.3,85.6-49.9v4.6h0c0,0.2,0,0.5,0,0.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9
							c0-0.2,0-0.5,0-0.7h0v-4.6C588.6,679.2,626.9,701.5,674.2,701.5z"/>

            <linearGradient id="SVGID_00000086661318666252189640000012865181767909647010_"
                            gradientUnits="userSpaceOnUse" x1="374.1637" y1="653.4547" x2="374.1923" y2="653.4547"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000086661318666252189640000012865181767909647010_);" d="M588.6,653.8v-0.7h0
							C588.6,653.3,588.6,653.6,588.6,653.8z"/>
					</g>
          <g>

							<linearGradient id="SVGID_00000109022781980401162940000013002591534015407033_"
                              gradientUnits="userSpaceOnUse" x1="314.7943" y1="672.5446" x2="317.1946" y2="672.5446"
                              gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
                <stop offset="0.1797" style="stop-color:#196955"/>
                <stop offset="0.4323" style="stop-color:#237B64"/>
                <stop offset="0.7265" style="stop-color:#32997C"/>
                <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000109022781980401162940000013002591534015407033_);" d="M648,704.5c-0.8-0.2-1.6-0.3-2.4-0.5
							v-63.3h2.4V704.5z"/>

            <linearGradient id="SVGID_00000025432050810901777320000012178825647215364758_"
                            gradientUnits="userSpaceOnUse" x1="325.5518" y1="671.275" x2="327.9522" y2="671.275"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000025432050810901777320000012178825647215364758_);" d="M637.2,701.9
							c-0.8-0.2-1.6-0.4-2.4-0.7v-60.6h2.4V701.9z"/>

            <linearGradient id="SVGID_00000096755633758644903970000003431194837674679689_"
                            gradientUnits="userSpaceOnUse" x1="336.3087" y1="669.5123" x2="338.7091" y2="669.5123"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000096755633758644903970000003431194837674679689_);" d="M626.5,698.4c-0.8-0.3-1.6-0.7-2.4-1
							v-56.7h2.4V698.4z"/>

            <linearGradient id="SVGID_00000013900850573662404890000007306352904089334158_"
                            gradientUnits="userSpaceOnUse" x1="304.0374" y1="673.3195" x2="306.4377" y2="673.3195"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000013900850573662404890000007306352904089334158_);" d="M658.7,706c-0.8-0.1-1.6-0.2-2.4-0.3
							v-65.1h2.4V706z"/>

            <linearGradient id="SVGID_00000042006907382912928540000010858005719539977150_"
                            gradientUnits="userSpaceOnUse" x1="357.8232" y1="663.435" x2="360.2235" y2="663.435"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000042006907382912928540000010858005719539977150_);" d="M604.9,686.2c-0.8-0.7-1.6-1.3-2.4-2
							v-43.6h2.4V686.2z"/>

            <linearGradient id="SVGID_00000146502009558027272880000000827581005910135432_"
                            gradientUnits="userSpaceOnUse" x1="368.5794" y1="657.6326" x2="370.9797" y2="657.6326"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000146502009558027272880000000827581005910135432_);" d="M594.2,674.6
							c-0.9-1.4-1.7-2.8-2.4-4.2v-29.8h2.4V674.6z"/>

            <linearGradient id="SVGID_00000049935661272532005750000012102138965969757110_"
                            gradientUnits="userSpaceOnUse" x1="347.0649" y1="666.9864" x2="349.4653" y2="666.9864"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000049935661272532005750000012102138965969757110_);" d="M615.7,693.3
							c-0.8-0.4-1.6-0.9-2.4-1.3v-51.4h2.4V693.3z"/>

            <linearGradient id="SVGID_00000076572356848225578910000008148015310846886561_"
                            gradientUnits="userSpaceOnUse" x1="293.2805" y1="673.6774" x2="295.6808" y2="673.6774"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000076572356848225578910000008148015310846886561_);" d="M669.5,706.7c-0.8,0-1.6,0-2.4-0.1
							v-66h2.4V706.7z"/>

            <linearGradient id="SVGID_00000106144132423902803260000001477227450383488159_"
                            gradientUnits="userSpaceOnUse" x1="282.523" y1="673.6933" x2="284.9232" y2="673.6933"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000106144132423902803260000001477227450383488159_);" d="M680.2,706.7c-0.8,0-1.6,0.1-2.4,0.1
							v-66.1h2.4V706.7z"/>

            <linearGradient id="SVGID_00000131338730202795718220000003279673928946061965_"
                            gradientUnits="userSpaceOnUse" x1="261.0099" y1="672.649" x2="263.4102" y2="672.649"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000131338730202795718220000003279673928946061965_);" d="M701.8,704.2
							c-0.8,0.2-1.6,0.3-2.4,0.5v-64h2.4V704.2z"/>

            <linearGradient id="SVGID_00000098901209722507886150000001264307520029964436_"
                            gradientUnits="userSpaceOnUse" x1="271.7667" y1="673.3669" x2="274.1671" y2="673.3669"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000098901209722507886150000001264307520029964436_);" d="M691,705.9c-0.8,0.1-1.6,0.1-2.4,0.2
							v-65.5h2.4V705.9z"/>

            <linearGradient id="SVGID_00000125565283508010779280000003856382952964543623_"
                            gradientUnits="userSpaceOnUse" x1="250.2523" y1="671.425" x2="252.6526" y2="671.425"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000125565283508010779280000003856382952964543623_);" d="M712.5,701.5
							c-0.8,0.2-1.6,0.5-2.4,0.7v-61.6h2.4V701.5z"/>

            <linearGradient id="SVGID_00000111887648296390692740000003388041896782194863_"
                            gradientUnits="userSpaceOnUse" x1="207.2247" y1="658.4853" x2="209.625" y2="658.4853"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000111887648296390692740000003388041896782194863_);" d="M755.5,672.5
							c-0.7,1.3-1.5,2.6-2.4,3.8v-35.7h2.4V672.5z"/>

            <linearGradient id="SVGID_00000062893678511036686180000018298350299252882601_"
                            gradientUnits="userSpaceOnUse" x1="217.9809" y1="663.8524" x2="220.3813" y2="663.8524"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000062893678511036686180000018298350299252882601_);" d="M744.8,685.2
							c-0.8,0.6-1.6,1.2-2.4,1.9v-46.4h2.4V685.2z"/>

            <linearGradient id="SVGID_00000055678618866114041980000017724430112172563374_"
                            gradientUnits="userSpaceOnUse" x1="239.4955" y1="669.7021" x2="241.8957" y2="669.7021"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000055678618866114041980000017724430112172563374_);" d="M723.3,697.8
							c-0.8,0.3-1.6,0.6-2.4,0.9v-58.1h2.4V697.8z"/>

            <linearGradient id="SVGID_00000106141098007142860130000017226027418468124058_"
                            gradientUnits="userSpaceOnUse" x1="228.7385" y1="667.2703" x2="231.1388" y2="667.2703"
                            gradientTransform="matrix(-1 0 0 1 962.7682 0)">
							<stop offset="0" style="stop-color:#166250"/>
              <stop offset="0.1797" style="stop-color:#196955"/>
              <stop offset="0.4323" style="stop-color:#237B64"/>
              <stop offset="0.7265" style="stop-color:#32997C"/>
              <stop offset="1" style="stop-color:#44BB98"/>
						</linearGradient>
            <path style="fill:url(#SVGID_00000106141098007142860130000017226027418468124058_);" d="M734,692.6c-0.8,0.4-1.6,0.8-2.4,1.3
							v-53.3h2.4V692.6z"/>
					</g>

          <linearGradient id="SVGID_00000039841979797145715920000001180975749951162532_" gradientUnits="userSpaceOnUse"
                          x1="446.7802" y1="473.2742" x2="279.2908" y2="641.8306"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000039841979797145715920000001180975749951162532_);" d="M588.6,632.5
						c0,27.5,38.3,49.9,85.6,49.9c47.3,0,85.6-22.3,85.6-49.9c0-27.5-38.3-49.9-85.6-49.9C626.9,582.6,588.6,605,588.6,632.5z"/>

          <linearGradient id="SVGID_00000049912643063887512960000017631747066351883168_" gradientUnits="userSpaceOnUse"
                          x1="202.9399" y1="658.6935" x2="374.1934" y2="658.6935"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000049912643063887512960000017631747066351883168_);" d="M674.2,681
						c46.3,0,83.9-21.4,85.5-48.1c0,0.6,0.2,1.1,0.2,1.7c0,27.5-38.3,49.9-85.6,49.9c-47.3,0-85.6-22.3-85.6-49.9
						c0-0.6,0.1-1.2,0.2-1.7C590.3,659.6,627.9,681,674.2,681z"/>

          <linearGradient id="SVGID_00000067939592008523800110000010214884944382596529_" gradientUnits="userSpaceOnUse"
                          x1="357.3745" y1="563.2495" x2="232.1711" y2="689.2504"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000067939592008523800110000010214884944382596529_);" d="M610.2,632.5
						c0,20.6,28.7,37.3,64,37.3c35.4,0,64-16.7,64-37.3c0-20.6-28.7-37.3-64-37.3C638.9,595.2,610.2,611.9,610.2,632.5z"/>

          <linearGradient id="SVGID_00000033337533963322178180000006668214937444029349_" gradientUnits="userSpaceOnUse"
                          x1="226.6908" y1="612.7252" x2="354.7085" y2="612.7252"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000033337533963322178180000006668214937444029349_);" d="M672.1,597.1
						c-34.2,0-62,15.6-63.8,35.3c-0.1-0.7-0.2-1.3-0.2-2c0-20.6,28.7-37.3,64-37.3s64,16.7,64,37.3c0,0.7-0.1,1.3-0.2,2
						C734.1,612.7,706.3,597.1,672.1,597.1z"/>

          <linearGradient id="SVGID_00000099658103318928031730000014553787819866115006_" gradientUnits="userSpaceOnUse"
                          x1="380.4186" y1="535.9611" x2="262.2643" y2="654.868"
                          gradientTransform="matrix(-1 0 0 1 962.7682 0)">
						<stop offset="0" style="stop-color:#166250"/>
            <stop offset="0.1797" style="stop-color:#196955"/>
            <stop offset="0.4323" style="stop-color:#237B64"/>
            <stop offset="0.7265" style="stop-color:#32997C"/>
            <stop offset="1" style="stop-color:#44BB98"/>
					</linearGradient>
          <path style="fill:url(#SVGID_00000099658103318928031730000014553787819866115006_);" d="M674.2,599.2
						c-34.2,0-62,15.6-63.8,35.3c-0.1-0.7-0.2-1.3-0.2-2c0-20.6,28.7-37.3,64-37.3c35.4,0,64,16.7,64,37.3c0,0.7-0.1,1.3-0.2,2
						C736.2,614.8,708.4,599.2,674.2,599.2z"/>
				</g>
			</g>
		</g>
    <g>
			<g class="st559">
				<path class="st5" d="M109.3,356.7c4.9,0,9.3,1.1,12.9,3.1l62.9,27.9l62.9,27.9c4.7,2.7,72.4,33.3,72.4,38.1
					c0,5.2-61.1,20.5-66.7,23.8l-7.1,2.9c-4.4,2.6-40.8-19.9-44.3-21.9l-55.1-35.3L92,387.7c-4.7-2.7-7.4-7-7.4-11.7
					c0-5.2,3.2-10.1,8.9-13.3C93.5,362.7,103.6,356.7,109.3,356.7z"/>
        <path class="st560" d="M94.9,363.1c0,0,9.5-5.5,14.9-5.6c4.6,0,8.9,0.9,12.2,2.8l59.2,26.5l25.6,11.4l33.7,15.1
					c2.8,1.6,31.8,15.1,50.3,24.7c10.1,5.3,17.4,9.9,17.2,11.6c-0.1,1.1-3.1,2.8-7.6,4.6c-8.4,3.4-22.1,7.2-33.6,10.6
					c-10.2,2.9-19.4,5.2-21.3,6.3l-6.6,2.5c-4,2.3-38.3-18.9-41.5-20.7l-16.5-10.6l-35.2-22.6l-45.7-29.4c-0.1,0-5.9-3.7-5.9-3.8
					c-4.4-2.5-6.9-6.5-7.1-10.9C86.8,370.7,89.6,366.2,94.9,363.1z"/>
        <path class="st561" d="M96.2,363.5c0,0,8.8-5.1,14-5.2c4.4-0.1,8.4,0.8,11.4,2.6l55.6,25.2l24,10.9l31.6,14.3
					c2.5,1.4,30.6,14.7,47.3,23.4c9.4,4.9,16,9.4,15.4,11.1c0,1-3.1,2.7-7.1,4.3c-7.9,3.2-20.8,6.6-31.4,9.5
					c-9.2,2.5-18.1,4.2-19.8,5.2L231,467c-3.6,2.1-35.8-17.9-38.7-19.6l-15.4-9.9l-32.8-21.1l-42.7-27.5c-0.1-0.1-5.4-3.4-5.5-3.5
					c-4.1-2.4-6.5-6-6.7-10.1C88.8,370.7,91.2,366.4,96.2,363.5z"/>
        <path class="st562" d="M97.5,364c0,0,8.2-4.6,13.2-4.8c4.1-0.1,7.9,0.7,10.7,2.3l52,23.8l22.4,10.3l29.6,13.5
					c2.2,1.3,29.4,14.3,44.2,22c8.7,4.6,14.5,8.9,13.6,10.6c0,0.9-3,2.6-6.6,4c-7.4,3-19.5,6-29.2,8.5c-8.2,2.1-16.8,3.3-18.3,4.2
					l-5.7,1.7c-3.2,1.9-33.3-16.9-35.9-18.4l-14.3-9.2L142.6,413l-39.7-25.6c-0.2-0.1-4.9-3.1-5.2-3.3c-3.8-2.2-6-5.6-6.4-9.3
					C90.9,370.6,92.9,366.6,97.5,364z"/>
        <path class="st563" d="M98.8,364.4c0,0,7.6-4.2,12.3-4.4c3.8-0.1,7.4,0.6,10,2.1l48.4,22.5l20.9,9.7l27.5,12.8
					c1.9,1.1,28.2,13.9,41.2,20.7c8,4.2,13,8.3,11.8,10.1c0,0.8-3,2.4-6.1,3.7c-6.9,2.9-18.1,5.4-27,7.5c-7.2,1.8-15.5,2.3-16.8,3.1
					l-5.3,1.4c-2.8,1.6-30.8-15.9-33.1-17.2l-13.2-8.5l-28.2-18.2l-36.7-23.7c-0.2-0.1-4.5-2.8-4.8-3c-3.4-2-5.6-5.1-6.1-8.5
					C93,370.5,94.6,366.9,98.8,364.4z"/>
        <path class="st564" d="M100.1,364.9c0,0,6.9-3.8,11.4-4c3.6-0.1,6.9,0.4,9.3,1.8l44.7,21.1l19.3,9.1l25.4,12
					c1.7,1,27,13.5,38.1,19.3c7.3,3.8,11.6,7.8,10,9.6c0,0.6-2.9,2.3-5.6,3.5c-6.4,2.7-16.8,4.7-24.8,6.5
					c-6.2,1.4-14.2,1.4-15.4,2.1l-4.8,1c-2.4,1.4-28.3-14.9-30.2-16l-12.1-7.9l-25.9-16.7L106,384.5c-0.3-0.1-4-2.5-4.4-2.8
					c-3.1-1.8-5.1-4.6-5.8-7.6C95.1,370.5,96.2,367.1,100.1,364.9z"/>
        <path class="st565" d="M101.4,365.3c0,0,6.3-3.3,10.6-3.6c3.3-0.2,6.4,0.3,8.6,1.6l41.1,19.8l17.7,8.5l23.4,11.2
					c1.4,0.8,25.8,13.1,35.1,18c6.6,3.5,10.1,7.3,8.2,9.2c0,0.5-2.9,2.2-5.1,3.2c-6,2.5-15.5,4.1-22.7,5.5c-5.2,1-12.9,0.4-13.9,1
					l-4.3,0.6c-2,1.2-25.8-13.9-27.4-14.9l-11-7.2l-23.5-15.3L107.5,383c-0.3-0.2-3.6-2.2-4-2.5c-2.8-1.7-4.7-4.2-5.5-6.8
					C97.2,370.4,97.9,367.3,101.4,365.3z"/>
        <path class="st566" d="M102.8,365.7c0,0,5.7-2.9,9.7-3.2c3-0.2,5.9,0.2,7.9,1.3l37.5,18.4l16.2,7.9l21.3,10.5
					c1.1,0.6,24.6,12.7,32,16.6c5.9,3.1,8.6,6.8,6.4,8.7c0,0.4-2.8,2.1-4.6,2.9c-5.5,2.4-14.1,3.5-20.5,4.5
					c-4.2,0.7-11.6-0.5-12.4-0.1l-3.9,0.2c-1.6,0.9-23.4-12.9-24.6-13.7l-10-6.5l-21.2-13.8l-27.6-18c-0.4-0.2-3.1-1.9-3.6-2.3
					c-2.5-1.5-4.3-3.7-5.1-6C99.2,370.3,99.6,367.6,102.8,365.7z"/>
        <path class="st567" d="M104.1,366.2c0,0,5.1-2.4,8.9-2.8c2.8-0.2,5.4,0.1,7.2,1.1l33.9,17.1l14.6,7.4l19.3,9.7
					c0.8,0.5,23.4,12.3,29,15.3c5.2,2.7,7.1,6.3,4.6,8.2c0,0.3-2.8,2-4.1,2.6c-5,2.2-12.7,2.8-18.3,3.5c-3.2,0.4-10.3-1.4-10.9-1.1
					l-3.4-0.2c-1.2,0.7-20.9-11.9-21.8-12.5l-8.9-5.8l-18.9-12.4l-24.6-16.1c-0.4-0.2-2.7-1.6-3.2-2c-2.2-1.3-3.9-3.2-4.8-5.2
					C101.3,370.3,101.2,367.8,104.1,366.2z"/>
        <path class="st568" d="M105.4,366.6c0,0,4.4-2,8-2.4c2.5-0.2,4.9-0.1,6.5,0.8l30.2,15.7l13,6.8l17.2,8.9
					c0.6,0.3,22.2,11.9,25.9,13.9c4.5,2.4,5.6,5.8,2.8,7.7c0,0.2-2.7,1.9-3.6,2.3c-4.5,2.1-11.4,3.2-16.1,2.5c-2,0.6-9-2.4-9.4-2.2
					l-3-0.6c-0.8,0.5-18.4-11-19-11.3l-7.8-5.1l-16.6-10.9l-21.6-14.2c-0.5-0.3-2.2-1.3-2.8-1.7c-1.9-1.1-3.5-2.7-4.5-4.3
					C103.3,370.2,102.9,368,105.4,366.6z"/>
        <path class="st569" d="M106.7,367c0,0,3.8-1.6,7.2-2c2.2-0.3,4.4-0.2,5.8,0.6l26.6,14.4l11.5,6.2l15.1,8.2
					c0.3,0.2,21,11.6,22.9,12.6c3.7,2,4.1,5.3,1,7.2c0,0.1-2.6,1.9-3.1,2.1c-4.1,1.9-10,2.7-13.9,1.5c-1,0.3-7.7-3.3-7.9-3.2l-2.5-1
					c-0.4,0.2-15.9-10-16.2-10.1l-6.7-4.4l-14.2-9.4l-18.6-12.3c-0.5-0.3-1.7-1-2.5-1.5c-1.6-1-3.1-2.2-4.2-3.5
					C105.4,370.2,104.6,368.3,106.7,367z"/>
        <path d="M170.1,412.5l-27.5-18.4l-27.5-18.4c-3-1.7-10.7-6.2-7.2-8.2c0,0,8.4-3,11.4-1.2l32.9,18.6l32.9,18.6
					c3,1.7,2.6,4.8-0.8,6.7l-2.6,1.8C178.4,414,173.1,414.2,170.1,412.5z"/>
			</g>
      <polygon class="st409" points="88.9,303.6 88.9,370.9 79.1,365.4 79.1,298.1 			"/>

      <linearGradient id="SVGID_00000001634543177431031370000000499390516669522574_" gradientUnits="userSpaceOnUse"
                      x1="88.7491" y1="322.5856" x2="136.7875" y2="322.5856">
				<stop offset="0" style="stop-color:#166250"/>
        <stop offset="0.1797" style="stop-color:#196955"/>
        <stop offset="0.4323" style="stop-color:#237B64"/>
        <stop offset="0.7265" style="stop-color:#32997C"/>
        <stop offset="1" style="stop-color:#44BB98"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000001634543177431031370000000499390516669522574_);" points="88.7,303.6 88.7,370.9
				136.8,341.4 136.8,274.2 			"/>

      <linearGradient id="SVGID_00000183243098701261425640000013292349889374251398_" gradientUnits="userSpaceOnUse"
                      x1="79.1413" y1="286.0658" x2="136.7875" y2="286.0658">
				<stop offset="0" style="stop-color:#166250"/>
        <stop offset="0.1797" style="stop-color:#196955"/>
        <stop offset="0.4323" style="stop-color:#237B64"/>
        <stop offset="0.7265" style="stop-color:#32997C"/>
        <stop offset="1" style="stop-color:#44BB98"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000183243098701261425640000013292349889374251398_);" points="136.8,274.2 88.7,303.6
				79.1,298.1 127.5,268.6 			"/>
      <polygon class="st409" points="213.8,366.7 213.8,406.6 103.2,342.8 103.2,302.9 			"/>

      <linearGradient id="SVGID_00000096027064771187825950000003851860154375412101_" gradientUnits="userSpaceOnUse"
                      x1="1570.8329" y1="375.0703" x2="1570.8329" y2="424.8788"
                      gradientTransform="matrix(-1 0 0 1 1791.6339 0)">
				<stop offset="0" style="stop-color:#8F77B5"/>
        <stop offset="0.1485" style="stop-color:#967DB8"/>
        <stop offset="0.3573" style="stop-color:#A88EC2"/>
        <stop offset="0.5808" style="stop-color:#C3A8D0"/>
        <stop offset="0.7574" style="stop-color:#CEB8D9"/>
        <stop offset="1" style="stop-color:#E2D4E8"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000096027064771187825950000003851860154375412101_);" points="213.6,366.7 213.6,406.6
				228,397.8 228,358.1 			"/>
      <polygon class="st402" points="228,358.1 213.6,366.7 103.2,302.9 117.8,294.1 			"/>
      <polygon class="st402" points="228,358.1 217.4,364.1 111.7,298.2 117.8,294.1 			"/>
      <polygon class="st409" points="421.9,291.6 421.9,314.7 217.4,241 220,176.4 			"/>

      <linearGradient id="SVGID_00000072969431103963897000000006188840994229163147_" gradientUnits="userSpaceOnUse"
                      x1="1529.5553" y1="380.7481" x2="1592.3008" y2="380.7481"
                      gradientTransform="matrix(-1 0 0 1 1791.6339 0)">
				<stop offset="0" style="stop-color:#166250"/>
        <stop offset="0.1797" style="stop-color:#196955"/>
        <stop offset="0.4323" style="stop-color:#237B64"/>
        <stop offset="0.7265" style="stop-color:#32997C"/>
        <stop offset="1" style="stop-color:#44BB98"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000072969431103963897000000006188840994229163147_);" d="M198.6,343.9h63.8v54.9h0
				c0,0.1,0,0.2,0,0.3c0,10.3-14.3,18.6-31.9,18.6c-17.6,0-31.9-8.3-31.9-18.6c0-0.1,0-0.2,0-0.3h0V343.9z"/>

      <linearGradient id="SVGID_00000073697950650388448920000016631935785861571225_" gradientUnits="userSpaceOnUse"
                      x1="1535.8988" y1="329.4616" x2="1586.3588" y2="358.5947"
                      gradientTransform="matrix(-1 0 0 1 1791.6339 0)">
				<stop offset="0" style="stop-color:#166250"/>
        <stop offset="0.1797" style="stop-color:#196955"/>
        <stop offset="0.4323" style="stop-color:#237B64"/>
        <stop offset="0.7265" style="stop-color:#32997C"/>
        <stop offset="1" style="stop-color:#44BB98"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000073697950650388448920000016631935785861571225_);" d="M198.6,344c0,10.3,14.3,18.6,31.9,18.6
				c17.6,0,31.9-8.3,31.9-18.6s-14.3-18.6-31.9-18.6C212.9,325.5,198.6,333.8,198.6,344z"/>
      <path class="st409" d="M204.4,309.9h52.3v31.5h0c0,0.1,0,0.1,0,0.2c0,8.4-11.7,15.2-26.1,15.2c-14.4,0-26.1-6.8-26.1-15.2
				c0-0.1,0-0.1,0-0.2h0V309.9z"/>
      <path class="st575" d="M155.4,275.1c0,12.5,4.3,21.4,11.3,25.7c0,0,180.2,101,180.4,101.2c7.3,4.1,2.6-5.2,13.7-11.6
				c22.3-12.9,40.4-44.1,40.4-69.7c0-12.7,11.7-12.8,4.5-17c0,0-181.6-101.3-181.8-101.4c-7.3-3.9-17.2-3.2-28.2,3.1
				C173.4,218.2,155.4,249.4,155.4,275.1z"/>
      <path class="st575" d="M336.8,376.6c0,25.6,18.1,35.9,40.4,23c22.3-12.9,40.4-44.1,40.4-69.7c0-25.6-18.1-35.9-40.4-23
				C354.9,319.7,336.8,350.9,336.8,376.6z"/>

      <radialGradient id="SVGID_00000173877594314630565820000018414771887326731137_" cx="1373.3792" cy="337.6261"
                      r="43.8924" gradientTransform="matrix(-1 0 0 1 1730.4019 0)" gradientUnits="userSpaceOnUse">
				<stop offset="0" style="stop-color:#FFFFFF"/>
        <stop offset="1" style="stop-color:#000000"/>
			</radialGradient>
      <path style="fill:url(#SVGID_00000173877594314630565820000018414771887326731137_);" d="M375.4,305.7c10.8-6.2,20.5-7,27.8-3.4
				c-6.8-1.9-15.2-0.5-24.3,4.8c-22.4,13-40.6,44.3-40.6,70.1c0,13.4,4.9,22.6,12.8,26.6c-9.9-2.8-16.3-12.6-16.3-27.9
				C334.8,350.1,353,318.7,375.4,305.7z"/>
      <path class="st405" d="M348.8,373.2c0,18.7,13.2,26.2,29.5,16.8c16.3-9.4,29.5-32.2,29.5-50.9c0-18.7-13.2-26.2-29.5-16.8
				C362,331.7,348.8,354.5,348.8,373.2z"/>

      <linearGradient id="SVGID_00000026124816310069712540000002752781289114081977_" gradientUnits="userSpaceOnUse"
                      x1="1388.1964" y1="325.5975" x2="1441.0679" y2="389.9006"
                      gradientTransform="matrix(-1 0 0 1 1791.6339 0)">
				<stop offset="0" style="stop-color:#166250"/>
        <stop offset="0.1797" style="stop-color:#196955"/>
        <stop offset="0.4323" style="stop-color:#237B64"/>
        <stop offset="0.7265" style="stop-color:#32997C"/>
        <stop offset="1" style="stop-color:#44BB98"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000026124816310069712540000002752781289114081977_);" d="M354,370.2c0,15.4,10.9,21.6,24.3,13.8
				c13.4-7.7,24.3-26.5,24.3-41.9c0-15.4-10.9-21.6-24.3-13.8C364.9,336,354,354.8,354,370.2z"/>

      <linearGradient id="SVGID_00000082360135831702703130000000863381469707085980_" gradientUnits="userSpaceOnUse"
                      x1="1390.3256" y1="384.861" x2="1360.7061" y2="360.0731"
                      gradientTransform="matrix(-0.866 0.5 0 1.1547 1570.1897 -762.8357)">
				<stop offset="0" style="stop-color:#166250"/>
        <stop offset="0.1797" style="stop-color:#196955"/>
        <stop offset="0.4323" style="stop-color:#237B64"/>
        <stop offset="0.7265" style="stop-color:#32997C"/>
        <stop offset="1" style="stop-color:#44BB98"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000082360135831702703130000000863381469707085980_);" d="M362.1,365.5c0,10.3,7.2,14.4,16.2,9.2
				c8.9-5.2,16.2-17.7,16.2-27.9c0-10.3-7.2-14.4-16.2-9.2C369.4,342.7,362.1,355.2,362.1,365.5z"/>

      <linearGradient id="SVGID_00000110466480042875495060000015336028040109220995_" gradientUnits="userSpaceOnUse"
                      x1="1385.3621" y1="380.7069" x2="1372.3843" y2="369.8461"
                      gradientTransform="matrix(-0.866 0.5 0 1.1547 1570.1897 -762.8357)">
				<stop offset="0" style="stop-color:#5E499D"/>
        <stop offset="5.897868e-02" style="stop-color:#53408A"/>
        <stop offset="0.209" style="stop-color:#3A2D60"/>
        <stop offset="0.3621" style="stop-color:#251D3D"/>
        <stop offset="0.5165" style="stop-color:#151023"/>
        <stop offset="0.6729" style="stop-color:#09070F"/>
        <stop offset="0.8324" style="stop-color:#020204"/>
        <stop offset="1" style="stop-color:#000000"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000110466480042875495060000015336028040109220995_);" d="M372.3,359.6c0,3.8,2.7,5.4,6.1,3.5
				c3.4-1.9,6.1-6.6,6.1-10.5s-2.7-5.4-6.1-3.5C375,351.1,372.3,355.8,372.3,359.6z"/>

      <linearGradient id="SVGID_00000054236363374654094550000011065035896724292012_" gradientUnits="userSpaceOnUse"
                      x1="1547.6997" y1="341.225" x2="1532.1064" y2="298.2637"
                      gradientTransform="matrix(-1 0 0 1 1791.6339 0)">
				<stop offset="0" style="stop-color:#FFFFFF"/>
        <stop offset="1" style="stop-color:#B09EB7"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000054236363374654094550000011065035896724292012_);" points="342,353.4 336.9,373.9
				157.7,290 			"/>

      <linearGradient id="SVGID_00000057844016199114395010000008979481866065934742_" gradientUnits="userSpaceOnUse"
                      x1="1404.3197" y1="345.8226" x2="1436.9172" y2="331.7542"
                      gradientTransform="matrix(-1 0 0 1 1791.6339 0)">
				<stop offset="0" style="stop-color:#FFFFFF"/>
        <stop offset="1" style="stop-color:#B09EB7"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000057844016199114395010000008979481866065934742_);" d="M413.4,311.8L336.9,374l0-0.1
				c1.2-25.1,18.7-54.6,40.3-67.1C393.1,297.7,406.8,300.3,413.4,311.8z"/>

      <linearGradient id="SVGID_00000133490682927235135960000009798422215239691446_" gradientUnits="userSpaceOnUse"
                      x1="144.3366" y1="289.6655" x2="348.8159" y2="289.6655">
				<stop offset="0" style="stop-color:#8F77B5"/>
        <stop offset="0.1485" style="stop-color:#967DB8"/>
        <stop offset="0.3573" style="stop-color:#A88EC2"/>
        <stop offset="0.5808" style="stop-color:#C3A8D0"/>
        <stop offset="0.7574" style="stop-color:#CEB8D9"/>
        <stop offset="1" style="stop-color:#E2D4E8"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000133490682927235135960000009798422215239691446_);" points="348.8,335.7 348.8,358.8
				144.3,285.1 146.9,220.5 			"/>

      <linearGradient id="SVGID_00000180354176891754905700000018371330082943266435_" gradientUnits="userSpaceOnUse"
                      x1="146.9308" y1="255.9238" x2="422.0905" y2="255.9238">
				<stop offset="0" style="stop-color:#8F77B5"/>
        <stop offset="0.1485" style="stop-color:#967DB8"/>
        <stop offset="0.3573" style="stop-color:#A88EC2"/>
        <stop offset="0.5808" style="stop-color:#C3A8D0"/>
        <stop offset="0.7574" style="stop-color:#CEB8D9"/>
        <stop offset="1" style="stop-color:#E2D4E8"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000180354176891754905700000018371330082943266435_);" points="422.1,291.4 348.8,335.7
				146.9,220.5 220.4,176.1 			"/>

      <linearGradient id="SVGID_00000000900825065766005480000014788808391702381988_" gradientUnits="userSpaceOnUse"
                      x1="1395.9141" y1="331.9786" x2="1411.4343" y2="358.9348"
                      gradientTransform="matrix(-1 0 0 1 1791.6339 0)">
				<stop offset="0" style="stop-color:#FFFFFF"/>
        <stop offset="1" style="stop-color:#000000"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000000900825065766005480000014788808391702381988_);" d="M374.9,357c0,6.1,4.3,8.6,9.6,5.5
				c5.3-3.1,9.6-10.5,9.6-16.6s-4.3-8.6-9.6-5.5C379.2,343.5,374.9,350.9,374.9,357z"/>

      <radialGradient id="SVGID_00000076577951766678807700000013613101402038551431_" cx="1438.6709" cy="303.3697"
                      r="72.9463" gradientTransform="matrix(-1 0 0 1 1791.6339 0)" gradientUnits="userSpaceOnUse">
				<stop offset="0" style="stop-color:#FFFFFF"/>
        <stop offset="1" style="stop-color:#000000"/>
			</radialGradient>
      <polygon style="fill:url(#SVGID_00000076577951766678807700000013613101402038551431_);" points="422.1,291.4 348.8,335.7
				348.8,358.8 346.8,335.9 146.9,220.5 347.5,333.9 			"/>
		</g>
	</g>
</g>
            <g>
	<path class="st404" d="M80.1,961.5c0,2.9,0,5.7-0.1,8.5c-0.1,2.6-0.4,5.1-0.7,7.7c-5-0.3-9.8-0.7-14.8-0.7c-3.3-0.1-6.5,0-9.8,0
		c-0.8,11.4-1.6,22.7-2,34.1c-0.7,14-1,28-1.3,42.1l-20.1-0.1c0.9-12.9,2-26,2.6-39.1c0.7-12.3,1-24.7,1.3-37
		c-5.4-0.1-10.7-0.1-15.9,0.1c-2.9,0.1-5.6,0.4-8.5,0.5l0.8-16.3L80.1,961.5z"/>
              <path class="st404" d="M522.6,1005l-14.1-43.8h18.4l6.4,22.3l9.1-22.3h18.4c-1.6,3.1-3.3,6.3-4.8,9.4c-2.9,5.9-5.5,11.9-8.2,17.8
		c-2.4,5.4-4.8,10.7-7.3,16.1l10.7,33.8c1.2-3,2.4-6,3.7-8.9c1.6-3.5,3.3-6.9,4.8-10.5c3.3-6.9,6.4-13.9,9.7-20.8
		c3-6.3,5.9-12.7,8.6-18.9c2.5-6,4.8-12,7.2-18h19.9c-4.1,8.1-8,16.2-11.8,24.4c-3.4,7.3-6.7,14.8-10.1,22.1
		c-4,8.9-8.4,17.6-12.4,26.5c-2.7,6.1-5.4,12.4-8,18.7h-25c-1.2-4.2-2.2-8.2-3.4-12.3c-1.6-4.8-3.1-9.5-4.7-14.2l-3.5,8.6
		c-1.3,2.9-2.7,5.6-3.9,8.5c-1.4,3.1-2.6,6.3-3.9,9.4H494c-1.7-6.5-3.5-12.9-5.5-19.3c-2.4-7.3-5-14.5-7.3-21.8
		c-3.8-11.4-7.3-23-11.2-34.4c-1.8-5.4-3.7-10.7-5.5-16.2l20.5,0.1c1.3,5.5,2.5,11,4.1,16.5c1.8,6.3,3.8,12.5,5.9,18.8
		c0.9,2.7,1.7,5.5,2.6,8.2c3.4,10.7,6.8,21.6,10.2,32.4L522.6,1005z"/>
              <path class="st693" d="M125.8,983.4c5.5,0.4,10.7,0.9,15.1,3.7c2.8,1.7,7.7,6.2,7.7,13.8c0,1-0.1,3.2-1,5.7
		c-0.9,2.7-3.7,8.9-11.7,12.8c-2.9,1.4-6.8,2.6-10.1,3.5l18.8,29.9h-21.3c-2-4.2-4-8.3-6.4-12.3c-2.3-4.1-4.8-8.2-7.2-12.1
		c-3-4.9-5.9-9.7-8.8-14.5c2.9,0.2,5.8,0.4,8.7,0.4c2.3,0,12.2-0.1,17.1-5.6c2.3-2.6,2.5-5.3,2.5-6.5c0-1.1-0.3-4.2-3.3-6.1
		c-1.9-1.2-3.5-1.6-8.6-1.8l-18.9,0.1c-1.1,13.6-2.1,27.2-2.6,40.9c-0.3,5.9-0.4,11.6-0.5,17.4H75.9c0.9-7.5,1.5-14.9,2-22.5
		c0.4-5.8,0.6-11.6,0.9-17.4c0.4-6.2,0.8-12.2,0.9-18.4c0.1-3.7,0.1-7.4,0.1-11H125.8z"/>
              <path class="st693" d="M215,983.1c2.1,5.2,4.4,10.3,6.8,15.5c3.3,6.8,6.7,13.5,10,20.3c5.4,11.3,10.8,22.6,16.3,33.9h-20.9
		c-2.9-8.7-3.9-12.1-11.5-26.5h-33.8c-3.4,5-6.9,9.8-10.2,14.9c-2.4,3.8-4.7,7.7-6.8,11.5h-19.8l46.3-69.7H215z M187.8,1015.5h23.7
		l-10-21.6L187.8,1015.5z"/>
              <path class="st693" d="M272.5,983.1c5.5-0.1,11.1-0.3,16.5-0.3c5.7,0,11.2,0.2,16.8,0.4c8.1,1,13.5,1.9,19.4,6.5
		c3.9,3,6.1,6.5,6.8,7.8c3.9,7,3.8,13.4,3.5,21.1c-0.8,6.9-1.1,8.4-3.7,14.9c-0.4,0.8-0.8,1.6-1.3,2.4c-1.5,2.7-5.2,9-14.2,13.1
		c-3.8,1.7-6.8,2.4-15,3.3c-6.8,0.3-13.5,0.6-20.4,0.6c-3.8,0-7.7-0.1-11.5-0.1c-5.8,0-11.6,0-17.4,0.1c0.6-6,1.4-11.9,1.8-17.9
		c0.3-4.9,0.4-9.7,0.8-14.6c0.4-6.9,0.9-13.8,1.1-20.8c0.3-5.5,0.3-10.9,0.4-16.4H272.5z M271.4,1040.9c5.8,0,11.7,0.1,17.4-0.2
		l6.4-0.3c0.4-0.1,4-0.5,6.3-1.2c2.1-0.6,6.8-2.2,10.2-6.4c3.9-4.8,6.1-12.3,6.1-17.9c0-3-0.4-14.8-14-18.7c-3.2-0.9-5.8-1-9.1-1.2
		H274L271.4,1040.9z"/>
              <path class="st693" d="M410.9,983.1l-0.5,12.4c-7.8-0.4-15.6-0.7-23.6-0.7c-7.7,0-15.4,0.2-23.1,0.4l-0.8,15.8l40.7-0.3l-0.8,12.6
		c-7.2-0.2-14.5-0.5-21.7-0.5c-6.4,0-12.7,0.1-19,0.3l-1,17.7c8.8,0.1,17.8,0.3,26.6,0.1c6.8-0.2,13.5-0.5,20.3-0.9v12.6h-66.8
		c0.5-3.9,1-7.7,1.4-11.5c0.5-5.8,0.8-11.5,1-17.2c0.5-7.9,1-15.8,1.3-23.7c0.3-5.8,0.3-11.4,0.4-17.2H410.9z"/>
              <path class="st693" d="M649.8,983.1c2.1,5.2,4.4,10.3,6.8,15.5c3.3,6.8,6.7,13.5,10,20.3c5.4,11.3,10.8,22.6,16.3,33.9h-20.9
		c-2.9-8.7-3.9-12.1-11.5-26.5h-33.8c-3.4,5-6.9,9.8-10.2,14.9c-2.4,3.8-4.7,7.7-6.8,11.5h-19.8l46.3-69.7H649.8z M622.6,1015.5
		h23.7l-10-21.6L622.6,1015.5z"/>
              <path class="st693" d="M749.7,983.3c0,2.2,0,4.4-0.1,6.5c-0.1,2-0.4,3.9-0.6,5.9c-4.8-0.2-9.5-0.5-14.2-0.5c-3.2-0.1-6.3,0-9.5,0
		c-0.8,8.7-1.5,17.3-1.9,26c-0.6,10.6-1,21.3-1.3,32l-19.4-0.1c0.9-9.8,1.9-19.8,2.5-29.7c0.6-9.3,1-18.8,1.3-28.1
		c-5.2-0.1-10.3-0.1-15.4,0.1c-2.8,0.1-5.4,0.3-8.2,0.4l0.8-12.4L749.7,983.3z"/>
              <path class="st693" d="M821.5,996.2c-9.3-1.7-12-2.2-21.4-2.6c-11,0.3-20,1-26.9,8.2c-2.8,2.9-7.3,9-7.3,18.2
		c0,9.5,5.7,17.2,17.3,20.5c2.9,0.8,5.7,1.2,11.8,1.7c11,0,13.7-0.4,24-2.7l-3.2,13.5c-5.4,0.6-7.9,1-17.6,1.3
		c-1.9,0-3.9,0.1-5.9,0.1c-2.5,0-5.4-0.1-10.6-0.6c-6.7-1.2-12.1-2.2-17.8-5.3c-10-5.4-13.4-12.9-14.5-16c-1.4-4-1.8-8.4-1.9-9.5
		c0-8.6,0.6-10,1.9-14.6c1.6-4.2,2.8-6.5,3.9-8.3c4.5-7.2,12.7-13.2,22.3-16c4.4-1.2,8.1-1.6,12.7-2.1c10.5-0.4,14.5-0.7,32.3,1.2
		L821.5,996.2z"/>
              <path class="st693" d="M849.4,983.1l-2.3,27.9h47.5c0.5-5.5,0.9-10.9,1.1-16.4c0.1-3.9,0.3-7.7,0.4-11.5l19.7,0.1
		c-1.1,12.5-2.3,25.2-3,37.8c-0.6,10.5-0.9,21.2-1.1,31.8h-19.5c0.6-7.3,1.4-14.4,1.6-21.7c0.1-2.7,0.1-5.5,0.3-8.3l-47.4,0.1
		c-0.4,7-0.9,13.9-1,21c-0.1,2.9-0.1,5.9-0.3,8.9h-19.8c1.3-13.2,2.4-26.5,3-39.7c0.5-10,0.8-20.1,0.9-30H849.4z"/>
              <path class="st693" d="M992.8,983.1l-0.5,12.4c-7.8-0.4-15.6-0.7-23.6-0.7c-7.7,0-15.4,0.2-23.1,0.4l-0.8,15.8l40.7-0.3l-0.8,12.6
		c-7.2-0.2-14.5-0.5-21.7-0.5c-6.4,0-12.7,0.1-19,0.3l-1,17.7c8.8,0.1,17.8,0.3,26.6,0.1c6.8-0.2,13.5-0.5,20.3-0.9v12.6h-66.8
		c0.5-3.9,1-7.7,1.4-11.5c0.5-5.8,0.8-11.5,1-17.2c0.5-7.9,1-15.8,1.3-23.7c0.3-5.8,0.3-11.4,0.4-17.2H992.8z"/>
              <path class="st693" d="M1046.4,983.4c5.5,0.4,10.7,0.9,15.1,3.7c2.8,1.7,7.7,6.2,7.7,13.8c0,1-0.1,3.2-1,5.7
		c-0.9,2.7-3.7,8.9-11.7,12.8c-2.9,1.4-6.8,2.6-10.1,3.5l18.8,29.9h-21.3c-2-4.2-4-8.3-6.4-12.3c-2.3-4.1-4.8-8.2-7.2-12.1
		c-3-4.9-5.9-9.7-8.8-14.5c2.9,0.2,5.8,0.4,8.7,0.4c2.3,0,12.2-0.1,17.1-5.6c2.3-2.6,2.5-5.3,2.5-6.5c0-1.1-0.3-4.2-3.3-6.1
		c-1.9-1.2-3.5-1.6-8.6-1.8l-18.9,0.1c-1.1,13.6-2.1,27.2-2.6,40.9c-0.3,5.9-0.4,11.6-0.5,17.4h-19.4c0.9-7.5,1.5-14.9,2-22.5
		c0.4-5.8,0.6-11.6,0.9-17.4c0.4-6.2,0.8-12.2,0.9-18.4c0.1-3.7,0.1-7.4,0.1-11H1046.4z"/>
</g>
</svg>
        </div>
      </template>
      <span>Trade Watcher</span>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * @component TradeWatcherButton
 * Home button component that redirects to Trade Watcher page
 */
export default {
  name: 'TradeWatcherButton',
  props: {
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    goToTradeWatcherPage() {
      this.$router.push('/trade-watcher');
    }
  }
}

</script>

<style lang="scss" scoped>
.main-light {
  .home-button {
    background-color: rgba(0, 0, 0, 0.15);
    border: 4px solid #5c9485;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.7);

    &:hover {
      background-color: rgb(255, 255, 255);
      border: 4px solid #4ABD96 !important;
      box-shadow: 5px 5px 14px rgba(0, 0, 0, 0.7);
      cursor: pointer;
      z-index: 99999;
      transform: scale(1.1);
    }
  }
}
</style>

<style scoped>
.st0 {
  clip-path: url(#SVGID_00000164496503272829764220000017511989833884894647_);
}

.st1 {
  clip-path: url(#SVGID_00000129885271253751982060000014381860640660975506_);
  enable-background: new;
}

.st2 {
  clip-path: url(#SVGID_00000176015829572275777080000014701367455724438171_);
}

.st3 {
  clip-path: url(#SVGID_00000027582023710429162120000008185116936573191067_);
}

.st4 {
  opacity: 0;
  clip-path: url(#SVGID_00000085221312017898587250000003374592357406834346_);
}

.st5 {
  opacity: 0;
}

.st6 {
  clip-path: url(#SVGID_00000079464470808069783860000003402143186708254369_);
}

.st7 {
  clip-path: url(#SVGID_00000025407380077500043360000009619873771775377083_);
}

.st8 {
  clip-path: url(#SVGID_00000066498048293699803770000009442523569229203612_);
  fill: #3FB994;
}

.st9 {
  clip-path: url(#SVGID_00000015318346394280767170000001519529517811878028_);
}

.st10 {
  clip-path: url(#SVGID_00000132807614022813272250000012183031546669939855_);
  enable-background: new;
}

.st11 {
  clip-path: url(#SVGID_00000056424988673364496350000012846287759179840697_);
}

.st12 {
  clip-path: url(#SVGID_00000181775392251795281590000000723587431501733248_);
}

.st13 {
  clip-path: url(#SVGID_00000163043035403760215900000003441114507635016879_);
  fill: #3FB994;
}

.st14 {
  clip-path: url(#SVGID_00000105422691243059325490000014819188851977172141_);
}

.st15 {
  clip-path: url(#SVGID_00000148636501637998428380000001052150636687931778_);
}

.st16 {
  clip-path: url(#SVGID_00000062164711838075877460000005006637305471964053_);
  fill: #3FB994;
}

.st17 {
  clip-path: url(#SVGID_00000103263565524498529020000003579710166352018351_);
}

.st18 {
  clip-path: url(#SVGID_00000108990767427733884650000012157750827885324716_);
}

.st19 {
  clip-path: url(#SVGID_00000044858352306957206160000003856978209181561786_);
  fill: #3FB994;
}

.st20 {
  clip-path: url(#SVGID_00000144301576081187106530000000778581247288859790_);
}

.st21 {
  clip-path: url(#SVGID_00000143612753324203188680000014699402668371714224_);
}

.st22 {
  clip-path: url(#SVGID_00000130632421601444414670000012292364278258401977_);
  fill: #3FB994;
}

.st23 {
  clip-path: url(#SVGID_00000101069845986144128720000004146785454131229856_);
}

.st24 {
  clip-path: url(#SVGID_00000059999447311723936550000006224433301864959155_);
}

.st25 {
  clip-path: url(#SVGID_00000087400289052166299810000017429865387017227137_);
  fill: #3FB994;
}

.st26 {
  clip-path: url(#SVGID_00000135687619872200119350000007590702098941439362_);
}

.st27 {
  clip-path: url(#SVGID_00000055704274660929128830000007915288661965629082_);
}

.st28 {
  clip-path: url(#SVGID_00000055696495536398266990000009387057373194974378_);
  fill: #3FB994;
}

.st29 {
  clip-path: url(#SVGID_00000151529502619827558320000016638194010013594000_);
}

.st30 {
  clip-path: url(#SVGID_00000057870909561229832690000016857398485307898282_);
}

.st31 {
  clip-path: url(#SVGID_00000074402108756671637400000014231629876309447089_);
  fill: #3FB994;
}

.st32 {
  clip-path: url(#SVGID_00000093895627836537565110000005710067777676044462_);
}

.st33 {
  clip-path: url(#SVGID_00000060743726212652589840000003506948246341786293_);
}

.st34 {
  clip-path: url(#SVGID_00000015319302100107693460000014539206792656219792_);
  fill: #3FB994;
}

.st35 {
  clip-path: url(#SVGID_00000099621564519987898620000008076861175772764347_);
}

.st36 {
  clip-path: url(#SVGID_00000153677762334542307770000006730505080598934959_);
}

.st37 {
  clip-path: url(#SVGID_00000047038602851946063660000010697474320502162620_);
  fill: #3FB994;
}

.st38 {
  clip-path: url(#SVGID_00000072977428985764291880000013110904346993260417_);
}

.st39 {
  clip-path: url(#SVGID_00000070090524674458178850000003886361370490701725_);
}

.st40 {
  clip-path: url(#SVGID_00000115511125767990381410000011811572650549990028_);
  fill: #3FB994;
}

.st41 {
  clip-path: url(#SVGID_00000101062841482109380070000007035483981197676424_);
}

.st42 {
  clip-path: url(#SVGID_00000142146916619934489700000015747334995787538613_);
}

.st43 {
  clip-path: url(#SVGID_00000098207285639820670830000015567095843560305069_);
  fill: #3FB994;
}

.st44 {
  clip-path: url(#SVGID_00000005955036083299043850000011109253417149488007_);
}

.st45 {
  clip-path: url(#SVGID_00000160892181950423481180000005023510693585620903_);
}

.st46 {
  clip-path: url(#SVGID_00000042002397284044680200000013255336301181464736_);
  fill: #3FB994;
}

.st47 {
  clip-path: url(#SVGID_00000059299027277804811760000004052573954915635590_);
}

.st48 {
  clip-path: url(#SVGID_00000113324638809375659900000010343912998867063431_);
}

.st49 {
  clip-path: url(#SVGID_00000050639265590213127510000005112755355092330936_);
  fill: #3FB994;
}

.st50 {
  clip-path: url(#SVGID_00000164504398738041359150000002722068514885926335_);
}

.st51 {
  clip-path: url(#SVGID_00000144304114151031958120000005246395638568508577_);
  enable-background: new;
}

.st52 {
  clip-path: url(#SVGID_00000109727546706932339660000007578507747073145745_);
}

.st53 {
  clip-path: url(#SVGID_00000119821939648388191740000001074107717847731114_);
}

.st54 {
  clip-path: url(#SVGID_00000181067208489483563800000011811808993777128377_);
  fill: #306175;
}

.st55 {
  clip-path: url(#SVGID_00000008827436252358836960000013226359493136824500_);
}

.st56 {
  clip-path: url(#SVGID_00000093176168177072668970000014775384795247170235_);
}

.st57 {
  clip-path: url(#SVGID_00000093893258754768758810000004169663671899684273_);
  fill: #32657A;
}

.st58 {
  clip-path: url(#SVGID_00000020387036932869923560000017493001896026037125_);
}

.st59 {
  clip-path: url(#SVGID_00000172406323636646025430000002297665520787405734_);
}

.st60 {
  clip-path: url(#SVGID_00000132808457800207660330000005594678842499340683_);
  fill: #34697F;
}

.st61 {
  clip-path: url(#SVGID_00000145769889765265046980000000184428342692368299_);
}

.st62 {
  clip-path: url(#SVGID_00000059990595433287244510000008375378520676601509_);
}

.st63 {
  clip-path: url(#SVGID_00000099627455641614749100000016054117825084047533_);
  fill: #366C82;
}

.st64 {
  clip-path: url(#SVGID_00000037675259248746983890000005339602626589990845_);
}

.st65 {
  clip-path: url(#SVGID_00000003809405604662551280000002464331262157621649_);
  enable-background: new;
}

.st66 {
  clip-path: url(#SVGID_00000102542446609064633670000010780201441389177233_);
}

.st67 {
  clip-path: url(#SVGID_00000079456850551315175710000007150366998103365309_);
}

.st68 {
  opacity: 0;
  clip-path: url(#SVGID_00000106844408507944901800000013697398978771768753_);
}

.st69 {
  clip-path: url(#SVGID_00000137100190893603165560000014296710913434347947_);
}

.st70 {
  clip-path: url(#SVGID_00000147196971831923868700000015690001512513350072_);
}

.st71 {
  clip-path: url(#SVGID_00000026884144860162223180000000118145449387604927_);
  fill: #3FB994;
}

.st72 {
  clip-path: url(#SVGID_00000183928034554417766950000018287261718152851363_);
}

.st73 {
  clip-path: url(#SVGID_00000070108893377642649690000015131350289899663274_);
  enable-background: new;
}

.st74 {
  clip-path: url(#SVGID_00000161603988852285546080000006599794969136824214_);
}

.st75 {
  clip-path: url(#SVGID_00000082360122717795478500000009996900265516337306_);
}

.st76 {
  clip-path: url(#SVGID_00000155861247896939420790000004981826706799259033_);
  fill: #3FB994;
}

.st77 {
  clip-path: url(#SVGID_00000081649237996272271040000005482710214855868316_);
}

.st78 {
  clip-path: url(#SVGID_00000099656211530290637480000016682112989425111477_);
}

.st79 {
  clip-path: url(#SVGID_00000000197387268013072900000004328596363183671725_);
  fill: #3FB994;
}

.st80 {
  clip-path: url(#SVGID_00000128442739096747804160000015178330527828440228_);
}

.st81 {
  clip-path: url(#SVGID_00000084499409687499625430000000982082211938004620_);
}

.st82 {
  clip-path: url(#SVGID_00000023280640399377114170000006326356794450677922_);
  fill: #3FB994;
}

.st83 {
  clip-path: url(#SVGID_00000095302657039911629350000004664158682274508476_);
}

.st84 {
  clip-path: url(#SVGID_00000023277300125860243870000009202727009697321639_);
}

.st85 {
  clip-path: url(#SVGID_00000021831384601409546220000015917182162358728882_);
  fill: #3FB994;
}

.st86 {
  clip-path: url(#SVGID_00000098934602775452748390000014192876038772325786_);
}

.st87 {
  clip-path: url(#SVGID_00000103261866702994952630000017756568125827320464_);
}

.st88 {
  clip-path: url(#SVGID_00000104674361755460003490000010610857194861631372_);
  fill: #3FB994;
}

.st89 {
  clip-path: url(#SVGID_00000178903729470875949480000007936819064429406353_);
}

.st90 {
  clip-path: url(#SVGID_00000075880819003238600230000001517119403493397426_);
}

.st91 {
  clip-path: url(#SVGID_00000124145375463794457450000015342645365771582598_);
  fill: #3FB994;
}

.st92 {
  clip-path: url(#SVGID_00000143616145812058395810000011115782922613545634_);
}

.st93 {
  clip-path: url(#SVGID_00000011715221417634283160000011471666470798886333_);
}

.st94 {
  clip-path: url(#SVGID_00000094619807841488584480000010509814610948052398_);
  fill: #3FB994;
}

.st95 {
  clip-path: url(#SVGID_00000010997965917673384240000008621877418788835247_);
}

.st96 {
  clip-path: url(#SVGID_00000139997399672498731130000007470922957647983535_);
}

.st97 {
  clip-path: url(#SVGID_00000148651286938246592730000001541821685326837684_);
  fill: #3FB994;
}

.st98 {
  clip-path: url(#SVGID_00000179603777328849034080000000175925147146737284_);
}

.st99 {
  clip-path: url(#SVGID_00000097475254276805619890000012870275807650192287_);
}

.st100 {
  clip-path: url(#SVGID_00000142873271071993988100000016556589801860229519_);
  fill: #3FB994;
}

.st101 {
  clip-path: url(#SVGID_00000055689061920968816310000010958133169965701530_);
}

.st102 {
  clip-path: url(#SVGID_00000158749458922876147550000000533769083151226296_);
}

.st103 {
  clip-path: url(#SVGID_00000155826688940476537240000016662830331306589076_);
  fill: #3FB994;
}

.st104 {
  clip-path: url(#SVGID_00000044175293997895822440000010249708753266553490_);
}

.st105 {
  clip-path: url(#SVGID_00000093878905335714101780000005563317679199944633_);
}

.st106 {
  clip-path: url(#SVGID_00000059282620187702748630000001688070003014131371_);
  fill: #3FB994;
}

.st107 {
  clip-path: url(#SVGID_00000142147591864029083480000017327424703631485868_);
}

.st108 {
  clip-path: url(#SVGID_00000044897890994858338860000015640367440022526605_);
}

.st109 {
  clip-path: url(#SVGID_00000096749744957744253760000008295611661661737394_);
  fill: #3FB994;
}

.st110 {
  clip-path: url(#SVGID_00000087395553726588719430000006407299891339166850_);
}

.st111 {
  clip-path: url(#SVGID_00000022558062927561915920000011401995888625853357_);
}

.st112 {
  clip-path: url(#SVGID_00000140726407466460144620000015046532398162902946_);
  fill: #3FB994;
}

.st113 {
  clip-path: url(#SVGID_00000118357612328408011530000015173258046491692454_);
}

.st114 {
  clip-path: url(#SVGID_00000100362167409154284630000015795157393537148049_);
}

.st115 {
  clip-path: url(#SVGID_00000070826236873808964270000004068748569442049708_);
  fill: #3FB994;
}

.st116 {
  clip-path: url(#SVGID_00000137814941783372509620000002479160563573390720_);
}

.st117 {
  clip-path: url(#SVGID_00000028290494794079986880000017897109448721155975_);
}

.st118 {
  clip-path: url(#SVGID_00000070106052519389693120000000107430610288408761_);
  fill: #3FB994;
}

.st119 {
  clip-path: url(#SVGID_00000145023730118756891760000014574551738571476121_);
}

.st120 {
  clip-path: url(#SVGID_00000044149173405998266530000010532016513304799628_);
}

.st121 {
  clip-path: url(#SVGID_00000137097279015897779150000004213063475531748020_);
  fill: #3FB994;
}

.st122 {
  clip-path: url(#SVGID_00000001656395287290081410000015285102229217580178_);
}

.st123 {
  clip-path: url(#SVGID_00000135658301895351508510000007275443925487102626_);
}

.st124 {
  clip-path: url(#SVGID_00000130606587259217724080000004585247636331557046_);
  fill: #3FB994;
}

.st125 {
  clip-path: url(#SVGID_00000113352051525413750300000005749292132359101334_);
}

.st126 {
  clip-path: url(#SVGID_00000141446962882788445630000006463388376087032458_);
}

.st127 {
  clip-path: url(#SVGID_00000134947143784812443670000012844396296750074504_);
  fill: #3FB994;
}

.st128 {
  clip-path: url(#SVGID_00000132779773732968115950000012688647222046568357_);
}

.st129 {
  clip-path: url(#SVGID_00000108289454717779393390000003631122805284734122_);
  fill: #154C3D;
}

.st130 {
  clip-path: url(#SVGID_00000078746768821963283690000004267770625372712351_);
}

.st131 {
  clip-path: url(#SVGID_00000034088180720017968760000015537394578091629959_);
  fill: #226A57;
}

.st132 {
  clip-path: url(#SVGID_00000173878165741773770450000011876689279620625316_);
}

.st133 {
  clip-path: url(#SVGID_00000037687439888050305010000011927132495287281591_);
  fill: #226A57;
}

.st134 {
  clip-path: url(#SVGID_00000154400635918176586230000008778718600564068024_);
}

.st135 {
  clip-path: url(#SVGID_00000156575892826298061240000009125699723497466797_);
  fill: #3FB994;
}

.st136 {
  clip-path: url(#SVGID_00000162325535646146962010000003908395287471165879_);
}

.st137 {
  clip-path: url(#SVGID_00000147914448094334591690000010333024856547709097_);
  fill: #3FB994;
}

.st138 {
  clip-path: url(#SVGID_00000165223293114783501340000007205899571231431358_);
}

.st139 {
  clip-path: url(#SVGID_00000132768918358015344960000013304390656415362200_);
  fill: #25292A;
}

.st140 {
  clip-path: url(#SVGID_00000016762672994922763230000014288947483912617115_);
}

.st141 {
  clip-path: url(#SVGID_00000094581793401908890450000007016852118568984468_);
  fill: #3FB994;
}

.st142 {
  clip-path: url(#SVGID_00000070797525851699071290000012696543347022478471_);
}

.st143 {
  clip-path: url(#SVGID_00000116936640106093558120000005308985491634079893_);
  fill: #42B994;
}

.st144 {
  clip-path: url(#SVGID_00000024691447020038839050000006665846509480141968_);
}

.st145 {
  clip-path: url(#SVGID_00000037661090961746021050000000365892584169842318_);
  fill: #25292A;
}

.st146 {
  clip-path: url(#SVGID_00000119104648378092341230000013812965268364651149_);
}

.st147 {
  clip-path: url(#SVGID_00000021831315848166523520000014491826025500757164_);
  fill: #42B994;
}

.st148 {
  clip-path: url(#SVGID_00000179606975633986771930000006838354867777872808_);
}

.st149 {
  clip-path: url(#SVGID_00000036950253221350442460000006336159879578476453_);
  fill: #25292A;
}

.st150 {
  clip-path: url(#SVGID_00000117635995614302165020000002814955927513063602_);
}

.st151 {
  clip-path: url(#SVGID_00000132053130516897316170000011999833642871139491_);
  fill: #42B994;
}

.st152 {
  clip-path: url(#SVGID_00000102546124749349901770000006353546437721613964_);
}

.st153 {
  clip-path: url(#SVGID_00000031927900001893166440000001270284172618117530_);
  fill: #25292A;
}

.st154 {
  clip-path: url(#SVGID_00000021121115691094925250000013402159378217893538_);
}

.st155 {
  clip-path: url(#SVGID_00000049935634090876738130000005892261509109065918_);
  enable-background: new;
}

.st156 {
  clip-path: url(#SVGID_00000030463802021007372360000018046312998217540248_);
}

.st157 {
  clip-path: url(#SVGID_00000100363758521876375290000011566228750047148472_);
}

.st158 {
  clip-path: url(#SVGID_00000052092311636438719310000000955562629715144329_);
  fill: #25292A;
}

.st159 {
  clip-path: url(#SVGID_00000062901919740497998400000010294226886565708673_);
}

.st160 {
  clip-path: url(#SVGID_00000043422153612662874330000012462073056131863439_);
}

.st161 {
  clip-path: url(#SVGID_00000145032764500376480350000013411645323893887672_);
  fill: #25292A;
}

.st162 {
  clip-path: url(#SVGID_00000183227118706092341910000013398236772811096965_);
}

.st163 {
  clip-path: url(#SVGID_00000124137930217983626040000006099211242952411543_);
  enable-background: new;
}

.st164 {
  clip-path: url(#SVGID_00000095309566893541998230000010013051040688536495_);
}

.st165 {
  clip-path: url(#SVGID_00000063632208370065744900000016996712500486205583_);
}

.st166 {
  clip-path: url(#SVGID_00000158002517938093008700000009423403287393147581_);
  fill: #3FB994;
}

.st167 {
  clip-path: url(#SVGID_00000096018214367644819990000003988229071617062022_);
}

.st168 {
  clip-path: url(#SVGID_00000023264952584900145540000003364026704908645278_);
}

.st169 {
  clip-path: url(#SVGID_00000087387885331127543780000003964594437714239933_);
  fill: #001820;
}

.st170 {
  clip-path: url(#SVGID_00000077283168439192954750000010337518745629242525_);
}

.st171 {
  clip-path: url(#SVGID_00000054258208787561763150000010896146206554343584_);
  fill: #25292A;
}

.st172 {
  clip-path: url(#SVGID_00000133491961942505836320000006626672033630281378_);
}

.st173 {
  clip-path: url(#SVGID_00000129910982842207740080000013408585597325027227_);
  fill: #25292A;
}

.st174 {
  clip-path: url(#SVGID_00000044156330785312674290000013433924094444002741_);
}

.st175 {
  clip-path: url(#SVGID_00000081610092311699667110000003539391311073471153_);
  fill: #A4A6A5;
}

.st176 {
  clip-path: url(#SVGID_00000079454508430587354000000005049503645266126269_);
}

.st177 {
  clip-path: url(#SVGID_00000134249861524772981610000014370293211374899611_);
  fill: #9CB3C6;
}

.st178 {
  clip-path: url(#SVGID_00000072282379653972934330000013834543793510769035_);
}

.st179 {
  clip-path: url(#SVGID_00000009580717514154597760000007279621091105190320_);
  fill: #9CB3C6;
}

.st180 {
  clip-path: url(#SVGID_00000080885870077056539560000001395347769319204027_);
}

.st181 {
  clip-path: url(#SVGID_00000114044341649843086140000005955504428691277697_);
  fill: #25292A;
}

.st182 {
  clip-path: url(#SVGID_00000173849976625762086410000014048545156894908554_);
}

.st183 {
  clip-path: url(#SVGID_00000027595208827642558700000011535552441068745888_);
  fill: #E0E1DB;
}

.st184 {
  clip-path: url(#SVGID_00000163042978916739800770000013636598345393657239_);
}

.st185 {
  clip-path: url(#SVGID_00000078025056709696865240000002527958079740347535_);
  fill: #25292A;
}

.st186 {
  clip-path: url(#SVGID_00000021803894220505037410000008329090869089233830_);
}

.st187 {
  clip-path: url(#SVGID_00000093162291198674966220000002969901862489574323_);
  fill: #25292A;
}

.st188 {
  clip-path: url(#SVGID_00000000207840014172413830000003825683944453272493_);
}

.st189 {
  clip-path: url(#SVGID_00000047764736225410646550000012482761628355861910_);
  fill: #25292A;
}

.st190 {
  clip-path: url(#SVGID_00000003790161709896394600000010690090131033070994_);
}

.st191 {
  clip-path: url(#SVGID_00000085951952004504831270000017905046855846505898_);
  fill: #A4A6A5;
}

.st192 {
  clip-path: url(#SVGID_00000070087109997641843000000009293650690745569171_);
}

.st193 {
  clip-path: url(#SVGID_00000095325290773729504670000000445347025443191485_);
  enable-background: new;
}

.st194 {
  clip-path: url(#SVGID_00000060017916193220514210000009323442367749239684_);
}

.st195 {
  clip-path: url(#SVGID_00000000934069409987619050000013727515408789533374_);
}

.st196 {
  opacity: 0;
  clip-path: url(#SVGID_00000173157128490395015950000008976630924734238882_);
}

.st197 {
  clip-path: url(#SVGID_00000092429157666931420720000005494242962661570693_);
}

.st198 {
  clip-path: url(#SVGID_00000176759802458386863900000004221276817181547705_);
}

.st199 {
  clip-path: url(#SVGID_00000011713299362582212220000000655525344346233525_);
  enable-background: new;
}

.st200 {
  clip-path: url(#SVGID_00000135672831742473563840000012609658265582983600_);
}

.st201 {
  clip-path: url(#SVGID_00000010304569780306505440000002207749482785225129_);
}

.st202 {
  opacity: 0;
  clip-path: url(#SVGID_00000176732828611551350900000013220548895561867692_);
}

.st203 {
  clip-path: url(#SVGID_00000040543566431888243330000016187382726435827092_);
}

.st204 {
  clip-path: url(#SVGID_00000127730141721642419150000003219698930455554462_);
}

.st205 {
  clip-path: url(#SVGID_00000021835429624370216710000017109560860818439813_);
  enable-background: new;
}

.st206 {
  clip-path: url(#SVGID_00000053534446945590833830000005632303672926461602_);
}

.st207 {
  clip-path: url(#SVGID_00000157986556911685324550000012894987096825592484_);
}

.st208 {
  opacity: 0;
  clip-path: url(#SVGID_00000152966401624538412530000007618418062198808973_);
}

.st209 {
  clip-path: url(#SVGID_00000143600265183186813470000006203527471880789133_);
}

.st210 {
  clip-path: url(#SVGID_00000019637422248796928690000010664307677608088994_);
}

.st211 {
  clip-path: url(#SVGID_00000009566579298744329050000009040176619560207530_);
  fill: #4EBD99;
}

.st212 {
  clip-path: url(#SVGID_00000066495245785314066170000008630785364007764121_);
}

.st213 {
  clip-path: url(#SVGID_00000007402024552126623160000013044967126335950004_);
  fill: #42B994;
}

.st214 {
  clip-path: url(#SVGID_00000046317478244975900900000002178624278650285964_);
}

.st215 {
  clip-path: url(#SVGID_00000036214558367316088280000004771589725251757477_);
  fill: #226A57;
}

.st216 {
  clip-path: url(#SVGID_00000053537712523928063950000000685832847391640499_);
}

.st217 {
  clip-path: url(#SVGID_00000116954624753455186340000002602723670728402578_);
  fill: #165748;
}

.st218 {
  clip-path: url(#SVGID_00000131368099811542828820000018140970900897751693_);
}

.st219 {
  clip-path: url(#SVGID_00000119104926488399612500000009620787629736724098_);
  fill: #42B994;
}

.st220 {
  clip-path: url(#SVGID_00000032630585717599852600000002159722432555656878_);
}

.st221 {
  clip-path: url(#SVGID_00000134231227114498699950000015632849040780482452_);
  fill: #226A57;
}

.st222 {
  clip-path: url(#SVGID_00000138554168176577554940000006839032084104857769_);
}

.st223 {
  clip-path: url(#SVGID_00000103968289858897053290000011018230601959762831_);
  fill: #165748;
}

.st224 {
  clip-path: url(#SVGID_00000040541088069872293200000013712462579188220822_);
}

.st225 {
  clip-path: url(#SVGID_00000167383505713644803140000015435759043520564922_);
  fill: #42B994;
}

.st226 {
  clip-path: url(#SVGID_00000100342847614836633480000015828557382201429412_);
}

.st227 {
  clip-path: url(#SVGID_00000124878984451991005770000015836070329583782301_);
  fill: #226A57;
}

.st228 {
  clip-path: url(#SVGID_00000183927327778934697540000014549186644854809483_);
}

.st229 {
  clip-path: url(#SVGID_00000143602598408770295850000018121285961742246785_);
  fill: #165748;
}

.st230 {
  clip-path: url(#SVGID_00000124141601740682968150000016416799758497039760_);
}

.st231 {
  clip-path: url(#SVGID_00000183219295509136248240000008949652695716868255_);
  fill: #42B994;
}

.st232 {
  clip-path: url(#SVGID_00000168815952386025458720000003650054048070264993_);
}

.st233 {
  clip-path: url(#SVGID_00000145754309034505078070000017889534235452897713_);
  fill: #226A57;
}

.st234 {
  clip-path: url(#SVGID_00000070085005577898211850000010662474561144732038_);
}

.st235 {
  clip-path: url(#SVGID_00000104665774065786393160000001791205929721762226_);
  fill: #165748;
}

.st236 {
  clip-path: url(#SVGID_00000083083549447321820990000001198475919209659051_);
}

.st237 {
  clip-path: url(#SVGID_00000115476748811314852830000016787693124280938673_);
  fill: #42B994;
}

.st238 {
  clip-path: url(#SVGID_00000150085630909997049700000015555756538162774665_);
}

.st239 {
  clip-path: url(#SVGID_00000088107978258952209600000011495795428768914065_);
  fill: #226A57;
}

.st240 {
  clip-path: url(#SVGID_00000042723625339384637010000002023686101587500475_);
}

.st241 {
  clip-path: url(#SVGID_00000073707045472470987130000012132502172767084204_);
  fill: #165748;
}

.st242 {
  clip-path: url(#SVGID_00000021822098646546186040000017103938587010165638_);
}

.st243 {
  clip-path: url(#SVGID_00000035518882542287406630000006863638744413214362_);
  fill: #226A57;
}

.st244 {
  clip-path: url(#SVGID_00000018958999970308374980000004782397916522779797_);
}

.st245 {
  clip-path: url(#SVGID_00000099624862772639775420000000810785030715608496_);
  fill: #FFFFFF;
}

.st246 {
  clip-path: url(#SVGID_00000039820878941480558470000015804503534191311288_);
}

.st247 {
  clip-path: url(#SVGID_00000022540777643886748770000002257196445677006510_);
  fill: #226A57;
}

.st248 {
  clip-path: url(#SVGID_00000038394081129270383490000004953085986658566575_);
}

.st249 {
  clip-path: url(#SVGID_00000156588947436060367020000001097919125001267851_);
  fill: #42B994;
}

.st250 {
  clip-path: url(#SVGID_00000164489675764602416060000016281370097488437122_);
}

.st251 {
  clip-path: url(#SVGID_00000029739454565157292580000015236657073615365816_);
  fill: #226A57;
}

.st252 {
  clip-path: url(#SVGID_00000072254447992499453550000009430231502718496180_);
}

.st253 {
  clip-path: url(#SVGID_00000075121822974540643340000009831239639861288372_);
  fill: #42B994;
}

.st254 {
  clip-path: url(#SVGID_00000047748338041189594260000008003559614916360837_);
}

.st255 {
  clip-path: url(#SVGID_00000096044062250036723730000014656873177858545581_);
  fill: #226A57;
}

.st256 {
  clip-path: url(#SVGID_00000025430577261306334790000000468816031340994951_);
}

.st257 {
  clip-path: url(#SVGID_00000142178554858097383040000003258644332369309840_);
  fill: #42B994;
}

.st258 {
  clip-path: url(#SVGID_00000054248804845351476860000017657309197092659369_);
}

.st259 {
  clip-path: url(#SVGID_00000109020226371707103740000015471704851441873812_);
  fill: #EBEAE6;
}

.st260 {
  clip-path: url(#SVGID_00000062173604464737668780000016103863484945142166_);
}

.st261 {
  clip-path: url(#SVGID_00000088846333297447594750000001256341094900072628_);
  fill: #DCDDD7;
}

.st262 {
  clip-path: url(#SVGID_00000141416645347933695570000014693131204895220651_);
}

.st263 {
  clip-path: url(#SVGID_00000101816055881282613730000014033231328843042946_);
  fill: #868B89;
}

.st264 {
  clip-path: url(#SVGID_00000001627453428111331590000017138132040346738325_);
}

.st265 {
  clip-path: url(#SVGID_00000160906247188491275830000001162579811326743444_);
  fill: #95CCB9;
}

.st266 {
  clip-path: url(#SVGID_00000163769074008436417720000003963148309699115685_);
}

.st267 {
  clip-path: url(#SVGID_00000034047949444371698470000004812168671418877060_);
  fill: #82A79C;
}

.st268 {
  clip-path: url(#SVGID_00000108303365810290546790000007587763214802518400_);
}

.st269 {
  clip-path: url(#SVGID_00000111876325620761950870000014986067313135871630_);
  fill: #7FA096;
}

.st270 {
  clip-path: url(#SVGID_00000116934307215795577360000012443297527993393329_);
}

.st271 {
  clip-path: url(#SVGID_00000047046754744426094620000001709615903166451889_);
  fill: #95CCB9;
}

.st272 {
  clip-path: url(#SVGID_00000180345228108231600700000014712378539824148906_);
}

.st273 {
  clip-path: url(#SVGID_00000029032173213999583820000003797534343887159940_);
  fill: #82A79C;
}

.st274 {
  clip-path: url(#SVGID_00000032634483295271573260000017043125568643914428_);
}

.st275 {
  clip-path: url(#SVGID_00000041977306194554195530000016513241122777211062_);
  fill: #7FA096;
}

.st276 {
  clip-path: url(#SVGID_00000062184132368578841590000005156986100654875784_);
}

.st277 {
  clip-path: url(#SVGID_00000096022478571553918300000003267663207625202048_);
  fill: #95CCB9;
}

.st278 {
  clip-path: url(#SVGID_00000058553930091642100490000003146899370527221929_);
}

.st279 {
  clip-path: url(#SVGID_00000160879114248319913890000009581960760158930583_);
  fill: #82A79C;
}

.st280 {
  clip-path: url(#SVGID_00000155142474106895404270000008781066571319651244_);
}

.st281 {
  clip-path: url(#SVGID_00000000203896397694320500000018327389941275280801_);
  fill: #95CCB9;
}

.st282 {
  clip-path: url(#SVGID_00000128455135201506584950000016028549916592604600_);
}

.st283 {
  clip-path: url(#SVGID_00000083804069658356079400000007737969406677939358_);
  fill: #82A79C;
}

.st284 {
  clip-path: url(#SVGID_00000170996850021679737170000011601189661269597099_);
}

.st285 {
  clip-path: url(#SVGID_00000075873734698385093530000000573253288694307001_);
  fill: #7FA096;
}

.st286 {
  clip-path: url(#SVGID_00000096059136604100084360000015509521960502856839_);
}

.st287 {
  clip-path: url(#SVGID_00000039821352436276187400000003364819410613652916_);
  fill: #95CCB9;
}

.st288 {
  clip-path: url(#SVGID_00000050660317931111450120000008895065780003141543_);
}

.st289 {
  clip-path: url(#SVGID_00000034085953620710182210000016694187712348460177_);
  fill: #7FA096;
}

.st290 {
  clip-path: url(#SVGID_00000052819162028318352020000007104139555335390122_);
}

.st291 {
  clip-path: url(#SVGID_00000060007078042519363880000006360760872964532874_);
  fill: #82A79C;
}

.st292 {
  clip-path: url(#SVGID_00000013167325296901591020000005759105568124966584_);
}

.st293 {
  clip-path: url(#SVGID_00000079485084606369898540000004692730563692743084_);
  fill: #EBEBE7;
}

.st294 {
  clip-path: url(#SVGID_00000083075818338429974830000013290831417414674846_);
}

.st295 {
  clip-path: url(#SVGID_00000063593645315683118120000013340081737985937840_);
  fill: #999A98;
}

.st296 {
  clip-path: url(#SVGID_00000112632577445586924490000005714199014292108947_);
}

.st297 {
  clip-path: url(#SVGID_00000095309234686061444340000013678244383280758930_);
  fill: #999A98;
}

.st298 {
  clip-path: url(#SVGID_00000071559620910861545750000016822493379832393386_);
}

.st299 {
  clip-path: url(#SVGID_00000097464150365559511220000011022653983770760077_);
  fill: #6B59A6;
}

.st300 {
  clip-path: url(#SVGID_00000115489848214772788780000011788098191811611264_);
}

.st301 {
  clip-path: url(#SVGID_00000127022730440945880780000013198509502403930017_);
  fill: #6B59A6;
}

.st302 {
  clip-path: url(#SVGID_00000162336493356003496650000014151195608877670043_);
}

.st303 {
  clip-path: url(#SVGID_00000134934089403896150070000008565549008632147113_);
  fill: #548D7A;
}

.st304 {
  clip-path: url(#SVGID_00000007422148549992335280000013185120554836566913_);
}

.st305 {
  clip-path: url(#SVGID_00000047021138179251030990000002624017165591836830_);
  fill: #4D8271;
}

.st306 {
  clip-path: url(#SVGID_00000181774280815372404080000007417527690038720925_);
}

.st307 {
  clip-path: url(#SVGID_00000065784968253949405730000001853267810415985547_);
  fill: #4A7F6F;
}

.st308 {
  clip-path: url(#SVGID_00000134209296055661893620000010579299636545983162_);
}

.st309 {
  clip-path: url(#SVGID_00000008140308154448433590000003144514040015393924_);
  fill: #4D8271;
}

.st310 {
  clip-path: url(#SVGID_00000065040881427945848390000017855404658833429664_);
}

.st311 {
  clip-path: url(#SVGID_00000096766846884975965390000018310799020260649895_);
  fill: #699687;
}

.st312 {
  clip-path: url(#SVGID_00000039820781202975723550000000574614438196276115_);
}

.st313 {
  clip-path: url(#SVGID_00000055704159865275551820000008267195671588412051_);
  fill: #C9DAD1;
}

.st314 {
  clip-path: url(#SVGID_00000083053326376444141340000004568888441544736403_);
}

.st315 {
  clip-path: url(#SVGID_00000134235734405002827120000000178366192910923164_);
  fill: #C9DAD1;
}

.st316 {
  clip-path: url(#SVGID_00000013891345591856295200000001023619120855648137_);
}

.st317 {
  clip-path: url(#SVGID_00000183952971006455716070000008353477803468514751_);
  fill: #C9DAD1;
}

.st318 {
  clip-path: url(#SVGID_00000078750398263506350770000008641600449309282946_);
}

.st319 {
  clip-path: url(#SVGID_00000033350201914858345150000009692044435974621324_);
  fill: #165748;
}

.st320 {
  clip-path: url(#SVGID_00000015354494605385785830000014579621976554353080_);
}

.st321 {
  clip-path: url(#SVGID_00000013157710140542858360000006638753138014132923_);
  fill: #165748;
}

.st322 {
  clip-path: url(#SVGID_00000158015965145725892400000010671308132537387397_);
}

.st323 {
  clip-path: url(#SVGID_00000174559791933531696260000001820474438693107604_);
  fill: #165748;
}

.st324 {
  clip-path: url(#SVGID_00000008862188771431760420000001963617005134917260_);
}

.st325 {
  clip-path: url(#SVGID_00000170245795423785913910000007589189012630950790_);
  fill: #165748;
}

.st326 {
  clip-path: url(#SVGID_00000092451220215157830940000010269177627367696523_);
}

.st327 {
  clip-path: url(#SVGID_00000089555608506790449780000009446558144916269957_);
  fill: #A4B6AD;
}

.st328 {
  clip-path: url(#SVGID_00000126298708436713716210000008212467545618836918_);
}

.st329 {
  clip-path: url(#SVGID_00000127726196078203319390000002536368730964366232_);
  fill: #A2B3AB;
}

.st330 {
  clip-path: url(#SVGID_00000083063688472035689220000013751342993253118857_);
}

.st331 {
  clip-path: url(#SVGID_00000034062395995430715660000001089699377276091528_);
  fill: #91B1A5;
}

.st332 {
  clip-path: url(#SVGID_00000010990979722248227530000010277633762132992423_);
}

.st333 {
  clip-path: url(#SVGID_00000064318869437705786570000000697171157797222067_);
  fill: #8BA79D;
}

.st334 {
  clip-path: url(#SVGID_00000030467135015982526630000014774632306277104553_);
}

.st335 {
  clip-path: url(#SVGID_00000023987039935351257260000018356816441018551711_);
  fill: #91B1A5;
}

.st336 {
  clip-path: url(#SVGID_00000110430346544083493350000004021086508823502237_);
}

.st337 {
  clip-path: url(#SVGID_00000031170009185203211300000006064112103236085180_);
  fill: #8BA79D;
}

.st338 {
  clip-path: url(#SVGID_00000003804645583129435730000009327285939209216399_);
}

.st339 {
  clip-path: url(#SVGID_00000148637546637934316560000012541369529548323253_);
  fill: #6E9084;
}

.st340 {
  clip-path: url(#SVGID_00000170999362724806834570000014128540556927628190_);
}

.st341 {
  clip-path: url(#SVGID_00000080894009189161126120000005522145409697742720_);
  fill: #165748;
}

.st342 {
  clip-path: url(#SVGID_00000063605443300473011460000007244131546710881162_);
}

.st343 {
  clip-path: url(#SVGID_00000111171738322306988530000006190460362314982020_);
  fill: #165748;
}

.st344 {
  clip-path: url(#SVGID_00000152949124506216791870000004137889733039099293_);
}

.st345 {
  clip-path: url(#SVGID_00000086674035683315197500000002261242430673061299_);
  fill: #EBEAE6;
}

.st346 {
  clip-path: url(#SVGID_00000011017812311153346710000002309636127582862509_);
}

.st347 {
  clip-path: url(#SVGID_00000100358056630310398280000012756783301455867839_);
  fill: #DCDDD7;
}

.st348 {
  clip-path: url(#SVGID_00000008868248281604952730000008539835682541670042_);
}

.st349 {
  clip-path: url(#SVGID_00000180340532975965112250000009964186146080537275_);
  fill: #868B89;
}

.st350 {
  clip-path: url(#SVGID_00000163064532851290892050000003120947571858797443_);
}

.st351 {
  clip-path: url(#SVGID_00000074415858682265022450000011330794741055951529_);
  fill: #DCDDD7;
}

.st352 {
  clip-path: url(#SVGID_00000009579489303952674150000000772690585079135935_);
}

.st353 {
  clip-path: url(#SVGID_00000109727363362210310950000010593272527039639939_);
  fill: #999C9A;
}

.st354 {
  clip-path: url(#SVGID_00000061440263305845955110000011046574072000307346_);
}

.st355 {
  clip-path: url(#SVGID_00000015338353708928868780000016176179726872478348_);
  fill: #999C9A;
}

.st356 {
  clip-path: url(#SVGID_00000146460406266304728890000009881387680263864234_);
}

.st357 {
  clip-path: url(#SVGID_00000109023069224469692630000008679012711128561546_);
  fill: #98CAB7;
}

.st358 {
  clip-path: url(#SVGID_00000153701595369761771160000013136988126302463112_);
}

.st359 {
  clip-path: url(#SVGID_00000090265181874261312730000016108071097235091645_);
  fill: #6E9A8A;
}

.st360 {
  clip-path: url(#SVGID_00000052089871837325132290000014393946880109443728_);
}

.st361 {
  clip-path: url(#SVGID_00000178898051332282496990000002245574995440976285_);
  fill: #6B59A6;
}

.st362 {
  clip-path: url(#SVGID_00000041294511441226198200000000376037363158642844_);
}

.st363 {
  clip-path: url(#SVGID_00000065788344364109515650000005173666183230890932_);
  fill: #699085;
}

.st364 {
  clip-path: url(#SVGID_00000175312302303546114390000014636753237865243541_);
}

.st365 {
  clip-path: url(#SVGID_00000097474173227032041380000007988001224457006978_);
  fill: #98CAB7;
}

.st366 {
  clip-path: url(#SVGID_00000037682035058006408190000017103208651355036330_);
}

.st367 {
  clip-path: url(#SVGID_00000015353555766487263550000008202275162124682943_);
  fill: #679384;
}

.st368 {
  clip-path: url(#SVGID_00000121256018804310278100000000953411359455442826_);
}

.st369 {
  clip-path: url(#SVGID_00000059281035051428421260000005159190923540981920_);
  fill: #6B59A6;
}

.st370 {
  clip-path: url(#SVGID_00000129206362293430000530000007318702074193521815_);
}

.st371 {
  clip-path: url(#SVGID_00000045587745535494809710000008954053519225376643_);
  fill: #6B59A6;
}

.st372 {
  clip-path: url(#SVGID_00000008119528407179520890000005244894332777188493_);
}

.st373 {
  clip-path: url(#SVGID_00000172432924105514900610000011747537389724094106_);
  fill: #6B59A6;
}

.st374 {
  clip-path: url(#SVGID_00000078755028922904213730000014182110993034420398_);
}

.st375 {
  clip-path: url(#SVGID_00000168099654168768674670000010275974850001086881_);
  fill: #6B59A6;
}

.st376 {
  clip-path: url(#SVGID_00000148631070116383233030000009930193336887496089_);
}

.st377 {
  clip-path: url(#SVGID_00000147218831882105489680000006920760708432710076_);
  fill: #547E6F;
}

.st378 {
  clip-path: url(#SVGID_00000080891205298422584770000003670148953913377944_);
}

.st379 {
  clip-path: url(#SVGID_00000057145518132942011820000016102361119248273551_);
  fill: #C7D9D0;
}

.st380 {
  clip-path: url(#SVGID_00000118394842567375132940000011633457896701876635_);
}

.st381 {
  clip-path: url(#SVGID_00000092441908093094254020000013684129314464694152_);
  fill: #C7D9D0;
}

.st382 {
  clip-path: url(#SVGID_00000113314007778005767030000006110273519100349069_);
}

.st383 {
  clip-path: url(#SVGID_00000088818922050284858800000011980419126635127486_);
  fill: #C7D9D0;
}

.st384 {
  fill: #E0E1DB;
}

.st385 {
  clip-path: url(#SVGID_00000080182624741194330210000006416143884939945391_);
}

.st386 {
  clip-path: url(#SVGID_00000058556803962263691300000008633186599111750035_);
  enable-background: new;
}

.st387 {
  clip-path: url(#SVGID_00000039819677306729874540000001243593723559541399_);
}

.st388 {
  clip-path: url(#SVGID_00000174573194201157308050000013600371266518373019_);
}

.st389 {
  opacity: 0;
  clip-path: url(#SVGID_00000093148469977857613330000012270185307695407492_);
}

.st390 {
  clip-path: url(#SVGID_00000135668733196569955550000009563764524218640284_);
}

.st391 {
  clip-path: url(#SVGID_00000083778894604915000280000003672415709672320640_);
}

.st392 {
  clip-path: url(#SVGID_00000175298667460073024260000017112305068053853359_);
  fill: #6B59A6;
}

.st393 {
  clip-path: url(#SVGID_00000119108917169198006550000016226853480571347596_);
}

.st394 {
  clip-path: url(#SVGID_00000178896264622794567650000000999988883775914422_);
  enable-background: new;
}

.st395 {
  clip-path: url(#SVGID_00000074416518861710744610000018166175426952874925_);
}

.st396 {
  clip-path: url(#SVGID_00000145766524395062905740000007076502829039568292_);
}

.st397 {
  opacity: 0;
  clip-path: url(#SVGID_00000093162825378844467900000015872714272136503214_);
}

.st398 {
  clip-path: url(#SVGID_00000178202009350242126830000008470590175378705339_);
}

.st399 {
  clip-path: url(#SVGID_00000170251370507627313810000005127579708988169360_);
}

.st400 {
  clip-path: url(#SVGID_00000182521106246911218190000016770804822389530017_);
  fill: #3E3F6F;
}

.st401 {
  opacity: 0.1;
}

.st402 {
  fill: #1F715C;
}

.st403 {
  fill: #A5B5BB;
}

.st404 {
  fill: #49BD99;
}

.st405 {
  fill: #2A2C2F;
}

.st406 {
  fill: #FFFFFF;
}

.st407 {
  fill: #434648;
}

.st408 {
  fill: #231F20;
}

.st409 {
  fill: #14604E;
}

.st410 {
  opacity: 0.8;
  fill: #2A2C2F;
}

.st411 {
  fill: #79AA9D;
}

.st412 {
  fill: url(#SVGID_00000085228200339791829190000015152531580934748567_);
}

.st413 {
  fill: #AFB4C4;
}

.st414 {
  fill: url(#SVGID_00000134220852716630308290000000054477536481481149_);
}

.st415 {
  fill: #EEF0F5;
}

.st416 {
  fill: #C8CEDB;
}

.st417 {
  enable-background: new;
}

.st418 {
  clip-path: url(#SVGID_00000080917034246790363540000001592061641630174627_);
  enable-background: new;
}

.st419 {
  fill: #0D3F33;
}

.st420 {
  clip-path: url(#SVGID_00000013179014666278752130000018356736058521995933_);
  enable-background: new;
}

.st421 {
  fill: #0A3229;
}

.st422 {
  fill: #115444;
}

.st423 {
  fill: #0A3027;
}

.st424 {
  clip-path: url(#SVGID_00000156558331297440968940000011111239775956230332_);
  enable-background: new;
}

.st425 {
  fill: #0C3A2F;
}

.st426 {
  fill: #0C3C30;
}

.st427 {
  fill: #0D3D32;
}

.st428 {
  fill: #0C382D;
}

.st429 {
  fill: #0B362C;
}

.st430 {
  fill: #0B342A;
}

.st431 {
  opacity: 0.7;
}

.st432 {
  clip-path: url(#SVGID_00000141450232353202782150000005752876612021038226_);
  enable-background: new;
}

.st433 {
  fill: #608E80;
}

.st434 {
  clip-path: url(#SVGID_00000109014356698897402900000013059208800161164974_);
  enable-background: new;
}

.st435 {
  fill: #588174;
}

.st436 {
  fill: #5B8578;
}

.st437 {
  fill: #5D8A7C;
}

.st438 {
  clip-path: url(#SVGID_00000144308741712790296660000010561495836667537343_);
  enable-background: new;
}

.st439 {
  fill: #557D71;
}

.st440 {
  fill: #52786D;
}

.st441 {
  fill: #4F7469;
}

.st442 {
  fill: #4C7065;
}

.st443 {
  clip-path: url(#SVGID_00000123399528930242905240000017865420616636517268_);
  enable-background: new;
}

.st444 {
  clip-path: url(#SVGID_00000152956505067194165790000006265628270973432503_);
  enable-background: new;
}

.st445 {
  clip-path: url(#SVGID_00000051351211714857185280000009968147837668636044_);
  enable-background: new;
}

.st446 {
  clip-path: url(#SVGID_00000131327225306738840420000015161850957273198981_);
  enable-background: new;
}

.st447 {
  clip-path: url(#SVGID_00000058575124262017187670000014362376758868219527_);
  enable-background: new;
}

.st448 {
  clip-path: url(#SVGID_00000066496361449300883940000013880677988585102997_);
  enable-background: new;
}

.st449 {
  clip-path: url(#SVGID_00000126305528947971043680000017344252236882007198_);
  enable-background: new;
}

.st450 {
  fill: #7FBCA9;
}

.st451 {
  clip-path: url(#SVGID_00000039103324140975261510000012899139938679790209_);
  enable-background: new;
}

.st452 {
  fill: #496C61;
}

.st453 {
  fill: #255F4D;
}

.st454 {
  clip-path: url(#SVGID_00000087378162691553125960000013535004111676499627_);
  enable-background: new;
}

.st455 {
  fill: #307D65;
}

.st456 {
  fill: #2F7962;
}

.st457 {
  fill: #2D755F;
}

.st458 {
  clip-path: url(#SVGID_00000144330958173169621060000011805349469301857709_);
  enable-background: new;
}

.st459 {
  fill: #266250;
}

.st460 {
  fill: #276653;
}

.st461 {
  fill: #296A56;
}

.st462 {
  fill: #2A6E59;
}

.st463 {
  fill: #2C715C;
}

.st464 {
  fill: #40A586;
}

.st465 {
  clip-path: url(#SVGID_00000044898807788473205270000002091590878531261088_);
  enable-background: new;
}

.st466 {
  clip-path: url(#SVGID_00000114770566388299601360000006819811615894885563_);
  enable-background: new;
}

.st467 {
  clip-path: url(#SVGID_00000013905453634280509160000015003220134446486422_);
  enable-background: new;
}

.st468 {
  clip-path: url(#SVGID_00000077284925934811731520000002343574370298954168_);
  enable-background: new;
}

.st469 {
  clip-path: url(#SVGID_00000121273549051814518430000010347060636575260090_);
  enable-background: new;
}

.st470 {
  clip-path: url(#SVGID_00000150797175620631806190000003932565577338731441_);
  enable-background: new;
}

.st471 {
  clip-path: url(#SVGID_00000173852458338756698880000005322662101097012622_);
  enable-background: new;
}

.st472 {
  clip-path: url(#SVGID_00000162321069827045780770000010745722936153619386_);
  enable-background: new;
}

.st473 {
  clip-path: url(#SVGID_00000021797771211604130720000006878309362199089294_);
  enable-background: new;
}

.st474 {
  clip-path: url(#SVGID_00000098921828978621580620000007502534165878178444_);
  enable-background: new;
}

.st475 {
  fill: #33836A;
}

.st476 {
  fill: url(#SVGID_00000009582770971421603760000012280794155280598193_);
}

.st477 {
  fill: url(#SVGID_00000102518936807935647770000003464881722794474167_);
}

.st478 {
  fill: url(#SVGID_00000062876330511348881770000006926876562316475808_);
}

.st479 {
  fill: url(#SVGID_00000064350337876732827610000013146265856524491178_);
}

.st480 {
  fill: url(#SVGID_00000070077858822887668290000007437886368645121670_);
}

.st481 {
  fill: url(#SVGID_00000039842405819273429980000010639969937329583529_);
}

.st482 {
  fill: url(#SVGID_00000025428049797574449330000003141849650557476755_);
}

.st483 {
  fill: url(#SVGID_00000021837610798429742330000015113359213056735657_);
}

.st484 {
  fill: url(#SVGID_00000070078502422406846060000012483047981489586817_);
}

.st485 {
  fill: url(#SVGID_00000014617148454675980570000005628183131527006885_);
}

.st486 {
  fill: url(#SVGID_00000152974223298757143590000000172725247766123709_);
}

.st487 {
  fill: url(#SVGID_00000034773336819968885630000001632181521240975529_);
}

.st488 {
  fill: url(#SVGID_00000093166535901103610490000005309597430294229414_);
}

.st489 {
  fill: url(#SVGID_00000022545065287285248430000004513417996498051721_);
}

.st490 {
  fill: url(#SVGID_00000023994462788088704660000010455664910716525996_);
}

.st491 {
  fill: url(#SVGID_00000106121680029981895310000006200606633796074164_);
}

.st492 {
  fill: url(#SVGID_00000113313469786191360380000004960633776377970105_);
}

.st493 {
  fill: url(#SVGID_00000074402259805418513720000014903630676354556085_);
}

.st494 {
  fill: url(#SVGID_00000062170809325967040240000008425980203406837636_);
}

.st495 {
  fill: url(#SVGID_00000108291102912680750590000000611307896381662619_);
}

.st496 {
  fill: url(#SVGID_00000165211090500323987130000011445885732994804379_);
}

.st497 {
  fill: url(#SVGID_00000119816930797398047860000001004303731698131119_);
}

.st498 {
  fill: url(#SVGID_00000102533674293621999570000016145448575636224185_);
}

.st499 {
  fill: url(#SVGID_00000049188658425782309170000002266936207779083919_);
}

.st500 {
  fill: url(#SVGID_00000163775974403345420870000009304523691911784584_);
}

.st501 {
  fill: url(#SVGID_00000076577016623375413180000007231647450913516477_);
}

.st502 {
  fill: url(#SVGID_00000163055926820487255740000008843472620397023619_);
}

.st503 {
  fill: url(#SVGID_00000178927750100772481980000008526855254886103969_);
}

.st504 {
  fill: url(#SVGID_00000125571190358385578120000012399211883853488308_);
}

.st505 {
  fill: url(#SVGID_00000179605056851182140710000001182076397825393301_);
}

.st506 {
  fill: url(#SVGID_00000015334221239714052040000007517920830975785404_);
}

.st507 {
  fill: url(#SVGID_00000039117512028957463510000004168272781328801686_);
}

.st508 {
  fill: url(#SVGID_00000101805363636729928130000006845224646612746911_);
}

.st509 {
  fill: url(#SVGID_00000000923178907017060900000006213240357343608251_);
}

.st510 {
  fill: url(#SVGID_00000119822368434487833010000004933339565858217347_);
}

.st511 {
  fill: url(#SVGID_00000021813984484987493560000005015186297986253993_);
}

.st512 {
  fill: url(#SVGID_00000035531583150844384870000014655388692947048340_);
}

.st513 {
  fill: url(#SVGID_00000147942703412450113820000010579240251525823646_);
}

.st514 {
  fill: url(#SVGID_00000147925505693294124500000011171007041184657813_);
}

.st515 {
  fill: url(#SVGID_00000053524118432312230210000013146097017656552124_);
}

.st516 {
  fill: url(#SVGID_00000011731948814953639840000001145752962164472744_);
}

.st517 {
  fill: url(#SVGID_00000121969081954115558630000006528014766469878690_);
}

.st518 {
  fill: url(#SVGID_00000064327785249354452070000005978014160914079400_);
}

.st519 {
  fill: url(#SVGID_00000124859194899089439220000009050636093960220042_);
}

.st520 {
  fill: url(#SVGID_00000003826558636415130190000002108538427611954561_);
}

.st521 {
  fill: url(#SVGID_00000024687067099049538720000004455503217241729158_);
}

.st522 {
  fill: url(#SVGID_00000182524275810942200010000015082943673958254012_);
}

.st523 {
  fill: url(#SVGID_00000037684061535097923100000012040533723910135483_);
}

.st524 {
  fill: url(#SVGID_00000106853595102303961510000008360106526377282473_);
}

.st525 {
  fill: url(#SVGID_00000010287117399403761320000013469593285517258888_);
}

.st526 {
  fill: url(#SVGID_00000119087208407009768590000007657123903617718716_);
}

.st527 {
  fill: url(#SVGID_00000076606052669966093050000018219356402448955018_);
}

.st528 {
  fill: url(#SVGID_00000068670229163332041320000012746599554719800504_);
}

.st529 {
  fill: url(#SVGID_00000049916298385953836980000002324532487359518884_);
}

.st530 {
  fill: url(#SVGID_00000043453910979034311930000006277598946911032731_);
}

.st531 {
  fill: url(#SVGID_00000075853270272878170360000016762486623535301528_);
}

.st532 {
  fill: url(#SVGID_00000181073246126993626800000002707889917360401850_);
}

.st533 {
  fill: url(#SVGID_00000072988298649043420180000013631337556512471680_);
}

.st534 {
  fill: url(#SVGID_00000045601002943097044650000010714211856733003422_);
}

.st535 {
  fill: url(#SVGID_00000024718008717885780760000014124172680917279125_);
}

.st536 {
  fill: url(#SVGID_00000098222151033997249750000012696421927349690039_);
}

.st537 {
  fill: url(#SVGID_00000062914610719814661720000016107677739959638145_);
}

.st538 {
  fill: url(#SVGID_00000029019820195101147320000009219767165273373341_);
}

.st539 {
  fill: url(#SVGID_00000158740097265292134840000013173454614410782098_);
}

.st540 {
  fill: url(#SVGID_00000063628783627460994990000001447504652171768997_);
}

.st541 {
  fill: url(#SVGID_00000036220515569596468440000011293966407037403046_);
}

.st542 {
  fill: url(#SVGID_00000143615717707761200710000004965942548471373229_);
}

.st543 {
  fill: url(#SVGID_00000029015922204046926520000001822840037082780351_);
}

.st544 {
  fill: url(#SVGID_00000128443967337549938620000005975091345246505353_);
}

.st545 {
  fill: url(#SVGID_00000121258939286009951920000000377997328036589480_);
}

.st546 {
  fill: url(#SVGID_00000084516888373383147260000015318824524212751516_);
}

.st547 {
  fill: url(#SVGID_00000129926561423807588130000008088060502128277166_);
}

.st548 {
  fill: url(#SVGID_00000074411962217945093990000001593695876944927622_);
}

.st549 {
  fill: url(#SVGID_00000087381742533102296040000017228662816277476769_);
}

.st550 {
  fill: url(#SVGID_00000121244497457455791940000011290267977827086269_);
}

.st551 {
  fill: url(#SVGID_00000018201083203219743750000007962761244147505338_);
}

.st552 {
  fill: url(#SVGID_00000062160047392225195060000006516117945678747063_);
}

.st553 {
  fill: url(#SVGID_00000113328460846110987880000018065076201797753765_);
}

.st554 {
  fill: url(#SVGID_00000000936895664534534010000011434938628090813828_);
}

.st555 {
  fill: url(#SVGID_00000145020573197891298290000008492812345006635924_);
}

.st556 {
  fill: url(#SVGID_00000112599034836282572420000004876592268984021939_);
}

.st557 {
  fill: url(#SVGID_00000160176796372177542630000010318878553038516388_);
}

.st558 {
  fill: url(#SVGID_00000057846987389160290730000002807579710236528566_);
}

.st559 {
  opacity: 0.2;
}

.st560 {
  opacity: 9.090909e-02;
}

.st561 {
  opacity: 0.1818;
}

.st562 {
  opacity: 0.2727;
}

.st563 {
  opacity: 0.3636;
}

.st564 {
  opacity: 0.4545;
}

.st565 {
  opacity: 0.5455;
}

.st566 {
  opacity: 0.6364;
}

.st567 {
  opacity: 0.7273;
}

.st568 {
  opacity: 0.8182;
}

.st569 {
  opacity: 0.9091;
}

.st570 {
  fill: url(#SVGID_00000126314807164454821720000005442850165658315662_);
}

.st571 {
  fill: url(#SVGID_00000057867231616823078180000009874287244383747216_);
}

.st572 {
  fill: url(#SVGID_00000094616938302478850940000005033358026047600539_);
}

.st573 {
  fill: url(#SVGID_00000044871145193249881400000007887555201291868046_);
}

.st574 {
  fill: url(#SVGID_00000103966446045902760910000003833764993229377432_);
}

.st575 {
  fill: #619788;
}

.st576 {
  fill: url(#SVGID_00000090257765076032056360000009949531692984276927_);
}

.st577 {
  fill: url(#SVGID_00000014594602399134081080000016789494812773511042_);
}

.st578 {
  fill: url(#SVGID_00000023250310284999870510000015490369547705731762_);
}

.st579 {
  fill: url(#SVGID_00000038405019887927860620000016899299165581488526_);
}

.st580 {
  fill: url(#SVGID_00000014608231077101478360000002994702442028580286_);
}

.st581 {
  fill: url(#SVGID_00000067202080388097198650000016496418988843652488_);
}

.st582 {
  fill: url(#SVGID_00000146493688284375301840000001506772916738119853_);
}

.st583 {
  fill: url(#SVGID_00000004522479450315647340000018399882087134326180_);
}

.st584 {
  fill: url(#SVGID_00000140002343576040795880000010212759803885064353_);
}

.st585 {
  fill: url(#SVGID_00000034772401732729865610000002752636349117746080_);
}

.st586 {
  opacity: 0.6;
  fill: #6B59A6;
}

.st587 {
  fill: url(#SVGID_00000111189990854303243060000007191862756813325203_);
}

.st588 {
  opacity: 0;
  fill: url(#SVGID_00000000909273226963588120000004639563371019440050_);
}

.st589 {
  opacity: 9.090909e-02;
  fill: url(#SVGID_00000050651940811634774410000008573300980808391584_);
}

.st590 {
  opacity: 0.1818;
  fill: url(#SVGID_00000177454989023060934050000015261373173297420713_);
}

.st591 {
  opacity: 0.2727;
  fill: url(#SVGID_00000131335100028315683770000016493563535482626982_);
}

.st592 {
  opacity: 0.3636;
  fill: url(#SVGID_00000062903755399785869510000014805583644101557386_);
}

.st593 {
  opacity: 0.4545;
  fill: url(#SVGID_00000141418949417148449070000012316422922702617750_);
}

.st594 {
  opacity: 0.5455;
  fill: url(#SVGID_00000158715668687145581820000005667227683020832657_);
}

.st595 {
  opacity: 0.6364;
  fill: url(#SVGID_00000114036881379011322790000004831225254105222845_);
}

.st596 {
  opacity: 0.7273;
  fill: url(#SVGID_00000067917185324894577740000003297712086590487720_);
}

.st597 {
  opacity: 0.8182;
  fill: url(#SVGID_00000093870853678131103990000017568981461285957526_);
}

.st598 {
  opacity: 0.9091;
  fill: url(#SVGID_00000121247482687824851980000004056796012345879680_);
}

.st599 {
  fill: url(#SVGID_00000008868913176389855110000017911725500293137850_);
}

.st600 {
  opacity: 0.7;
  fill: url(#SVGID_00000116222146633817647940000015578076132136707985_);
}

.st601 {
  opacity: 0.1;
  fill: url(#SVGID_00000059301283250979885370000011285646171320626081_);
}

.st602 {
  fill: url(#SVGID_00000031198676557654464340000013576979908927356808_);
}

.st603 {
  opacity: 0.5;
  fill: #2A2C2F;
}

.st604 {
  fill: url(#SVGID_00000156557033609353524570000009300313185158964626_);
}

.st605 {
  fill: #45494B;
}

.st606 {
  fill: #363B3D;
}

.st607 {
  fill: #5A5F60;
}

.st608 {
  fill: #35896F;
}

.st609 {
  clip-path: url(#SVGID_00000013909263050786867410000010066622855821196172_);
  enable-background: new;
}

.st610 {
  fill: #328168;
}

.st611 {
  fill: #33846B;
}

.st612 {
  fill: #35886E;
}

.st613 {
  fill: #368C71;
}

.st614 {
  fill: #379074;
}

.st615 {
  fill: #399377;
}

.st616 {
  fill: #3A977A;
}

.st617 {
  fill: #3C9B7D;
}

.st618 {
  fill: #3D9F81;
}

.st619 {
  fill: #3FA384;
}

.st620 {
  fill: #40A687;
}

.st621 {
  fill: #42AA8A;
}

.st622 {
  fill: #43AE8D;
}

.st623 {
  fill: #45B290;
}

.st624 {
  fill: #46B593;
}

.st625 {
  fill: #48B996;
}

.st626 {
  clip-path: url(#SVGID_00000070814929628398583550000003766237177520800919_);
  enable-background: new;
}

.st627 {
  clip-path: url(#SVGID_00000073695877999222449880000009351306684407580291_);
  enable-background: new;
}

.st628 {
  clip-path: url(#SVGID_00000098194347287745875670000000811867330500293302_);
  enable-background: new;
}

.st629 {
  clip-path: url(#SVGID_00000051382202615424286240000004363641861418244018_);
  enable-background: new;
}

.st630 {
  fill: #3EA081;
}

.st631 {
  clip-path: url(#SVGID_00000021804830078586410430000001906367307520708789_);
  enable-background: new;
}

.st632 {
  clip-path: url(#SVGID_00000056402500830917894170000015068807549452143289_);
  enable-background: new;
}

.st633 {
  clip-path: url(#SVGID_00000109742252699303090050000002391501236523649450_);
  enable-background: new;
}

.st634 {
  clip-path: url(#SVGID_00000181769371613705913060000002485797631658655166_);
  enable-background: new;
}

.st635 {
  clip-path: url(#SVGID_00000065765174226948334080000001820964642888331142_);
  enable-background: new;
}

.st636 {
  clip-path: url(#SVGID_00000163751269229554296300000004879214438649534617_);
  enable-background: new;
}

.st637 {
  clip-path: url(#SVGID_00000142864055745838853690000007488702452928887222_);
  enable-background: new;
}

.st638 {
  clip-path: url(#SVGID_00000024003773315756416520000008344036935017339284_);
  enable-background: new;
}

.st639 {
  fill: #3E9F81;
}

.st640 {
  fill: #2B715B;
}

.st641 {
  fill: #3D9E80;
}

.st642 {
  fill: #44B08E;
}

.st643 {
  clip-path: url(#SVGID_00000169556615265080805000000000907871170406385810_);
  enable-background: new;
}

.st644 {
  fill: #858585;
}

.st645 {
  fill: #8A8A8A;
}

.st646 {
  fill: #8F8F8F;
}

.st647 {
  fill: #949494;
}

.st648 {
  fill: #999999;
}

.st649 {
  fill: #9E9E9E;
}

.st650 {
  fill: #A3A3A3;
}

.st651 {
  fill: #A8A8A8;
}

.st652 {
  fill: #ADADAD;
}

.st653 {
  fill: #B3B3B3;
}

.st654 {
  fill: #B8B8B8;
}

.st655 {
  fill: #BDBDBD;
}

.st656 {
  fill: #C2C2C2;
}

.st657 {
  fill: #C7C7C7;
}

.st658 {
  fill: #CCCCCC;
}

.st659 {
  fill: #D1D1D1;
}

.st660 {
  fill: #D6D6D6;
}

.st661 {
  fill: #DBDBDB;
}

.st662 {
  fill: #E0E0E0;
}

.st663 {
  fill: #E6E6E6;
}

.st664 {
  fill: #EBEBEB;
}

.st665 {
  fill: #F0F0F0;
}

.st666 {
  fill: #F5F5F5;
}

.st667 {
  fill: #FAFAFA;
}

.st668 {
  clip-path: url(#SVGID_00000120542894555637230280000012092514112215976609_);
  enable-background: new;
}

.st669 {
  clip-path: url(#SVGID_00000025444945980955894600000010578869308697498764_);
  enable-background: new;
}

.st670 {
  clip-path: url(#SVGID_00000143602126820008184670000008255080102495715488_);
  enable-background: new;
}

.st671 {
  fill: #989898;
}

.st672 {
  clip-path: url(#SVGID_00000162334898960985897530000012682468677343542423_);
  enable-background: new;
}

.st673 {
  clip-path: url(#SVGID_00000136387207732678436470000018122409679155745933_);
  enable-background: new;
}

.st674 {
  fill: #D8D8D8;
}

.st675 {
  clip-path: url(#SVGID_00000165937611232778387240000002114540654640667581_);
  enable-background: new;
}

.st676 {
  clip-path: url(#SVGID_00000043442271741876369020000010365238052816498577_);
  enable-background: new;
}

.st677 {
  clip-path: url(#SVGID_00000156565189752259245710000003634238974076378529_);
  enable-background: new;
}

.st678 {
  clip-path: url(#SVGID_00000127023760209465427590000000551235912387396247_);
  enable-background: new;
}

.st679 {
  clip-path: url(#SVGID_00000093881240211427491290000007803614792756832130_);
  enable-background: new;
}

.st680 {
  clip-path: url(#SVGID_00000178896196533974779050000001026546491603931043_);
  enable-background: new;
}

.st681 {
  clip-path: url(#SVGID_00000180350455864155855160000006453890044524790197_);
  enable-background: new;
}

.st682 {
  clip-path: url(#SVGID_00000083091325024207780330000005490506867182541478_);
  enable-background: new;
}

.st683 {
  clip-path: url(#SVGID_00000066504840609782429930000003231184395783948985_);
  enable-background: new;
}

.st684 {
  clip-path: url(#SVGID_00000075128795084009558980000008894896095648536476_);
  enable-background: new;
}

.st685 {
  clip-path: url(#SVGID_00000016781351869758369880000004714655874180163460_);
  enable-background: new;
}

.st686 {
  clip-path: url(#SVGID_00000117644104054580871050000004862975197089449660_);
  enable-background: new;
}

.st687 {
  clip-path: url(#SVGID_00000005949713965464440220000001753992997880371382_);
  enable-background: new;
}

.st688 {
  clip-path: url(#SVGID_00000088098465888829778460000010369831129465212832_);
  enable-background: new;
}

.st689 {
  clip-path: url(#SVGID_00000091712029177018817500000014917124989790386340_);
  enable-background: new;
}

.st690 {
  clip-path: url(#SVGID_00000085223206679311789060000007271910240064789181_);
  enable-background: new;
}

.st691 {
  clip-path: url(#SVGID_00000088094879722804964780000002817105729705502357_);
  enable-background: new;
}

.st692 {
  clip-path: url(#SVGID_00000158018928160486579120000003232789398889551499_);
  enable-background: new;
}

.st693 {
  fill: #685AA1;
}
</style>